import { setLoginUser, setLoginFlag } from "../login/loginAction";
import {
  api,
  generateCancelTokenSource,
  isCancelAxios,
} from "../../../api/api";
import { history } from "../../../app/AppRouter";
import { toastr } from "react-redux-toastr";
import {
  setGymData,
  setGymAttribute,
  setExpiringTodayData,
  setGymFeatures,
  setMemberAtRisk,
  setStats,
  setFeatures,
  setGymCategories,
} from "../gym/gymAction";
import moment from "moment";
import { buildMemberCreatePayload } from "../../../components/member/createPayload";
import {
  isVoiceSessionActive,
  skipVoiceCreate,
} from "../../../components/voiceAdd/voiceDraftGuard";
import {
  setNotifications,
  setUnreadNotificationCount,
  setPageLimit,
  setPushNotificationLogs,
  setPushNotificationLogsTotalCount,
  setPushNotificationLogsByGroupId,
  setPushNotificationLogsTotalCountByGroupId,
} from "../notification/notificationAction";
import {
  subscribeToMember,
  getNotifications,
} from "../../../services/socketInstance";

import {
  setTrainerAttribute,
  setTrainersData,
  setTrainerData,
  setTrainerCount,
  setAllTrainersData,
  setTrainerDashboardSchedule,
  setTrainerCalendarSchedule,
} from "../trainer/trainerAction";
import {
  setMembersData,
  setMemberData,
  setMemberCount,
  setMembersCheckinData,
  setAllMembersData,
  setGiveBackMoney,
  setNotes,
  sePurchasedProducts,
  setPurchasedProducts,
  setOverLapBookings,
  setMemberAssessments,
  setMemberAssessmentsCount,
  setMemberAssessmentsQuery,
  setMemberTreatments,
  setMemberTreatmentsCount,
} from "../members/memberAction";
import {
  setPackage,
  setPackagesData,
  setPackageCount,
  toggleDeactivateModalOpen,
  toggleActivateModalOpen,
  setPackageData,
  toggleSetPackageToBookAllClassesModalOpen,
  setAppointmentTypes,
  setActiveMemberSubscriptionsForDudction,
} from "../package/packageAction";
import {
  setClassesData,
  setClassCount,
  setClassData,
  setClassMembers,
  setClassesForWeek,
  setMemberSupportedPackagesForClass,
  toggleAddToBookingListModal,
  toggleSettlePaymentModal,
  toggleAddingSaleFromClassInfo,
  toggleCancelBookingModal,
  setAppointments,
  setSingleAppointment,
  toggleBookAppointmentModal,
  setAppointmentsBookings,
  setAppointmentsForWeek,
  setAllWeeklySchedule,
  toggleClassEditModal,
  toggleClassCancelModal,
  toggleDeductFromPackageModal,
} from "../class/classAction";
import {
  setSubscribedUsersData,
  setSubscribedUsersCount,
} from "../subscribedUsers/subscribedUsersAction";
import { setStaffData, setStaffCount } from "../staff/staffAction";

import { setWodsData, setWodData, setWodCount, setMemberWod } from "../wod/wodAction";
import { setMessageData } from "../messageAction";
import { setPlanData } from "../subscriptionPlan/subscriptionPlanAction";
import {
  addUserModal,
  addTrainerModal,
  addPrivateModal,
  addPackageModal,
  addSaleModal,
  addStaffModal,
  addAppointmentModal,
  addServiceModal,
  setRetailModal,
  setCourtModal,
  addWorkshopModal,
  addFollowupProgramModal,
} from "../sidebar/sidebarAction";
import {
  addWodModal,
  addGateModal,
  setAlertModal,
} from "../sidebar/sidebarAction";
import {
  setTrainerDashboardCardData,
  setTrainerLiveClassCardData,
} from "../trainerDashboard/trainerDashboardAction";
import {
  setGymDashboardCardData,
  setGymLiveClassCardData,
  setBookings,
  setSales,
  setExpansionCount,
  setExpansionSummary,
  setDashboardWeeklySchedule,
  setDashboardCharts,
} from "../gymDashboard/gymDashboardAction";
import {
  setaccountingDetailsData,
  setAccountingDetailsLoading,
  setAllReportsData,
  setFinancialParties,
  setFinancialPartiesCount,
  setReportsCount,
  setReportsData,
  setReportsSummary,
  setSalesDetailsCount,
  setSalesDetailsData,
  setSalesTotalData,
  setShowProductFilter,
} from "../reports/reportsAction";
import {
  setInvoiceData,
  setInvoiceCount,
  setInvoiceSummary,
} from "../invoice/invoiceAction";
import {
  setPermissons,
  setStaffGurationFilter,
  setSubAdminPermissions,
  setSubAdminType,
} from "../permissons/permissons";
import {
  resetCheckinsData,
  seTransferedToMember,
  setBookingListLoading,
  // setBookingMemberships,
  setCheckinsData,
  setExistingMember,
  setFreezeAllModalOpen,
  setFreezeMembershipOpen,
  setGymSubscriptionLoading,
  setMemberBookingList,
  setMemberBookingListCount,
  setMemberBookingsStatus,
  setMemberCheckInBookings,
  setMemberFinancialDetails,
  setMemberFreezeHistory,
  setMemberFreezeHistoryCount,
  setMemberFreezeHistorySaleId,
  setMemberGymPkgVisit,
  setMemberGymPkgVisitCount,
  setMemberInfo,
  setMemberInfoCount,
  setMemberInfoData,
  setMemberMemberSubscriptionsCount,
  setMemberMemberSubscriptionsList,
  setMemberPaidJoiningFees,
  setPushNotificationModal,
  setPushNotificationResult,
  setReturnProductOpen,
  setReturnVoidMembershipOpen,
  setSharedWithSubscriptions,
  setShowDeletedMemberModal,
  setShowExistingMemberModal,
  setShowMemberFreezeHistory,
  setVoidInfo,
  setVoidMembershipOpen,
  setVoidSummaryOpen,
  setmemberDocuments,
} from "../member/memberAction";
import { setCommonLoading, setLoading, setMemberLoading } from "../common/common-actions";
import classEditModal from "../../../components/classInfoModal/classEditModal";
import {
  setAvailableProducts,
  setProduct,
  setProductEdit,
  setProductExpiryDates,
  setProductExpiryDatesCount,
  setProductHistory,
  setProductHistoryCount,
  setProductHitoryModal,
  setProductLoading,
  setProducts,
  setProductsCount,
  setSuppliers,
  setTransferefProductsHistory,
} from "../product/productAction";
import { setMemberGymByMembershipCardId } from "../membershipCard/membershipCardAction";
import {
  setPaymentGateways,
  setPaymentGatewaysFields,
  setPaymentGatewayFieldSValue,
  setSaveGatewayValueFields,
  setPaymentGatewaysUsed,
} from "../paymentGateways/paymentGatewaysAction";
import { SET_PAYMENT_GATEWAY_FIELDS_ERROR } from "../../actions/types/types";

// import { addCalculationsToReports } from "../../../views/pages/gymPortion/reports/addCalculations";
import { setGateData, setGateCount, setGatesData, setPermanentAccessData, setPermanentAccessCount, setPermanentAccessLoading } from "../gate/gateAction";
import { downloadFailedRecordsExcel } from "../../../helper/helpers";
import { setPayRatesType, setPayRatesData, setPayRate, setPayRatesByStaff, setPayrollOverview, setPayrollDetails } from "../payRoll/payRollAction";
import { result } from "lodash";
import {
  getDataAgain,
  setBookingForUpdatedSlots,
  setCoachingSummary,
  setCourtCount,
  setCourtData,
  setCourtDurations,
  setCourtsData,
  setCourtsSlotsBlockedForBookingPageView,
  setCourtBlockedSlotsForBookingPageView,
  setCourtsSlotsForBookingPageView,
  setCourtsSlotsForBookingWindow,
  setCourtsSlotsForWeek,
  setSlotsTypesData,
  toggleBookCourtModal,
} from "../court/courtAction";
import {
  setConfirmCloseStaffSessionModalOpen,
  setCurrentStaffActiveSession,
  setCurrentStaffSessionsForToday,
  setCurrentStaffSessionsToVerify,
  setEndStaffSessionModalOpen,
  setSessionsForToday,
  setStartStaffSessionModalOpen,
  setVerifyAndInfoStaffSessionsModalOpen,
} from "../staffSession/staffSessionAction";
import { clearSelection } from "../selectAction";
import { setFollowupProgramCount, setFollowupProgramData, setFollowupProgramsData } from "../followupProgram/followupProgramAction";
import { addBodyMeasurementsModalAction, setMemberBodyMeasurements } from "../bodyMeasurements/bodyMeasurementsAction";
import { addInBodyTestModalAction, setMemberInBodyTests } from "../InBodyTest/InBodyTestAction";
import { setPagination, setSelectedInstructionVideos, setSelectedVideo, setVideosLibraryData } from "../videosLibrary/videosLibraryAction";
import { setAttachmentLibraryData, setAttachmentPagination } from "../attachmentLibrary/attachmentLibraryAction";
import { setActiveMedicalRecordTemplate, setAssessmentTemplates, setTreatmentTemplates } from "../templates/assessmentTemplateAction";
import { setLeadCount, setLeadFollowUps, setLeadInfo, setLeadQuotations, setLeadsData, setLeadStatics, setOpenConverToSaleModal, setOpenLeadFollowUpModal, setOpenLeadModal, setOpenQuotationModal, setUserFollowUps } from "../lead/leadAction";

const groupByBookingDate = (data) => {
  const result = [];
  
  // First, separate group sessions from other types
  const groupSessions = [];
  const regularSessions = [];
  
  data.forEach((slot) => {
    const hasGroupSessions = slot.slotBookedBy.some(booking => booking.slotType === "groupSession");
    
    if (hasGroupSessions) {
      groupSessions.push(slot);
    } else {
      regularSessions.push(slot);
    }
  });
  
  // Process group sessions - group them by date AND time
  const groupSessionsByDateAndTime = {};
  
  groupSessions.forEach((slot) => {
    // Create a unique key for this slot's time
    const timeKey = slot.slotStart; // Using slotStart as the time identifier
    
    slot.slotBookedBy.forEach((booking) => {
      if (booking.slotType === "groupSession") {
        const date = booking.bookingDate;
        // Create a combined key of date and time
        const dateTimeKey = `${date}-${timeKey}`;
        
        if (!groupSessionsByDateAndTime[dateTimeKey]) {
          groupSessionsByDateAndTime[dateTimeKey] = {
            slot: { ...slot },
            bookings: []
          };
        }
        
        groupSessionsByDateAndTime[dateTimeKey].bookings.push(booking);
      }
    });
  });
  
  // Create a new slot for each date-time combination with all group session bookings
  Object.keys(groupSessionsByDateAndTime).forEach((dateTimeKey) => {
    const { slot, bookings } = groupSessionsByDateAndTime[dateTimeKey];
    const newSlot = { ...slot };
    
    // Extract date from the combined key
    const date = dateTimeKey.split('-')[0];
    
    // Set all the group session bookings for this date and time
    newSlot.slotBookedBy = bookings;
    newSlot.slotType = "groupSession";
    
    // Calculate timing
    const bookingDateObj = new Date(parseInt(date));
    const [hours, minutes] = newSlot.slotStart.split(":").map(Number);
    bookingDateObj.setHours(hours);
    bookingDateObj.setMinutes(minutes);
    
    newSlot.slotStartTime = bookingDateObj.getTime();
    newSlot.slotEndTime = newSlot.slotStartTime + newSlot.slotDuration * 60000;
    
    result.push(newSlot);
  });
  
  // Process regular sessions as before
  regularSessions.forEach((slot) => {
    const bookingGroups = {};
    
    slot.slotBookedBy.forEach((booking) => {
      const date = booking.bookingDate;
      
      if (!bookingGroups[date]) {
        bookingGroups[date] = [];
      }
      
      bookingGroups[date].push(booking);
    });
    
    Object.keys(bookingGroups).forEach((date) => {
      const newSlot = { ...slot };
      newSlot.slotBookedBy = bookingGroups[date];
      newSlot.slotType = bookingGroups[date][0]?.slotType || 'regular';
      
      const bookingDateObj = new Date(parseInt(date));
      const [hours, minutes] = newSlot.slotStart.split(":").map(Number);
      bookingDateObj.setHours(hours);
      bookingDateObj.setMinutes(minutes);
      
      newSlot.slotStartTime = bookingDateObj.getTime();
      newSlot.slotEndTime = newSlot.slotStartTime + newSlot.slotDuration * 60000;
      
      result.push(newSlot);
    });
  });
  
  console.log("Final result:", result);
  return result;
};

export const loginApi = (value, fromPos = false, endpoint = "login") => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api(endpoint, value, "postWithoutToken").catch((err) => {});
    // .then((res) => {
    if (res) {
      if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        if (fromPos) return { success: false };
        return;
      }
      if (res.status === 400) {
        if (res?.data?.error) toastr.error(res.data.error);
        else toastr.error("Something went wrong!");
        if (fromPos) return { success: false };
      } else {
        if (res.data && res.data.data && res.data.data.selectionRequired) {
          return {
            selectionRequired: true,
            profiles: res.data.data.profiles || [],
          };
        }
        if (
          res.data && res.data.data &&
          res.data.data.role !== "GYM" &&
          res.data.data.role !== "TRAINER" &&
          res.data.data.role !== "STAFF"
        ) {
          toastr.error("Not allowed to login");
          if (fromPos) return { success: false };
          return;
        }
        let loginUser = res.data.data;
        if(loginUser.gym)dispatch(getGymFeatures(loginUser?.gym));
        if (res.data.data.role === "STAFF") {
          loginUser.gym = res.data.data.staffGym;
        }
        dispatch(setLoginUser(loginUser));
        localStorage.setItem(
          "connectToFitGymPanelUser",
          JSON.stringify(loginUser)
        );
        dispatch(setLoginFlag(true));
        subscribeToMember(
          `${res.data.data.id}${
            res.data.data.role === "GYM" || res.data.data.role === "STAFF"
              ? "G"
              : "T"
          }`
        );
        toastr.success("Success : Logged In");

        if (!fromPos) {
          if (res.data.data.role === "GYM" || res.data.data.role === "STAFF") {
            history.push("/gym-panel/dashboard");
          }
          if (res.data.data.role === "TRAINER") {
            history.push("/trainer-panel/dashboard");
          }
        }

        if (res.data.data.role === "STAFF") {
          let allPermission = await getAllPermission();
          let staffPermissons = await getPermissions(res.data.data.id);
          let permissons = { ...allPermission, ...staffPermissons };
          await dispatch(setPermissons(permissons));
          const staffPermissions = store().permissions.permissions || {};
          const canOpenDashboard =
            staffPermissions["S-SHW-DASH-1M"] ||
            staffPermissions["S-SHW-DASH-O"] ||
            staffPermissions["S-SHW-DASH-1W"] ||
            staffPermissions["S-SHW-DASH-3D"];
          if (!fromPos && !canOpenDashboard) {
            history.push("/gym-panel/gyminfo");
          }
          if (staffPermissions["S-SHW-DASH-1M"]) {
            await dispatch(setStaffGurationFilter("1M"));
          } else if (staffPermissions["S-SHW-DASH-1W"]) {
            await dispatch(setStaffGurationFilter("1W"));
          } else if (staffPermissions["S-SHW-DASH-3D"]) {
            await dispatch(setStaffGurationFilter("3D"));
          }
        }

        if (res.data.data.role === "TRAINER") {
          await dispatch(getTrainer(res.data.data.trainer), true);
          if(res?.data?.data?.trainerGym||res?.data?.data?.assignedGym){
              dispatch(getGym(res?.data?.data?.trainerGym||res.data.data.assignedGym))
              dispatch(getGymFeatures(res?.data?.data?.trainerGym||res.data.data.assignedGym));
          }
        } else {
          await dispatch(getGym(res.data.data.gym));
          if (res.data.data.role === "GYM") {
            dispatch(getGymFeatures(res.data.data.gym));
          }
          if (res.data.data.role === "STAFF") {
            dispatch(getGymFeatures(res.data.data.staffGym));
          }
        }
        getNotifications();
        if (store().gym?.gymConfig?.switchStaff?.enabled) {
          dispatch(getUserOpenedStaffSessions());
          dispatch(getStaffSessionsToVerify());
        }

        return { success: true };
      }
    }
    // })
  };
};

export const selectGymProfileApi = (value, fromPos = false) => {
  return loginApi(value, fromPos, "login/select-profile");
};

export const getAllPermission = async () => {
  let allPermission = await api(`permission?type=STAFF`, {}, "get");

  if (allPermission && allPermission.status === 200) {
    let permissions = allPermission.data.data;
    let customisedPermisstion = {};
    for (let i = 0; i < permissions.length; i++) {
      customisedPermisstion[permissions[i].code] = false;
    }
    return customisedPermisstion;
  } else {
    toastr.error("Error while getting all permissions!");
    return {};
  };
};
export const getPermissions = async (id) => {
  let staffById = await api(`staff/${id}`, {}, "get");
  if (staffById && staffById.status === 200) {
    let staffPermissions = staffById.data.data.permissions;
    let customisedPermisstion = {};
    for (let i = 0; i < staffPermissions.length; i++) {
      customisedPermisstion[staffPermissions[i].code] = true;
    }
    return customisedPermisstion;
  } else {
    toastr.error("Error while getting staff permissions!");
    return {};
  };;
};
export const getGym = (id) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`gym/${id}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          // res.data.data.type = "sportClub"
          // res.data.data.type = "gym"
          dispatch(setGymData(res.data.data));
        }
      })
      .catch((err) => {});
  };
};
export const setStaffCheckIn = (user) => {
  return async (dispatch, store) => {
    await api(`staff/logged/checkin`, user, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          toastr.success("Success : Staff Checked in");
        }
      })
      .catch((err) => {});
  };
};
export const getsubAdminPermissions = (id) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`subAdmin/permissions/${id}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          let permissions = res.data.data.permissions;
          let customisedPermisstion = {};
          for (let i = 0; i < permissions.length; i++) {
            customisedPermisstion[permissions[i].code] = true;
          }
          // return customisedPermisstion;
          dispatch(setSubAdminPermissions(customisedPermisstion));
          dispatch(setSubAdminType(res.data.data.role));
        }
      })
      .catch((err) => {});
  };
};

export const setStaffCheckOut = (user) => {
  return async (dispatch, store) => {
    await api(`staff/logged/checkout`, user, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          toastr.success("Success : Staff Checked out");
        }
      })
      .catch((err) => {});
  };
};

export const getWods = (limit = 10, page = 2, search = "") => {
  return async (dispatch, store) => {
    await api(`wod?page=${page}&limit=${limit}&search=${search}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setWodCount(res.data.totalCount));
          dispatch(setWodsData(res.data.data));
        }
      })
      .catch((err) => {});
  };
};
export const getMemberWods = ({limit = 10, page = 2, member}) => {
  return async (dispatch, store) => {
    await api(`wod/member/${member}?page=${page}&limit=${limit}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setWodCount(res.data.totalCount));
          dispatch(setMemberWod(res.data.data));
        }
      })
      .catch((err) => {});
  };
};
export const getPlans = () => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`plan`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setPlanData(res.data.data));
        }
      })
      .catch((err) => {});
  };
};

export const getGymAttribute = (type) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`gymAttribute?businessType=${type}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setGymAttribute(res.data.data));
        }
      })
      .catch((err) => {});
  };
};

export const editGym = (id, value) => {
  return async (dispatch, store) => {
    await api(`gym/${id}`, value, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error(
            typeof res?.data?.error === "string"
              ? res.data.error
              : "some error occured"
          );
        } else {
          // dispatch(
          //   setMessageData({
          //     type: 'success',
          //     message: 'Gym updated successfully',
          //   })
          // );
          // const interval = setTimeout(() => {
          //   dispatch(setMessageData({}));
          // }, 5000);
          toastr.success("Success : Info Updated");
          history.push("/gym-panel/gyminfo");
        }
      })
      .catch((err) => {});
  };
};
export const editClass = (req) => {
  return async (dispatch, store) => {
    try {
      const { id, startDate, trainer, ...rest } = req;
      const res = await api(`class/${req.id}`, rest, "patch");
      if (res.status === 201) {
        toastr.success("Class edited successfully");
        dispatch(
          getClassesForWeek(
            moment(startDate).format("x"),
            trainer || null,
            "class"
          )
        );
        dispatch(toggleClassEditModal(false));
      } else {
        toastr.error(res?.data?.message||"Something went wrong");
        dispatch(
          getClassesForWeek(
            moment(startDate).format("x"),
            trainer || null,
            "class"
          )
        );
        dispatch(toggleClassEditModal(false));
      }
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
};

export const createStaff = (data) => {
  if (skipVoiceCreate(data)) return () => {};
  return async (dispatch, store) => {
    await api("staff", data, "post").then((res) => {
      if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.status === 400) {
        if (res?.data?.error) toastr.error(res.data.error);
        else toastr.error("Something went wrong!");
      } else {
        dispatch(addStaffModal(false, false, {}));
        toastr.success("Success:Staff Added");
        history.push("/gym-panel/staffs");
      }
    });
  };
};

export const udateStaff = (id, data) => {
  return async (dispatch, store) => {
    await api(`staff/${id}`, data, "patch").then((res) => {
      if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.status === 400) {
        if (res?.data?.error) toastr.error(res.data.error);
        else toastr.error("Something went wrong!");
      } else {
        dispatch(addStaffModal(false, false, {}));
        if (data?.deactivate) {
          toastr.success("Success:Staff Deactivated");
        } else {
          toastr.success("Success:Staff Updated");
        }
        history.push("/gym-panel/staffs");
      }
    });
  };
};

export const getStaff = (page, limit, search, sort = "createdAt desc",allStaffs=false) => {
  return async (dispatch, store) => {
    let url = search
      ? `staff?page=${page}&limit=${limit}&name=${search}&sort=${sort}&allStaffs=${allStaffs}`
      : `staff?page=${page}&limit=${limit}&sort=${sort}&allStaffs=${allStaffs}`;
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setStaffData(res.data.data));
          dispatch(setStaffCount(res.data.totalCount));
        }
      })
      .catch((err) => {});
  };
};

export const getStaffForExport = (
  page,
  limit,
  search,
  sort = "createdAt desc"
) => {
  return async (dispatch, store) => {
    let url = search
      ? `staff?page=${page}&limit=${limit}&name=${search}&sort=${sort}`
      : `staff?page=${page}&limit=${limit}&sort=${sort}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      return res.data.data;
    }
  };
};

export const getTrainerAttribute = (id) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`trainerAttribute`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setTrainerAttribute(res.data.data));
        }
      })
      .catch((err) => {});
  };
};

export const createTrainer = (value, memberValue) => {
  if (skipVoiceCreate(value)) return () => {};
  return async (dispatch, store) => {
    await api(`trainer`, value, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error(res?.data?.error || "Email already exists");
        } else {
          dispatch(addTrainerModal(false));
          toastr.success("Success:Trainer Added");
          if (memberValue && value.addTrainerAsMember && res?.data?.data?.id) {
            dispatch(
              createTrainerAsMember({
                ...memberValue,
                trainerId: res?.data?.data?.id,
              })
            );
          }
          history.push("/gym-panel/trainerinfolist");
        }
      })
      .catch((err) => {});
  };
};

export const getTrainers = (
  page,
  limit,
  gymId,
  search,
  sort = "t.createdAt desc",
  filter = "",
  serviceType=""
) => {
  return async (dispatch, store) => {
    const params = new URLSearchParams();
    params.append("gym", gymId);
    params.append("page", page);
    params.append("limit", limit);
    params.append("sort", sort);

    // Optional dynamic fields
    if (search) params.append("name", search);
    if (filter !== undefined && filter !== "") params.append("isActive", filter);
    if (serviceType !== undefined && serviceType !== "") params.append("serviceType", serviceType);

    const url = `trainer?${params.toString()}`;
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setTrainersData(res.data.data));
          dispatch(setTrainerCount(res.data.totalCount));
        }
      })
      .catch((err) => {});
  };
};

export const getCoachingSummary = (
{gym}
) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let url = `coaching/grouped?gym=${gym}`;
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setCoachingSummary(res.data.data));
        }
      })
      .catch((err) => {});
  };
};

export const overlapsBooking= (
  startDate,
  endDate,blockTimesByTrainer
) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let filter = {
     
      startDate,
      endDate,
      blockTimesByTrainer
    
    };
    let params = {
      filter,
   
    };

    const queryString = Object.keys(params)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(
            JSON.stringify(params[key])
          )}`
      )
      .join("&");

    let url = `overlapsBookings?${queryString}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setOverLapBookings(res.data.data))
    }
  };
};

export const blockSlots = (body,currentDates) => {
  return async (dispatch, store) => {
    let res = await api('blockSlots', body, "post").catch((err) => {
      console.error("API Error:", err);
      toastr.error("Something went wrong!");
    });

    if (!res) return;

    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error(res?.data?.message || "Some error occurred");
      return;
    }

    // ✅ Show success toast
    toastr.success(res?.data?.message || "Blocked successfully");

    // ✅ Show each individual error as a warning toast
    if (Array.isArray(res?.data?.errors) && res.data.errors.length > 0) {
      res.data.errors.forEach((errMsg) => {
        toastr.warning(errMsg, "", { timeOut: 6000 }); // ⏱️ 8 seconds
      });
    }
    

    // ✅ Refresh blocked slots
    console.log({currentDates})
    dispatch(getBlockedSlots({
      startDate: currentDates?.startDate,
      endDate: currentDates?.endDate
    }));
  };
};

export const copyBlockedSlot = (id, body, currentDates) => {
  return async (dispatch) => {
    const res = await api(`blockSlots/${id}/copy`, body, "post").catch(
      (err) => err?.response
    );

    if (!res || res.status >= 500) {
      toastr.error(res?.data?.message || "Unable to copy blocked time");
      return;
    }
    if (res.status >= 400) {
      toastr.error(res?.data?.message || res?.data?.error || "Unable to copy blocked time");
      return;
    }

    const created = res?.data?.data?.created || [];
    const skipped = res?.data?.data?.skipped || [];
    if (created.length) {
      toastr.success(`${created.length} blocked time(s) copied successfully`);
    }
    skipped.forEach(({ dateTime, reason }) => {
      toastr.warning(
        `${moment(dateTime).format("DD/MM/YYYY HH:mm")} ${reason}`,
        "",
        { timeOut: 6000 }
      );
    });

    dispatch(
      getBlockedSlots({
        startDate: currentDates?.startDate,
        endDate: currentDates?.endDate,
      })
    );
  };
};

export const getTrainersForExport = (
  page,
  limit,
  gymId,
  search,
  sort = "t.createdAt desc",
  filter = ""
) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let url = search
      ? `trainer?gym=${gymId}&page=${page}&limit=${limit}&name=${search}&sort=${sort}&isActive=${filter}`
      : `trainer?gym=${gymId}&page=${page}&limit=${limit}&sort=${sort}&isActive=${filter}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      return res.data.data;
    }
  };
};

export const getAllTrainers = (
  page,
  limit,
  gymId,
  search,
  sort = "t.createdAt desc",
  filter = ""
) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let url = search
      ? `trainer?gym=${gymId}&page=${page}&limit=${limit}&name=${search}&sort=${sort}&isActive=${filter}`
      : `trainer?gym=${gymId}&page=${page}&limit=${limit}&sort=${sort}&isActive=${filter}`;
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setAllTrainersData(res.data.data));
        }
      })
      .catch((err) => {});
  };
};

export const getTrainer = (
  id,
  dashboard = false,
  weeklyScheduleFilter = false
) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(
      `trainer/${id}?dashboard=${dashboard}&scheduleFilter=${weeklyScheduleFilter}`,
      {},
      "get"
    )
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setTrainerData(res.data.data));
          if (dashboard) dispatch(setTrainerDashboardSchedule(res.data.data));
        }
      })
      .catch((err) => {});
  };
};

export const deleteTrainer = (id) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api(`trainer/${id}`, {}, "delete").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      toastr.success("Success : Trainer Delete");
      history.push("/gym-panel/trainerinfolist");
    }
  };
};

export const updateTrainer = (id, value, memberValue) => {
  return async (dispatch, store) => {
    dispatch(setLoading(true));

    let member;
    if (memberValue && value.addTrainerAsMember) {
      try {
        member = await dispatch(
          createTrainerAsMember({
            ...memberValue,
            trainerId: id,
          })
        );
      } catch (error) {
        toastr.error("some error occured when add trainer as member");
      }
    }
    return api(`trainer/${id}`, { ...value, member: member?.data?.id }, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          dispatch(setLoading(false));

          return;
        }
        if (res.status === 400) {
          toastr.error(res?.data?.error || "Trainer update failed. Please try again.");
          dispatch(setLoading(false));

        } else {
          dispatch(setLoading(false));
          if (value?.deactivate) {
            toastr.success("Success : Trainer Deactivate");
          } else {
            toastr.success("Success : Trainer Update");
          }
          dispatch(setTrainerData(res.data.data));
          console.log(memberValue && value.addTrainerAsMember);

          if (value?.deactivate) {
            history.push(`/gym-panel/trainerinfolist`);
          } else {
            JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
            history.push("/gym-panel/trainerinfolist")
            // JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
            //   .role === "TRAINER"
            //   ? history.push("/trainer-panel/trainerinfo")
            //   : history.push(`/gym-panel/trainer/${id}`);
          }

          // history.push(`/gym-panel/trainer/${id}`);
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        toastr.error(
          err?.response?.data?.message ||
            "Trainer update failed. Please try again."
        );
        return null;
      });
  };
};
export const updateBookingTrainer = (payload, startDate, endDate) => {
  return async (dispatch, store) => {
    await api(`booking/appointment/updateBookingsTrainer`, payload, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error(res?.data?.message||"some error occured");
        } else {
          toastr.success("Success : Coach/Instructor Updated");
          dispatch(
            getAppointmentBookingByMonth({ start: startDate, end: endDate })
          );
          dispatch(getCourtsSlotsForBookingPageView({startDate,endDate}));
          dispatch(getBlockedSlots({startDate,endDate}));
        }
      })
      .catch((err) => toastr.error("Something went wrong, please try again"));
  };
};
export const getReportsCount = () => {
  return async (dispatch, store) => {
    let url = `gym/reports/count`;
    await api(url, {}, "get").then((res) => {
      if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.status === 400) {
        toastr.error("some error occured");
      } else {
        dispatch(setReportsSummary(res.data.data));
      }
    });
  };
};
export const activateMembership = ({ id, member }) => {
  return async (dispatch, store) => {
    let url = `membership/activate/${id}`;
    await api(url, {}, "patch").then((res) => {
      if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.status === 400) {
        toastr.error("some error occured");
      } else if (res.status === 409) {
        if (res?.data?.error) toastr.error(res.data.error);
        else toastr.error("Something went wrong!");
      } else {
        dispatch(getMemberInfo(member));
        dispatch(
          getMemberTabsInfo({
            member,
            params: "purchases",
            page: store().member.dataPage,
            limit: store().member.dataLimit,
          })
        );
        toastr.success("Success : Membership Activated");
      }
    });
  };
};
export const getFinancialParty = ({ query, page, limit }) => {
  return async (dispatch, store) => {
    let url = "gym/financial/parties";
    if (page && limit) {
      url += `?page=${page}&limit=${limit}`;
    }
    if (query) {
      Object.keys(query).forEach((item) => {
        url += `&${encodeURIComponent(item)}=${encodeURIComponent(query[item])}`;
      });
    }
    try {
      let res = await api(url, {}, "get");
      if (String(res?.data?.status).startsWith('5') || String(res.data?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.data.status == 200) {
        dispatch(setFinancialParties(res.data.data));
        dispatch(setFinancialPartiesCount(res.data.totalCount));
      }
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
};
export const addFinancialParty = ({ body }) => {
  return async (dispatch, store) => {
    try {
      let res = await api(`gym/financial/parties`, body, "post");
      if (String(res?.data?.status).startsWith('5') || String(res.data?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.data.status == 200) {
        dispatch(
          getFinancialParty({
            query: {
              party: true,
            },
            page: 1,
            limit: 10,
          })
        );
        // dispatch(setFinancialPartiesCount(res.data.totalCount))
      }
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
};
export const updateFinancialParty = ({ body }) => {
  return async (dispatch, store) => {
    try {
      let res = await api(`gym/financial/parties/${body.id}`, body, "patch");
      if (String(res?.data?.status).startsWith('5') || String(res.data?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.data.status == 200) {
        dispatch(
          getFinancialParty({
            query: {
              party: true,
            },
            page: 1,
            limit: 10,
          })
        );
        toastr.success("Success : Counterparty Updated");
      }
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
};

export const deleteFinancialParty = ({ body }) => {
  return async (dispatch, store) => {
    try {
      let res = await api(`gym/financial/parties/${body.id}`, {}, "delete");
      if (String(res?.data?.status).startsWith('5') || String(res.data?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.data.status == 200) {
        dispatch(
          getFinancialParty({
            query: {
              party: true,
            },
            page: 1,
            limit: 10,
          })
        );
        toastr.success("Success : Counterparty Deleted");
      }
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
};
export const addTransactionByParty = (body) => {
  return async (dispatch, store) => {
    try {
      let res = await api(`gym/transaction/financial/parties`, body, "post");
      if (String(res?.data?.status).startsWith('5') || String(res.data?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.data.status == 200) {
        dispatch(
          getFinancialParty({
            query: {
              party: true,
            },
            page: 1,
            limit: 10,
          })
        );
        toastr.success("Success : Transaction by Party Added");
      }
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
};

export const updateTransactionByParty = (body) => {
  return async (dispatch, store) => {
    try {
      let res = await api(`gym/transaction/financial/parties/${body.id}`, body, "patch");
      if (String(res?.data?.status).startsWith('5') || String(res.data?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.data.status == 200) {
        dispatch(
          getFinancialParty({
            query: {
              party: true,
            },
            page: 1,
            limit: 10,
          })
        );
        toastr.success("Success : Transaction by Party Updated");
      }
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
};
export const updateReamainingSessions= (body) => {
  return async (dispatch, store) => {
    try {
      let res = await api(`sale/updateRemainingSession/${body.id}`, body, "patch");
      if (String(res?.data?.status).startsWith('5') || String(res.data?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.data.status == 200) {
        dispatch(
          getMemberTabsInfo({
            member:body.member,
            params: "purchases",
            page: store().member.dataPage,
            limit: store().member.dataLimit,
          })
        );
        toastr.success("Success : Remaining sessions Updated");
      }
      else toastr.error(res?.data?.message||"Something went wrong")
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
};
export const deleteTransactionByParty = (body) => {
  return async (dispatch, store) => {
    try {
      let res = await api(`gym/transaction/financial/parties/${body.id}`, {}, "delete");
      if (String(res?.data?.status).startsWith('5') || String(res.data?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.data.status == 200) {
        dispatch(
          getFinancialParty({
            query: {
              party: true,
            },
            page: 1,
            limit: 10,
          })
        );
        toastr.success("Success : Transaction by Party Deleted");
      }
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
};

export const getReports = ({ reportName, page, limit, query }) => {
  return async (dispatch, store) => {
        // Cancel the previous request before making a new request
   dispatch(setCommonLoading(true))
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Operation canceled due to new request.");
    }

    // Create a new CancelToken source
    const requestSource = generateCancelTokenSource();
    cancelTokenSource = requestSource;
    let url = `reports/${reportName}`;
    if (page && limit) {
      url += `?page=${page}&limit=${limit}&timeZone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`;
    }
    let showTotal = false;
    let date = {
      from: "",
      to: "",
    };
    let status = "";
    let memberStatus = "";
    if (query) {
      Object.keys(query).forEach((item) => {
        url += `&${item}=${query[item]}`;
        // here will add logic for permission for staff if he doesnt have permsiion to see total in transaction report
        if (item == "startDate" && reportName !== "sales") {
          date.from = query[item];
        }
        if (item == "endDate" && reportName !== "sales") {
          date.to = query[item];
        }
        if (item === "status" && reportName !== "sales") {
          status = query[item];
        }
        if((item === "memberStatus" && reportName !== "sales")){
          memberStatus=query[item];
        }

        if (reportName == "transaction" && item == "startDate") {
          showTotal = true;
        }
      });
    }
    try {
      let res = await api(url, {}, "get",null,requestSource.token);
      if (cancelTokenSource !== requestSource) return;
      if (!res) {
        dispatch(setCommonLoading(false));
        return;
      }
      if (String(res?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        dispatch(setCommonLoading(false));
        return;
      }
      if (res?.status === 400) {
        toastr.error(res?.data?.error || "Invalid report filters");
        dispatch(setCommonLoading(false));
        return;
      }
      if(res&&res?.status==200) {
        let data = res?.data?.data;
        let count = res?.data?.totalCount;
        let totals = res?.data?.counts;
        if (
          reportName == "transaction" &&
          store().login.loginUser.role == "STAFF" &&
          !store().permissions.permissions["SHO-TOTAL-S"] &&
          !showTotal
        ) {
          totals = { totalAmount: 0, outcome: 0, income: 0 };
        }

        dispatch(setAllReportsData(data));
        const isBookingExport =
          String(query?.export) === "1" &&
          (reportName === "appointmentBookings" ||
            reportName === "courtSlotBookings" ||
            reportName === "classBookings");
        if (isBookingExport) {
          if (Number(count) > (data?.length || 0)) {
            toastr.warning(
              `Exported ${data?.length || 0} of ${count} bookings. Shorten the dates to include the rest.`
            );
          }
        } else {
        if (
          reportName !== "appointmentBookings" &&
          reportName !== "courtSlotBookings" &&
          reportName !== "classBookings" &&
          reportName !== "insuranceClaims" &&
          !String(reportName).startsWith("revenue")
        ) {
        dispatch(
          getSalesExpansions(page, limit, null, "DATE", null, date, status,memberStatus)
        );
        }
        dispatch(setReportsData(data));
        dispatch(setReportsCount(count));
        dispatch(setReportsSummary(res?.data?.summary || {}));
        dispatch(
          setSalesTotalData({
            ...totals,
            returnAmount: res?.data?.returnAmount?.returnedAmount,
          })
        );
        dispatch(
          setSalesTotalData({
            ...totals,
            returnAmount: res?.data?.returnAmount?.returnedAmount,
          })
        );
        }
      }
      dispatch(setCommonLoading(false))

    } catch (e) {
      if (isCancelAxios(e) || cancelTokenSource !== requestSource) return;
      dispatch(setCommonLoading(false));
      toastr.error("Something went wrong");
    }
  };
};
export const getPayrollOverView=({page,limit})=>{
  return async (dispatch, store) => {
    let url = `payroll/overview`;
    if (page && limit) {
      url += `?page=${page}&limit=${limit}&timeZone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`;
    }
    try {
      dispatch(setCommonLoading(true))
      let res = await api(url, {}, "get");
      let data = res.data.data;
      if (res.status == 200) {
        dispatch(setPayrollOverview(data));
      } else {
        toastr.error("something went wrong");
      }
      dispatch(setCommonLoading(false))
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
}
export const getPayrollDetails=({page,limit,startDate,endDate})=>{
  return async (dispatch, store) => {
    let url = `payroll/details?startDate=${startDate}&endDate=${endDate}`;
    if (page && limit) {
      url += `?page=${page}&limit=${limit}&timeZone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`;
    }
    try {
      dispatch(setCommonLoading(true))
      let res = await api(url, {}, "get");
      let data = res.data.data;
      if (res.status == 200) {
        dispatch(setPayrollDetails(data));
      } else {
        toastr.error("something went wrong");
      }
      dispatch(setCommonLoading(false))
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
}
export const runPayroll=({startDate,endDate})=>{
  return async (dispatch, store) => {
    let url = `payroll/run`;
    try {
      dispatch(setCommonLoading(true))
      let res = await api(url, {startDate,endDate}, "post");
      if (res.status == 200) {
        dispatch(getPayrollDetails({startDate,endDate}));
      } else {
        toastr.error("something went wrong");
      }
      dispatch(setCommonLoading(false))
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
}
export const lockPayroll=({startDate,endDate})=>{
  return async (dispatch, store) => {
    let url = `payroll/lock`;
    try {
      dispatch(setCommonLoading(true))
      let res = await api(url, {startDate,endDate}, "post");
      if (res.status == 200) {
        dispatch(getPayrollDetails({startDate,endDate}));
      } else {
        toastr.error("something went wrong");
      }
      dispatch(setCommonLoading(false))
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
}
let accountingDetailsRequestId = 0;

export const getAccountingReportDetails = ({
  reportName,
  page,
  limit,
  query,
}) => {
  return async (dispatch, store) => {
    const requestId = ++accountingDetailsRequestId;
    let url = `reports/accountingEntryDetails`;
    if (page && limit) {
      url += `?page=${page}&limit=${limit}&timeZone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`;
    }
    if (query) {
      Object.keys(query).forEach((item) => {
        url += `&${item}=${query[item]}`;
      });
    }

    try {
      dispatch(setAccountingDetailsLoading(true));
      let res = await api(url, {}, "get");
      if (requestId !== accountingDetailsRequestId) return;
      let data = res.data.data;
      let count = res?.data?.totalCount;
      if (res.status == 200) {
        dispatch(setaccountingDetailsData({ data: data, totalCount: count }));
      } else {
        toastr.error("something went wrong");
      }
    } catch (e) {
      if (requestId !== accountingDetailsRequestId) return;
      toastr.error("Something went wrong");
    } finally {
      if (requestId === accountingDetailsRequestId) {
        dispatch(setAccountingDetailsLoading(false));
      }
    }
  };
};

const memberTabInfoCancelSources = {};

const isCanceledMemberTabRequest = (error) =>
  isCancelAxios(error) ||
  error?.message === "Operation canceled due to new request.";

export const getMemberTabsInfo = ({ params, page, limit, query, member }) => {
  return async (dispatch, store) => {
    if (params) {
      const isCurrentFinancialMember = () => {
        const selectedMemberId = Number(store().member?.member?.id);
        return !selectedMemberId || selectedMemberId === Number(member);
      };
      const isCurrentRequest = (requestSource) =>
        memberTabInfoCancelSources[params] === requestSource;
      const skipTabs = ["bodyMeasurements", "inBodyTest","workouts"];
      if (skipTabs.includes(params)) {
        return;
      }
      dispatch(setLoading(true));
      if (params === "financial") {
        dispatch(setMemberFinancialDetails({
          member: { memberId: Number(member) || null },
          summary: {
            totalPaidAmount: 0,
            totalPhysicalPaidAmount: 0,
            netPhysicalPaidAmount: 0,
            totalPackageCoveredAmount: 0,
            totalRefundOrOutcome: 0,
            outstandingBalance: 0,
          },
          memberCredit: { balance: 0, deposited: 0, used: 0 },
          payments: [],
          packages: [],
          loading: true,
        }));
      }
      let url = `member/${member}/info/${params}`;
      if (page && limit) {
        url += `?page=${page}&limit=${limit}`;
      }
      if (query) {
        Object.keys(query).forEach((item) => {
          url += `&${item}=${query[item]}`;
        });
      }
      const requestSource = generateCancelTokenSource();
      if (memberTabInfoCancelSources[params]) {
        memberTabInfoCancelSources[params].cancel(
          "Operation canceled due to new request."
        );
      }
      memberTabInfoCancelSources[params] = requestSource;
      try {
        let res = await api(url, {}, "get", null, requestSource.token);
        if (!isCurrentRequest(requestSource)) return { success: false };
        if (String(res?.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          if (params === "financial" && isCurrentFinancialMember()) {
            dispatch(setMemberFinancialDetails({
              member: { memberId: Number(member) || null },
              summary: {},
              memberCredit: { balance: 0, deposited: 0, used: 0 },
              payments: [],
              packages: [],
              loading: false,
            }));
          }
          dispatch(setLoading(false));
          return { success: false };
        }
        let responseData;
        if(res&&res?.status==200){
        let data = res.data.data;
        responseData = data;
        let count = res.data?.totalCount||0;
        let checkedIn = res?.data?.checkedIn;
        if(params==="visits"){
          dispatch(setMemberBookingsStatus(res?.data?.bookingStats))
        }
        if(params==="financial"){
        const selectedMemberId = Number(store().member?.member?.id);
        if (!selectedMemberId || selectedMemberId === Number(member)) {
          dispatch(setMemberFinancialDetails({ ...data, loading: false }));
        }
        }else{
        dispatch(setMemberCheckInBookings(checkedIn));
        dispatch(setMemberInfoData(data));
        dispatch(setMemberInfoCount(count));
        }
       
        } else if (params === "financial" && isCurrentFinancialMember()) {
          dispatch(setMemberFinancialDetails({
            member: { memberId: Number(member) || null },
            summary: {},
            memberCredit: { balance: 0, deposited: 0, used: 0 },
            payments: [],
            packages: [],
            loading: false,
          }));
        }
        dispatch(setLoading(false));
        return { success: Boolean(res && res.status == 200), data: responseData };
      } catch (e) {
        if (isCanceledMemberTabRequest(e) || !isCurrentRequest(requestSource)) {
          return { success: false, error: e };
        }
        toastr.error("Something went wrong");
        dispatch(setLoading(false));
        if (params === "financial" && isCurrentFinancialMember()) {
          dispatch(setMemberFinancialDetails({
            member: { memberId: Number(member) || null },
            summary: {},
            memberCredit: { balance: 0, deposited: 0, used: 0 },
            payments: [],
            packages: [],
            loading: false,
          }));
        }
        return { success: false, error: e };
      }
    }
  };
};
export const getMemberGymVisits = ({ msp, page, limit, query, member }) => {
  return async (dispatch, store) => { 
      dispatch(setLoading(true));
      let url = `member/getMemberships/${msp}`;
      if (page && limit) {
        url += `?page=${page}&limit=${limit}`;
      }
      if (query) {
        Object.keys(query).forEach((item) => {
          url += `&${item}=${query[item]}`;
        });
      }
      try {
       if (cancelTokenSource) {
          cancelTokenSource.cancel("Operation canceled due to new request.");
        }
        // Create a new CancelToken source
        cancelTokenSource = generateCancelTokenSource();
        let res = await api(url, {}, "get",null,cancelTokenSource.token);
        if (String(res?.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if(res&&res?.status==200){
        let data = res.data.data;
        dispatch(setMemberGymPkgVisit(data));
        dispatch(setMemberGymPkgVisitCount(res.data.totalCount));
        }
        dispatch(setLoading(false));
      } catch (e) {
        toastr.error("Something went wrong");
      }
    
  };
};
export const getMemberBookingList = ({
  page,
  limit,
  query,
  member,
  loading = true,
}) => {
  return async (dispatch, store) => {
    let url = `member/${member}/memberBookingList`;
    if (page && limit) {
      url += `?page=${page}&limit=${limit}`;
    }
    if (query) {
      Object.keys(query).forEach((item) => {
        url += `&${item}=${query[item]}`;
      });
    }
    try {
      loading && dispatch(setBookingListLoading(true));
      let res = await api(url, {}, "get");
      if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      let data = res.data.data;
      let count = res.data.totalCount;
      let checkedIn = res.data.checkedIn;
      loading && dispatch(setBookingListLoading(false));
      dispatch(setMemberBookingList(data));
      dispatch(setMemberCheckInBookings(checkedIn));
      dispatch(setMemberBookingListCount(count));
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
};
export const getReportsForExport = (page, limit, search, filter, date) => {
  return async (dispatch, store) => {
    let url = search
      ? `gym/reports?page=${page}&limit=${limit}&search=${search}`
      : `gym/reports?page=${page}&limit=${limit}`;
    if (filter) {
      if (filter === "ACTIVE") {
        url = url.concat(`&isActive=Y`);
      }
      if (filter === "INACTIVE") {
        url = url.concat(`&isActive=N`);
      }
      if (filter === "REMAINING") {
        url = url.concat(`&remaining=Y`);
      }
      if (filter === "FREEZE") {
        url = url.concat(`&isActive=N`);
      }
      if (filter === "RENEW") {
        url = url.concat(`&saleType=RENEW`);
      }
      if (filter === "REJOINED") {
        url = url.concat(`&saleType=REJOIN`);
      }
      if (filter === "DATE") {
        if (date) {
          url = url.concat(`&from=${date.from}&to=${date.to}`);
        }
      }
    }
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      return res.data.data;
    }
  };
};

export const returnVoidSale = ({
  id,
  member,
  transactionType,
  cardProcessingFees,
  note,
  usedSessions,
  chargablePackage,
  chargablePackagePayload
}) => {
  return async (dispatch, store) => {
    try {
      dispatch(setLoading(true));
      let res = await api(
        `gym/report/${id}/return`,
        { transactionType, cardProcessingFees, note, usedSessions,chargablePackage,...chargablePackagePayload },
        "patch"
      );
      if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
        toastr.error(res?.response?.data?.message||"Something went wrong!");
        return;
      }
      dispatch(setVoidInfo(res.data.data));
      if (res.data.data) toastr.success("Return  Sale Successfuly");
      return res.data;
    } catch (e) {
      toastr.error("Something went wrong");
    } finally {
      dispatch(setReturnVoidMembershipOpen(false));
      dispatch(setVoidSummaryOpen(true));
      dispatch(getMemberInfo(member));
      dispatch(
        getMemberTabsInfo({ member, params: "purchases", page: 1, limit: 10 })
      );
    }
  };
};

export const returnProductSale = ({
  id,
  member,
  reason,
  // transactionType,
  // cardProcessingFees,
}) => {
  return async (dispatch, store) => {
    dispatch(setLoading(false));
    try {
      let res = await api(`return/product/sale/${id}`, { reason }, "patch");
      // dispatch(setVoidInfo(res.data.data));
      if (res.data.status !== 200)
        toastr.error(
          res.data.message ? res.data.message : "something went wrong"
        );
      else toastr.success("Return Product Successfuly");
    } catch (e) {
      toastr.error("Something went wrong");
    } finally {
      console.log({ member });
      dispatch(getMemberInfo(member));
      dispatch(
        getMemberTabsInfo({
          member,
          params: "purchasesdProducts",
          page: 1,
          limit: 10,
        })
      );
    }
  };
};
export const VoidProductSale = ({
  id,
  member,
  reason,
  // transactionType,
  // cardProcessingFees,
}) => {
  return async (dispatch, store) => {
    dispatch(setLoading(false));
    try {
      let res = await api(`void/product/sale/${id}`, { reason }, "patch");
      // dispatch(setVoidInfo(res.data.data));
      if (res.data.status !== 200)
        toastr.error(
          res.data.message ? res.data.message : "something went wrong"
        );
      else toastr.success("Void Product Successfuly");
    } catch (e) {
      toastr.error("Something went wrong");
    } finally {
      console.log({ member });
      dispatch(getMemberInfo(member));
      dispatch(
        getMemberTabsInfo({
          member,
          params: "purchasesdProducts",
          page: 1,
          limit: 10,
        })
      );
    }
  };
};

export const voidSale = ({
  membership,
  member,
  cardProcessingFees,
  note,
  voidWithReason
}) => {
  return async (dispatch, store) => {
    try {
      dispatch(setCommonLoading(true))
      let res = await api(
        `gym/report/${membership}/void`,
        { cardProcessingFees, note,voidWithReason },
        "patch"
      );
      if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
        toastr.error(res?.data?.message || "Something went wrong!");
        return;
      }
      if (res?.status === 400 || res?.data?.status === 400) {
        toastr.error(res?.data?.message || "This sale could not be voided");
        return null;
      }
      dispatch(setVoidInfo(res.data.data));
      if (res.data.data) toastr.success("Voided Successfuly");
      return res.data;
    } catch (e) {
      toastr.error("Something went wrong");
    } finally {
      dispatch(setVoidMembershipOpen(false));
      dispatch(setVoidSummaryOpen(true));
      dispatch(getMemberInfo(member));
      dispatch(setCommonLoading(false))

      dispatch(
        getMemberTabsInfo({ member, params: "purchases", page: 1, limit: 10 })
      );
    }
  };
};
export const createMemberDocuments = ({ data, getDouments = true }) => {
  return async (dispatch, store) => {
    try {
      let res = await api(`member/document`, data, "post");

      // Handle server errors
      if (String(res.status).startsWith("5") || String(res?.response?.status).startsWith("5")) {
        toastr.error("Something went wrong!");
        return { success: false };
      }

      // Handle validation errors
      if (res.data.status === 400) {
        toastr.error(res.data.message ? res.data.message : "Something went wrong");
        return { success: false };
      }

      // Dispatch success action
      dispatch(setmemberDocuments(res.data.data));

      return { success: true, data: res.data.data };
    } catch (e) {
      toastr.error("Something went wrong");
      return { success: false };
    } finally {
      if (getDouments) {
        dispatch(
          getMemberTabsInfo({
            params: "documents",
            page: store().member.dataPage,
            limit: store().member.dataLimit,
            member: store().member.memberInfoId,
          })
        );
      }
    }
  };
};

export const deleteMemberDocument = ({ id, member }) => {
  return async (dispatch, store) => {
    try {
      let res = await api(`member/document/${id}`, {}, "delete");
      if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      if (res.data.status == 400)
        toastr.error(
          res.data.message ? res.data.message : "something went wrong"
        );
    } catch (e) {
      toastr.error("Something went wrong");
    } finally {
      dispatch(
        getMemberTabsInfo({
          params: "documents",
          page: store().member.dataPage,
          limit: store().member.dataLimit,
          member: member,
        })
      );
    }
  };
};

let cancelTokenSource;
let memberSearchCancelTokenSource;

export const getMembers = (
  page,
  limit,
  gymId,
  search,
  sort = "m.createdAt desc",
  filter = "",
  gender = "",
  isLoading = true,
  shouldStoreResults = true
) => {
  return async (dispatch, store) => {
    if (isLoading) {
      dispatch(setLoading(true));
    }

    const previousCancelTokenSource = shouldStoreResults
      ? cancelTokenSource
      : memberSearchCancelTokenSource;

    // Cancel the previous request before making a new request
    if (previousCancelTokenSource) {
      previousCancelTokenSource.cancel(
        "Operation canceled due to new request."
      );
    }

    // Create a new CancelToken source
    const requestCancelTokenSource = generateCancelTokenSource();
    if (shouldStoreResults) {
      cancelTokenSource = requestCancelTokenSource;
    } else {
      memberSearchCancelTokenSource = requestCancelTokenSource;
    }

    let url = search
      ? `getMembers?gym=${gymId}&page=${page}&limit=${limit}&search=${encodeURIComponent(search)}&sort=${sort}&filter=${filter}&gender=${gender}`
      : `getMembers?gym=${gymId}&page=${page}&limit=${limit}&sort=${sort}&filter=${filter}&gender=${gender}`;

    try {
      const res = await api(
        url,
        {},
        "get",
        null,
        requestCancelTokenSource.token
      );
      if (res) {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("Some error occurred");
        } else {
          if (shouldStoreResults) {
            dispatch(setMembersData(res.data.data));
            dispatch(setMemberCount(res.data.totalCount));
          }
          return res.data.data || [];
        }
      }
    } catch (err) {
      console.error(err);
      if (isCancelAxios(err)) {
        console.log("Request canceled", err.message);
      } else {
        // Handle error
        toastr.error("An error occurred while fetching data");
      }
      return [];
    } finally {
      if (isLoading) {
        dispatch(setLoading(false));
      }
    }
  };
};

export const getMembersForExport = (
  page,
  limit,
  gymId,
  search,
  sort = "m.createdAt desc",
  filter = ""
) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let url = search
      ? `getMembers?gym=${gymId}&page=${page}&limit=${limit}&search=${search}&sort=${sort}&filter=${filter}`
      : `getMembers?gym=${gymId}&page=${page}&limit=${limit}&sort=${sort}&filter=${filter}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      return res.data.data;
    }
  };
};
export const getClassesForWeek = (startDate, trainer, type) => {
  const date = new Date(parseInt(startDate));
  date.setTime(date.getTime() - new Date().getTimezoneOffset() * 60 * 1000);
  const utcTimestamp = date.getTime();
  return async (dispatch, store) => {
    let url = `class/getGroupByDate?startDate=${utcTimestamp}&timeZone=${
      Intl.DateTimeFormat().resolvedOptions().timeZone
    }${trainer ? `&trainer=${trainer}` : ""}${type ? `&type=${type}` : ""}`;
    api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        switch (type) {
          case "class": {
            dispatch(setClassesForWeek(res.data.data.classes));
            break;
          }
          case "appointment": {
            dispatch(setAppointmentsForWeek(res.data.data));
            break;
          }
          default: {
            dispatch(setAllWeeklySchedule(res.data.data));
            break;
          }
        }
      })
      .catch((err) => toastr.error("Something went wrong, please try again"));
  };
};

export const getInvoiceById = (id) => {
  return async (dispatch, store) => {
    let url = `transaction/member/${id}/invoice`;
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setInvoiceSummary(res.data.data));
        }
      })
      .catch((err) => {});
  };
};

export const getDashboardWeeklySchedule = (trainer, type) => {
  return async (dispatch, store) => {
    let startDate = moment()
      .startOf("day")
      .valueOf();
    let url = `class/getGroupByDateForDashboard?startDate=${startDate}`;
    if (type) url += `&type=${type}`;
    if (trainer) url += `&trainer=${trainer}`;

    await api(url, {}, "get")
      .then((res) => {
        if (res.status !== 200) {
          toastr.error("some error occured");
        } else {
          let totalClasses = 0;
          let totalAppointments = 0;
          let totalMembers = 0;
          let totalInstructors = 0;
          const uniqueMembers = new Set();
          const uniqueInstructors = new Set();

          let data = res.data.data.map((day) => {
            let schedule = day.schedules?.map((event) => {
              if (event.type === "class") {
                totalClasses++;
                // Add members from class bookings to the uniqueMembers Set
               if (event.bookingsMembers && Array.isArray(event.bookingsMembers)) {
                   event.bookingsMembers.forEach(booking => {
                      uniqueMembers.add(booking.member); // Add each member ID to the Set
                      });
                   }
                   uniqueInstructors.add(event.trainerId);

                return {
                  name: event.name,
                  start: parseInt(event.from),
                  end: parseInt(event.to),
                  noBookings: event.noBookings,
                  type: "class",
                };
              }

              const appointment = JSON.parse(event.appointment);
              const trainer = JSON.parse(event.trainer);
              uniqueInstructors.add(trainer.id);
              uniqueMembers.add(event?.member_id);
              // or whatever unique identifier you have for trainers

              totalAppointments++;
              // totalMembers++;
              // totalInstructors++;

              return {
                name: event.member_name,
                start: event.dateTime,
                end: moment(event.dateTime)
                  .add(appointment.duration, "minutes")
                  .valueOf(),
              };
            });

            return { date: day.date, schedules: schedule };
          });

          let savedObj = {
            data,
            totalClasses,
            totalAppointments,
            totalMembers: uniqueMembers.size,
            totalInstructors: uniqueInstructors.size,
          };
          dispatch(setDashboardWeeklySchedule(savedObj));
        }
      })
      .catch((err) => {
        console.error(err.message);
        toastr.error("Something went wrong");
      });
  };
};

export const getSingleInvoice = (id) => {
  return async (dispatch, store) => {
    let url = `transaction/member/${id}/invoice`;
    try {
      let {
        data: { data },
      } = await api(url, {}, "get");
      const [invoiceInfo] = data;
      return invoiceInfo;
    } catch (e) {
      toastr.error(e.message);
    }
  };
};

export const getInvoice = (
  page,
  limit,
  search = "",
  phone = "",
  amount = "",
  from = "",
  to = "",
  refId = ""
) => {
  return async (dispatch, store) => {
    let url = `transaction/member/invoice?page=${page}&limit=${limit}&search=${search}&phone=${phone}&amount=${amount}&from=${from}&to=${to}&refId=${encodeURIComponent(refId)}&sort=createdAt`;
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setInvoiceData(res.data.data));
          dispatch(setInvoiceCount(res.data.totalCount));
        }
      })
      .catch((err) => {});
  };
};

export const getCheckinMembers = (
  page,
  limit,
  gymId,
  search,
  sort = "createdAt desc",
  filter = ""
) => {
  let currentDate = moment().format("MM/DD/YYYY");
  let date = new Date(`${currentDate} UTC`).getTime();
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let url = search
      ? `member?gym=${gymId}&page=${page}&limit=${limit}&search=${search}&sort=${sort}&isActive=${filter}&checkInDay=${date}`
      : `member?gym=${gymId}&page=${page}&limit=${limit}&sort=${sort}&isActive=${filter}&checkInDay=${date}`;
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setMembersData(res.data.data));
          dispatch(setMemberCount(res.data.totalCount));
        }
      })
      .catch((err) => {});
  };
};
export const getCheckinMembersForExport = (
  page,
  limit,
  gymId,
  search,
  sort = "createdAt desc",
  filter = ""
) => {
  let currentDate = moment().format("MM/DD/YYYY");
  let date = new Date(`${currentDate} UTC`).getTime();
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let url = search
      ? `member?gym=${gymId}&page=${page}&limit=${limit}&search=${search}&sort=${sort}&isActive=${filter}&checkInDay=${date}`
      : `member?gym=${gymId}&page=${page}&limit=${limit}&sort=${sort}&isActive=${filter}&checkInDay=${date}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      return res.data.data;
    }
  };
};

export const getAllMembers = (gymId, memberId, withFamily = false,shared=false,search = "",shouldStoreResults = true
) => {
  return async (dispatch, store) => {
    let url = `memberAll?gym=${gymId}&exclude=${memberId}`;
    if (withFamily) url += `&withFamily=1`;
    if (shared) url += `&shared=1`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    return api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          // return res.data;
          if (shouldStoreResults) {
            dispatch(setAllMembersData(res.data.data));
          }
          return res.data.data;
        }
      })
      .catch((err) => []);
  };
};

export const getMember = (value, withLoading = false,isTransfered=false) => {
  return async (dispatch, store) => {
    if (withLoading) dispatch(setLoading(true));
    console.log("testtt",isTransfered)
    // dispatch(setloader(true));
    // await api(`member/${value.id}?pid=${pid}`, {}, "get")
    await api(`member/${value}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          if(isTransfered) return dispatch(seTransferedToMember(res.data.data));
          dispatch(setMemberInfo(res.data.data));
          dispatch(setMemberData(res.data.data));
        }
      })
      .catch((err) => {});
    dispatch(setLoading(false));
  };
};
export const activateMemberAccount = (memberId) => {
  return async (dispatch) => {
    try {
      const res = await api(`member/${memberId}/activate-account`, {}, "patch");
      if (!res || res.status >= 400 || res?.data?.status >= 400) {
        toastr.error(res?.data?.error || "Could not activate member account");
        return false;
      }
      toastr.success(res?.data?.message || "Member account activated");
      await dispatch(getMember(memberId));
      return true;
    } catch (error) {
      toastr.error(
        error?.response?.data?.error || "Could not activate member account",
      );
      return false;
    }
  };
};
export const setMemberPassword = (memberId, password) => {
  return async () => {
    try {
      const res = await api(
        `member/${memberId}/set-password`,
        { password },
        "patch",
      );
      if (!res || res.status >= 400 || res?.data?.status >= 400) {
        toastr.error(res?.data?.error || "Could not update member password");
        return false;
      }
      toastr.success(res?.data?.message || "Member password updated");
      return true;
    } catch (error) {
      toastr.error(
        error?.response?.data?.error || "Could not update member password",
      );
      return false;
    }
  };
};
export const blacklistMember = (memberId, reason) => {
  return async (dispatch) => {
    if (!memberId) return false;
    try {
      const res = await api(
        `member/${memberId}/blacklist`,
        { reason },
        "post",
      );
      if (!res || res.status >= 400 || res?.data?.status >= 400) {
        toastr.error(res?.data?.error || "Could not blacklist member");
        return false;
      }
      toastr.success(res?.data?.message || "Member blacklisted");
      await dispatch(getMember(memberId));
      return true;
    } catch (error) {
      toastr.error(
        error?.response?.data?.error || "Could not blacklist member",
      );
      return false;
    }
  };
};
export const removeMemberFromBlacklist = (memberId) => {
  return async (dispatch) => {
    if (!memberId) return false;
    try {
      const res = await api(
        `member/${memberId}/blacklist/remove`,
        {},
        "patch",
      );
      if (!res || res.status >= 400 || res?.data?.status >= 400) {
        toastr.error(
          res?.data?.error || "Could not remove member from blacklist",
        );
        return false;
      }
      toastr.success(
        res?.data?.message || "Member removed from blacklist",
      );
      await dispatch(getMember(memberId));
      return true;
    } catch (error) {
      toastr.error(
        error?.response?.data?.error ||
          "Could not remove member from blacklist",
      );
      return false;
    }
  };
};
export const checkIfMemberPaidJoinFees = (memberId) => {
  return async (dispatch, store) => {
    if (!memberId) {
      toastr.error("Missing memberId!");
      return;
    }
    await api(`member/paidJoiningFees/${memberId}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setMemberPaidJoiningFees(res.data.data));
        }
      })
      .catch((err) => {});
  };
};

export const getMemberInfo = (value) => {
  return async (dispatch, store) => {
    try {
      let res = await api(`member/${value}`, {}, "get");
      if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
        toastr.error("Something went wrong!");
        return;
      }
      dispatch(setMemberInfo(res.data.data));
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
};

export const deleteNote = ({ id, referenceType, referenceId }) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api(`member/note/${id}`, {}, "delete").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Something went wrong!");
    } else {
      toastr.success("Success:Delete Note");

      dispatch(getNotes({ referenceType, referenceId }));
    }
  };
};
export const updateNote = (data) => {
  return async (dispatch, store) => {
    let res = await api(
      `member/note/${data.id}`,
      data,
      "patch"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Something went wrong!");
    } else {
      toastr.success("Success:Update Note");

      dispatch(
        getNotes({
          referenceType: data.referenceType,
          referenceId: data.referenceId,
        })
      );
    }
  };
};

export const deleteMember = (id) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api(`member/${id}`, {}, "delete").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Something went wrong!");
    } else {
      toastr.success("Success:Delete Member");
      JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
      JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
        "TRAINER"
        ? history.push("/trainer-panel/memberslist")
        : history.goBack();
    }
  };
};

export const createSale = (
  payload,
  commingFromClass,
  comingFromAppointment,
  comingFromCourtBooking,
  timeSlot,
  comingFromPOS,
  comingFromCalendar,
  dates

) => {
  if (skipVoiceCreate(payload)) return () => {};
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(`member/membership`, payload, "post").catch((err) => {
      //console.log(err);
    });
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error(res?.response?.data?.error?.message||"Something went wrong!");
      dispatch(addSaleModal(false, false, {}));

      dispatch(setLoading(false));

      return { success: false, code: "SERVER_ERROR" };
    }
    if (res.status === 400) {
      const apiError = res?.data?.error;
      const errorMessage = apiError?.message || apiError || res?.data?.message;
      const errorCode = apiError?.code ||
        (String(errorMessage || "").includes("INSUFFICIENT_MEMBER_CREDIT")
          ? "INSUFFICIENT_MEMBER_CREDIT"
          : undefined);
      if (errorMessage) toastr.error(errorMessage);
      else toastr.error("Enter Valid data");
      dispatch(setLoading(false));
      return { success: false, code: errorCode, data: res.data };

    } else {
      toastr.success("Success:Added Sale");
      dispatch(setLoading(false));
      dispatch(addSaleModal(false, false, {}));
      // Skip redirect if coming from POS - POS handles its own state
      if (comingFromPOS) {
        return { success: true, data: res.data };
      }
      if (
        !commingFromClass &&
        !comingFromAppointment &&
        !comingFromCourtBooking &&
        !comingFromCalendar
      ) {
        dispatch(setMemberData({}));
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
          "TRAINER"
          ? history.push("/trainer-panel/memberslist")
          : history.push("/gym-panel/memberslist");
      } else if (commingFromClass) {

        dispatch(toggleSettlePaymentModal());
        if(commingFromClass.member&&commingFromClass.classId){
          dispatch(
            getMembersSupportedPackagesForClass(
              commingFromClass.member,
              commingFromClass.classId
            )
          );
        }
      
        dispatch(toggleAddingSaleFromClassInfo(false));
      } 
      else if(comingFromCalendar){
        dispatch(setLoading(false));
        dispatch(toggleSettlePaymentModal());
        if (dates && dates.startDate && dates.endDate) {
          dispatch(
            getCourtsSlotsForBookingPageView({
              startDate: dates.startDate,
              endDate: dates.endDate,
            })
          );
        }
      }
      else if (comingFromAppointment) {
        dispatch(setLoading(false));

        dispatch(
          getMembersWithAssignablePackagesByAppointment(comingFromAppointment)
        );
        dispatch(toggleSettlePaymentModal());
          dispatch(setMemberInfo({}));
         dispatch(setMemberData({}));
        if(payload?.bookingAppointmnetId){
          history.push("/gym-panel/memberslist")        }
      }else if(comingFromCourtBooking){
        console.log("here court",{comingFromCourtBooking})
          dispatch(toggleSettlePaymentModal());
          dispatch(
          getMembersWithAssignablePackagesBySlot(
            timeSlot
          )
        );
         dispatch(setMemberInfo({}));
         dispatch(setMemberData({}));
      }
      return { success: true, data: res.data };
    }
  };
};
export const updateSalePayment = (
  payload,

) => {
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    console.log({payload})

    let res = await api(`sale/update/payment`, payload, "patch").catch((err) => {
      //console.log(err);
    });
    const status = res && (res.status || (res.response && res.response.status));
    if (!res || String(status).startsWith("5")) {
      toastr.error("Something went wrong!");
      dispatch(setLoading(false));
      return;
    }
    if (status === 400 || status === 404) {
      const errorMessage =
        (res.data && res.data.error) ||
        (res.response && res.response.data && res.response.data.error);
      if (errorMessage) toastr.error(errorMessage);
      else toastr.error("Enter Valid data");
      dispatch(setLoading(false));
    } else {
      toastr.success("Success:Updated Sale");
      dispatch(setLoading(false));
      console.log({payload})
      if(payload?.type==="purchase-product"){
        dispatch(
          getMemberTabsInfo({
            params: "purchasesdProducts",
            page: store().member.dataPage,
            limit: store().member.dataLimit,
            query: "",
            member: payload.member,
          })
        );
      }
      if(payload?.type==="purchase"){
        dispatch(
          getMemberTabsInfo({
            params: "purchases",
            page: store().member.dataPage,
            limit: store().member.dataLimit,
            query: "",
            member: payload.member,
          })
        );
      }
    }
  };
};
export const getGymCategories = (
  payload,

) => {
  return async (dispatch, store) => {

    let res = await api(`gym/categories`, {}, "get").catch((err) => {
      //console.log(err);
    });
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("Enter Valid data");
    } else {
   
    dispatch(setGymCategories(res.data.data))
    }
  };
};

export const shareMemberSale = (
  payload,

) => {
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    console.log({payload})

    let res = await api(`sale/share`, payload, "post").catch((err) => {
      //console.log(err);
    });
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      dispatch(setLoading(false));

      return;
    }
    if (res.status === 400||res.status ===404) {
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("Enter Valid data");
      dispatch(setLoading(false));

      return
    } else {
      toastr.success("Success:Shared Sale");
      dispatch(setLoading(false));
      console.log({payload})
      if(payload?.type==="purchase-product"){
        dispatch(
          getMemberTabsInfo({
            params: "purchasesdProducts",
            page: store().member.dataPage,
            limit: store().member.dataLimit,
            query: "",
            member: payload.member,
          })
        );
      }

    }
  };
};
export const getSharedWithSubscriptions = (
saleId
) => {
  return async (dispatch, store) => {
    // dispatch(setLoading(true));

    let res = await api(`shared/subscriptions/${saleId}`, {}, "get").catch((err) => {
      //console.log(err);
    });
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      // dispatch(setLoading(false));

      return;
    }
    if (res.status === 400||res.status ===404) {
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("Enter Valid data");
      // dispatch(setLoading(false));

      return
    } else {
      // dispatch(setLoading(false));
      console.log({data: res.data.data});
      dispatch(setSharedWithSubscriptions(res?.data?.data?._sharedSubscriptions,res?.data?.data?.mainSubscription));
     
    }
  };
};
export const createProductSale = (payload) => {
  if (skipVoiceCreate(payload)) return () => {};
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(`member/product`, payload, "post").catch((err) => {
      //console.log(err);
    });
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("Enter Valid data");
    } else {
      toastr.success("Success:Added Product Sale");
      dispatch(setLoading(false));
    }
  };
};
export const upgradeSale = ({ payload, msp, oldPackage, remainingId }) => {
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(
      `member/upgradeSubscription/${msp}/${oldPackage}/${remainingId}`,
      payload,
      "post"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      dispatch(setLoading(false));
      return;
    }
    if (res.status === 400 || res.status == 404) {
      dispatch(setLoading(false));
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("Enter Valid data");
    } else {
      toastr.success("Success:Upgraded Sale");
      dispatch(setLoading(false));
      dispatch(
        getMemberTabsInfo({
          params: "purchases",
          page: store().member.dataPage,
          limit: store().member.dataLimit,
          query: "",
          member: payload.user.value,
        })
      ); // dispatch(addSaleModal(false, false, {}));
    }
  };
};
export const transferSaleV2 = ({ payload, msp,remainingId }) => {
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(
      `member/transeferSubscription/${msp}/${remainingId}`,
      payload,
      "post"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      dispatch(setLoading(false));
      return;
    }
    if (res.status === 400 || res.status == 404) {
      dispatch(setLoading(false));
      if (res?.data?.message) toastr.error(res.data.message);
      else toastr.error("Enter Valid data");
    } else {
      toastr.success("Success:Transfered Sale");
      dispatch(setLoading(false));
      dispatch(
        getMemberTabsInfo({
          params: "purchases",
          page: store().member.dataPage,
          limit: store().member.dataLimit,
          query: "",
          member: payload.member,
        })
      ); // dispatch(addSaleModal(false, false, {}));
    }
  };
};
export const voidSubscriptionWithReason = ({ payload, msp }) => {
  return async (dispatch, store) => {
    try {
    dispatch(setCommonLoading(true));
    let res = await api(
      `member/voidSubscriptionWithReason/${msp}`,
      payload,
      "post"
    ).catch((err) => {});
    let response  = res
    console.log({res})
    if (String(response.data.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (
      response.data.status === 400 ||
      response.data.status == 404
    ) {
      if (response.data.error) toastr.error(res.data.error);
      else toastr.error("Enter Valid data");
    } else {
      toastr.success("Success:Voided Sale");
      dispatch(setLoading(false));
      dispatch(
        getMemberTabsInfo({
          params: "purchases",
          page: store().member.dataPage,
          limit: store().member.dataLimit,
          query: "",
          member: payload.member,
        })
      ); // dispatch(addSaleModal(false, false, {}));
    }
    } catch (error) {
      
    }finally {
      dispatch(setCommonLoading(false))

    
    }

  };
};

export const updateMemberSubscriptionPackage = ({ id, data }) => {
  return async (dispatch, store) => {
    let url = `memberSubscriptionPackage/${id}`;
    let updatedOne = await api(url, data, "patch");
    if (updatedOne.status === 200)
      toastr.success("Success:Updated subscription");
    else toastr.error(updatedOne.message);
  };
};
export const setFreezeRules = (value) => {
  return async (dispatch, store) => {
    let url = `package/${value.id}/setFreezeRules`;
    let updatedOne = await api(url, value, "patch");
    if (updatedOne.status === 200) {
      toastr.success("Success:Added Freeze Rules");
      // dispatch(getPackageById())
    } else toastr.error(updatedOne.message);
  };
};

export const addNote = (data) => {
  return async (dispatch, store) => {
    let url = `member/note`;
    let note = await api(url, data, "post");
    if (note.data.status === 200) {
      toastr.success(note.data.message);
      dispatch(getNotes(data));
    } else toastr.error(note.message);
  };
};
export const getNotes = (data) => {
  return async (dispatch, store) => {
    let { referenceType, referenceId,isImportant } = data;
    let url = `member/note?referenceType=${referenceType}&referenceId=${referenceId}`;
    if(isImportant) url+=`&isImportant=true`
    if (data.limit) url += `&limit=${data.limit}`
    let note = await api(url, data, "get");
    if (note.data.status === 200) dispatch(setNotes(note.data.data));
    else toastr.error(note.message);
  };
};
export const getMembersPurchasedProducts = ({ member }) => {
  return async (dispatch, store) => {
    let url = `member/purchasedProducts/${member}`;
    let note = await api(url, {}, "get");
    if (note.data.status === 200)
      dispatch(setPurchasedProducts(note.data.data));
  };
};
export const confirmRecieveProduct = (product, transferedId) => {
  return async (dispatch, store) => {
    let url = `product/confirm/${product.id}/${transferedId}`;
    await api(url, {}, "patch")
      .then((res) => {
        console.log({res})
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          if (res?.data?.error) toastr.error(res.data.error);
          else toastr.error("Something went wrong!");
           return;
        } else {
              dispatch(getProductHistory(product.id));
              dispatch(getProducts({ limit: 10, page: 1 }));
              return res.data?.data;
        }
      })
      .catch((err) => {
        toastr.error("Something went wrong!");
      })


  };
};
export const rejectRecieveProduct = (product, transferedId, body) => {
  return async (dispatch, store) => {
    let url = `product/reject/${product.id}/${transferedId}`;

    let data = await api(url, body, "patch");
    dispatch(getProductHistory(product.id));
    dispatch(getProducts({ limit: 10, page: 1 }));

    return data?.data;
  };
};

export const getLastPlanStatus = async (id) => {
  let url = `member/${id}/lastplan`;
  let member = await api(url, {}, "get");
  if (member.status === 200) {
    let isRejoin = member.data.data.isRejoin;
    if (isRejoin) {
      return "REJOIN";
    } else {
      return "RENEW";
    }
  } else {
    return "RENEW";
  }
};

export const createMember = (value) => {
  if (skipVoiceCreate(value)) return () => {};
  const rest = buildMemberCreatePayload(value);

  return async (dispatch, store) => {
    dispatch(setLoading(true));
    try {
      let res = await api(`member`, rest, "post");
      if (res.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          setExistingMember({
            ...res.data.data,
            canAddToGym: res.data.canAddToGym,
            alreadyInCurrentGym: res.data.alreadyInCurrentGym,
            existsInAnotherBranch: res.data.existsInAnotherBranch,
            existingMemberMessage: res.data.message,
          })
        );
        dispatch(setShowExistingMemberModal(true));
      } else if (res?.response?.data?.status === 409) {
        console.log("trgier")
        dispatch(setLoading(false));
        dispatch(setExistingMember(res?.response?.data?.data));
        dispatch(setShowDeletedMemberModal(true));
      } else if (res.status !== 201) {
        dispatch(setLoading(false));
        if (res?.data?.error) toastr.error(res.data.error);
        else toastr.error("Enter Valid data");
      }else {
        toastr.success("Success:Added Member");
        dispatch(setLoading(false));
        const member = res.data.data;
        dispatch(setMemberData(member));
        dispatch(addUserModal(false));
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
          "TRAINER"
          ? history.push("/trainer-panel/memberslist")
          : history.push("/gym-panel/memberslist");
  
        dispatch(addSaleModal(true));
      }
    } catch (error) {
      const _error = typeof error == "string" ? error : JSON.stringify(error);
      toastr.error(`Error:: ${_error}`);
    }
  };
};
export const createTrainerAsMember = (value) => {
  console.log({ value });

  let rels;
  const { relations, dob, ...rest } = value;
  if (!rest.lastName) rest.name = rest.firstName;
  else rest.name = `${rest.firstName} ${rest.lastName}`;
  rest.relations = [rels];
  console.log({ value });
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(
      `trainer/${value.trainerId}/AsMember`,
      rest,
      "post"
    ).catch((err) => {});
    if (res.status !== 201) {
      toastr.error("Error in Add Instructor As Member");
    } else {
      toastr.success("Success:Added Instructor As Member");
    }
  };
};
export const createProduct = (payload) => {
  if (skipVoiceCreate(payload)) return () => {};
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(`product`, payload, "post").catch((err) => {});
    if (res.status !== 201) {
      dispatch(setLoading(false));
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("Enter Valid data");
    } else {
      toastr.success("Success:Added Product");
      dispatch(setLoading(false));
      dispatch(setRetailModal(false));
      dispatch(getGym(res.data.data.gym));

      history.push("/gym-panel/services/retail");
    }
  };
};
export const purchaseProduct = (payload) => {
  console.log({ payload });
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(`purchase/product`, payload, "post").catch((err) => {});
    if (res.status !== 201) {
      dispatch(setLoading(false));
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("Enter Valid data");
    } else {
      toastr.success("Success:Product Purchased");
      dispatch(setLoading(false));
      dispatch(getProducts({ limit: 10, page: 1 }));
      return res.data.data;
      // dispatch(setRetailModal(false))
      // dispatch(getGym(res.data.data.gym));

      // history.push("/gym-panel/services/retail")
    }
  };
};
export const getProductHistory = (payload) => {
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(
      `product/history/${payload}?limit${
        store().product.productHistoryLimit
      }&page=${store().product.productHistoryPage}`,
      payload,
      "get"
    ).catch((err) => {});
    if (res.status !== 200) {
      dispatch(setLoading(false));
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("Enter Valid data");
    } else {
      dispatch(setLoading(false));
      dispatch(setProductHistory(res.data.data));
      dispatch(setProductHistoryCount(res.data.totalCount));
    }
  };
};

export const createGymMember = (value) => {
  if (skipVoiceCreate(value)) return () => {};
  return async (dispatch, store) => {
    dispatch(setLoading(false));
    await api(`member/gym`, value, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          if (res?.data?.error) toastr.error(res.data.error);
          else toastr.error("Something went wrong!");
          dispatch(setShowExistingMemberModal(false));
          dispatch(addUserModal(false));
        } else {
          dispatch(setShowExistingMemberModal(false));
          dispatch(getMember(res.data.data.member));
          dispatch(addUserModal(false));
          toastr.success("Suceess:Member Added");
          dispatch(setLoading(false));
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
            "TRAINER"
            ? history.push("/trainer-panel/memberslist")
            : history.push("/gym-panel/memberslist");
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(addSaleModal(true));
      });
  };
};
export const undoDeletionMemberApi = (value) => {
  return async (dispatch, store) => {
    dispatch(setLoading(false));
    await api(`undo/deletion/member/gym/${value}`, {}, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          if (res?.data?.error) toastr.error(res.data.error);
          else toastr.error("Something went wrong!");
          dispatch(setShowDeletedMemberModal(false));
          dispatch(addUserModal(false));
        } else {
          dispatch(setShowDeletedMemberModal(false));
          toastr.success("Suceess:Member Undo Deletion ");
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
            "TRAINER"
            ? history.push("/trainer-panel/memberslist")
            : history.push("/gym-panel/memberslist");
        }
      })
      .catch((err) => {})
     
  };
};
export const deleteMemberApi = (value) => {
  return async (dispatch, store) => {
    dispatch(setLoading(false));
    await api(`member/delete/${value}`, {}, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          if (res?.data?.error) toastr.error(res.data.error);
          else toastr.error("Something went wrong!");
          dispatch(setShowDeletedMemberModal(false));
        } else {
          dispatch(setShowDeletedMemberModal(false));
          toastr.success("Suceess:Member Deleted");
          dispatch(setLoading(false));
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
            "TRAINER"
            ? history.push("/trainer-panel/memberslist")
            : history.push("/gym-panel/memberslist");
        }
      })
      .catch((err) => {})
      
  };
};
export const updateMember = (value) => {
  return async (dispatch) => {
    await api(`member/${value.id}`, value, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          if (res?.data?.error) toastr.error(res.data.error);
          else toastr.error("Something went wrong!");
        }else if(res?.response?.data?.status==409){
          toastr.error(res?.response?.data.message)
        } else if(res.status==423){
          toastr.error(res?.response?.data.message)
          dispatch(setExistingMember(res?.response?.data.data));
          dispatch(setShowDeletedMemberModal(true));
        }else {
          dispatch(setMemberData(res.data.data));
          const updatedMemberId = res?.data?.data?.id || value.id;
          dispatch(getMemberInfo(updatedMemberId));
          toastr.success("Suceess:Member Update");
          history.push(`/gym-panel/membersinfo/${updatedMemberId}`);
        }
      })
      .catch((err) => {});
  };
};

export const updateMemberSignedConsent = (memberId, signContest) => {
  return async (dispatch, store) => {
    try {
      const res = await api(
        `member/${memberId}/signed-consent`,
        { signContest },
        "patch"
      );
      if (!res || res.status >= 400) {
        toastr.error(
          res?.data?.message || res?.data?.error || "Unable to update signed consent"
        );
        return null;
      }
      const currentMember = store().member.memberInfo;
      const responseMember = res?.data?.data || {};
      const updatedMember = {
        ...(currentMember?.id === memberId ? currentMember : {}),
        ...responseMember,
        id: responseMember.id || memberId,
        metaData: {
          ...(currentMember?.id === memberId ? currentMember.metaData : {}),
          ...responseMember.metaData,
          signContest,
        },
      };

      if (currentMember?.id === memberId) {
        dispatch(setMemberInfo(updatedMember));
      }

      toastr.success(res?.data?.message || "Signed consent updated");
      return updatedMember;
    } catch (error) {
      toastr.error(
        error?.response?.data?.message || "Unable to update signed consent"
      );
      return null;
    }
  };
};

export const updateMemberCheckin = (id, packageClass, classId,classBookingId,dates) => {
  return async (dispatch, store) => {
    try {
      const res = await api(
        `member/${id}/classCheckin/${packageClass}?classId=${classId}`,
        {classBookingId},
        "post"
      );
      if (res.status !== 201) {
        if(res?.data?.data?.error) return toastr.error(res?.data?.data?.error)
        else return toastr.error("Declined", "Member already checked in")  
      } else {
        dispatch(setMembersCheckinData(res.data.data));
        toastr.success(res.data.message);
        if(dates){
          const startDate=dates.startDate||moment(new Date())
          .startOf("day")
          .valueOf()
          const endDate=dates.endDate|| moment(new Date())
                .endOf("day")
                .valueOf()
          dispatch(
            getCourtsSlotsForBookingPageView({
              startDate,
              endDate,
            })
          );
        }
        else dispatch(getClass(classId));
        return res.status;
        // history.push('/gym-panel/memberslist');
      }
    } catch (e) {
      toastr.error("Declined", "Member already checked in");
    }
  };
};
export const unCheckinMember = (id, packageClass, classId,checkInId,dates) => {
  return async (dispatch, store) => {
    try {
      let url=`member/${id}/uncheckInClass/${packageClass}?classId=${classId}`
      if(checkInId) url+=`&checkInId=${checkInId}`
      const res = await api(
        url,
        {},
        "post"
      );
      if (res.status !== 201) {
        if (res?.data?.error) toastr.error(res.data.error);
        else toastr.error("Something went wrong!");
      } else {
        dispatch(setMembersCheckinData(res.data.data));
        toastr.success(res.data.message);
        if(dates){
          const startDate=dates.startDate||moment(new Date())
          .startOf("day")
          .valueOf()
          const endDate=dates.endDate|| moment(new Date())
                .endOf("day")
                .valueOf()
          dispatch(
            getCourtsSlotsForBookingPageView({
              startDate,
              endDate,
            })
          );
        } else dispatch(getClass(classId));
        return res.status;
        // history.push('/gym-panel/memberslist');
      }
    } catch (e) {
      toastr.error("Declined", "Member already checked in");
    }
  };
};
export const changePassword = (value) => {
  let id = JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).id;
  let data = {
    oldpassword: value.oldPassword,
    newpassword: value.newPassword,
  };
  return async (dispatch, store) => {
    await api(`changePassword/${id}`, data, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setWodsData(res.data.data));
          toastr.success("Password Updated Successfully");
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
            "TRAINER"
            ? history.push("/trainer-panel/trainerinfo")
            : history.push("/gym-panel/gyminfo");
        }
      })
      .catch((err) => {});
  };
};

export const getWod = (id) => {
  return async (dispatch, store) => {
    await api(`wod/${id}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setWodData(res.data.data));
        }
      })
      .catch((err) => {});
  };
};
export const deleteWod = (id) => {
  return async (dispatch, store) => {
    let res = await api(`wod/${id}`, {}, "delete").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Something went wrong!");
    } else {
      toastr.success("Success:Delete Wod");
      history.push("/gym-panel/wod");
    }
  };
};

export const updateWod = (id, value) => {
  return async (dispatch, store) => {
    await api(`wod/${id}`, value, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(
            toastr.success("Suceess:Wod Update")
          );
          const interval = setTimeout(() => {
            dispatch(setMessageData({}));
          }, 5000);
          history.push("/gym-panel/wod");
        }
      })
      .catch((err) => {});
  };
};

export const createWod = (value) => {
  if (skipVoiceCreate(value)) return () => {};
  return async (dispatch, store) => {
    await api(`wod`, value, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          toastr.success("Success: Added WOD");
          dispatch(addWodModal(false));

          history.push("/gym-panel/wod");
        }
      })
      .catch((err) => {
      });
  };
};

export const createPackage = (value) => {
  if (skipVoiceCreate(value)) return () => {};
  //console.log(value);
  return async (dispatch, store) => {
    let res = await api(`package`, value, "post").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Something went wrong!");
    } else {
      // dispatch(addTrainerModal(false));
      toastr.success("Success:Add Pakcage");
      dispatch(addPackageModal(false, false, {}));
      const loginUser = JSON.parse(
        localStorage.getItem("connectToFitGymPanelUser")
      );
      if (loginUser?.role === "TRAINER") {
        dispatch(getPackages(1, 1000, true));
        if (!isVoiceSessionActive()) history.push("/trainer-panel/packages");
      } else {
        dispatch(getPackages(1, 1000, true));
        dispatch(getPackages(1, 1000, false));
        if (!isVoiceSessionActive()) history.push("/gym-panel/packages");
      }
    }
  };
};

export const getPackages = (
  page,
  limit,
  type,
  search,
  trainerId = "",
  planType,
  isLinked = "",
  upgrade = false,
  unlimited = false,
  gender = "",
  name = ""
) => {
  //console.log('get packages');
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let url = search
      ? `package?page=${page}&limit=${limit}&isLinked=${isLinked}&search=${search}${
          type !== undefined ? "&isActive=" + type : ""
        }`
      : `package?page=${page}&limit=${limit}&isLinked=${isLinked}&trainer=${trainerId}${
          type !== undefined ? "&isActive=" + type : ""
        }`;
    if (planType) url = url + `&planType=${planType}`;
    if (upgrade) url = url + `&upgradeUp=${upgrade}`;
    if (unlimited) url = url + `&unlimited=${unlimited}`;
    if (gender) url = url + `&gender=${gender}`;
    if (name) url = url + `&name=${name}`;

    console.log(url);
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Operation canceled due to new request.");
    }
    // Create a new CancelToken source
    cancelTokenSource = generateCancelTokenSource();
    try {
      const res = await api(url, {}, "get", null, cancelTokenSource.token);
      if (res) {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("Some error occurred");
        } else {
              // console.log("get packages", res.data.data);
            dispatch(setPackagesData(res.data.data));
            dispatch(setPackageCount(res.data.totalCount));
            return res.data.data;
        }
      }
    } catch (err) {
      console.error(err);
      if (isCancelAxios(err)) {
        console.log("Request canceled", err.message);
      } else {
        // Handle error
        toastr.error("An error occurred while fetching data");
      }
    }
  };
};
export const getIsLinkedPackages = (
  page,
  limit,
  type,
  isLinked,
  planType,
  upgrade,
  unlimited,
  gender,
  name
) => {
  // Call the original function with the new parameter
  return getPackages(
    page,
    limit,
    type,
    null,
    "",
    planType,
    isLinked,
    upgrade,
    unlimited,
    gender,
    name
  );
};
export const getPotentialPackagesByService = (
 {planType,serviceId,numberOfPlayers=1,trainerId,forMatch,bookingCourtId,matchCapacity}
) => {
return async (dispatch, store) => {
    // dispatch(setloader(true));
    let url = `potential/packages/list`; 
    const params = [];
    if (planType) {
      params.push(`planType=${encodeURIComponent(planType)}`);
    }
    if (forMatch) {
      params.push("forMatch=1");
    }
    if (matchCapacity) {
      params.push(`matchCapacity=${encodeURIComponent(matchCapacity)}`);
    }
    if (bookingCourtId) {
      params.push(`bookingCourtId=${encodeURIComponent(bookingCourtId)}`);
    }
    if (numberOfPlayers) {
      params.push(`numberOfPlayers=${encodeURIComponent(numberOfPlayers)}`);
    }
    if (serviceId) {
      params.push(`serviceId=${encodeURIComponent(serviceId)}`);
    }
    if(trainerId){
       params.push(`trainerId=${encodeURIComponent(trainerId)}`);

    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    try {
      const res = await api(url, {}, "get");
      if (res) {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error(
            res?.data?.message || res?.data?.error || "Some error occurred"
          );
          return [];
        } else {
              // console.log("get packages", res.data.data);
            dispatch(setPackagesData(res.data.data));
            dispatch(setPackageCount(res.data.totalCount));
            return res.data.data;
        }
      }
    } catch (err) {
      console.error(err);
    
        toastr.error("An error occurred while fetching data");
    }
  };
};
export const getUpgradedToPackages = ({
  packageId,
  planType,
  upgrade,
  unlimited,
  upgradeDuration,
  gender,
  price,
  numberOfPlayers
}) => {
  // Call the original function with the new parameter
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let url = `upgrade/package/${packageId}?planType=${planType}&upgradeUp=${upgrade}&unlimited=${unlimited}&upgradeDuration=${upgradeDuration}&gender=${gender}&price=${price}`;
    if(numberOfPlayers) url+= `&numberOfPlayers=${numberOfPlayers}`
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          // console.log("get packages", res.data.data);

          dispatch(setPackagesData(res.data.data));
          dispatch(setPackageCount(res.data.totalCount));
        }
      })
      .catch((err) => {});
  };
};

export const getPackage = (id) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`package/${id}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setPackage(res.data.data));
        }
      })
      .catch((err) => {});
  };
};
export const getPackageById = (id) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`package/get/${id}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          console.log({ res });
          dispatch(setPackageData(res.data.data));
        }
      })
      .catch((err) => {});
  };
};
export const updatePackage = (value, id, isActive = true) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`package/${id}`, value, "patch")
      .then(async (res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error(res?.data?.error || "some error occured");
        } else {
          if (value.planType === "pt") {
            const sharingResponse = await api(
              `package/${id}/pt-sharing`,
              {
                isSharedPackage: Boolean(value.isSharedPackage),
                sharedBranches: value.sharedBranches || [],
                sharedAppointmentMappings:
                  value.sharedAppointmentMappings || [],
              },
              "patch"
            );
            if (sharingResponse?.status >= 400) {
              toastr.error(
                sharingResponse?.data?.error || "Unable to update PT sharing"
              );
              return;
            }
          }
          // dispatch(
          // setMessageData({
          //   type: 'success',
          //   message: 'Wod updated successfully',
          // })
          toastr.success("Suceess:Package Update");
          dispatch(getPackages(1, 1000, isActive))
          // );
          // await dispatch(getPackages(1, 1000000, ""));
          await dispatch(addPackageModal(false, false, {}));
          // JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
          // JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
          //   "TRAINER"
          //   ? history.push("/trainer-panel/packages")
          //   : history.push("/gym-panel/packages");
          // dispatch(setPackage({}));
          // getPackages(
          //   1,
          //   10000,
          //   JSON.parse(localStorage.getItem('connectToFitGymPanelUser')).gym,
          //   ''
          // );

          // const interval = setTimeout(() => {
          //   dispatch(setMessageData({}));
          // }, 5000);
          // history.push('gym-panel/packages');
        }
      })
      .catch((err) => {});
  };
};

export const deletePackage = (id) => {
  return async (dispatch, store) => {
    let res = await api(`package/${id}`, {}, "delete").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Something went wrong!");
    } else {
      toastr.success("Success:Delete Package");
    }
  };
};

// class
export const createClass = (value) => {
  if (skipVoiceCreate(value)) return () => {};
  return async (dispatch, store) => {
    dispatch(setLoading(true));

    let res = await api(`class/test`, value, "post").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      dispatch(setLoading(false));
      return;
    }
    if (res.status === 400) {
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error(res.data?.message||"You have not entered Proper Data");
    } else {
      dispatch(addPrivateModal(false));
      dispatch(addWorkshopModal(false));
      toastr.success("Success:Service Added Successfully");
      if (!isVoiceSessionActive()) {
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
          "TRAINER"
          ? history.push("/trainer-panel/appointments")
          : history.push("/gym-panel/services");
      }
    }
    dispatch(setLoading(false));

  };
};

// class
export const updateClassByGroupId = (value) => {
  return async (dispatch, store) => {
    let res = await api(
      `class/updateByGroupId/${value.groupId}`,
      value,
      "patch"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error(res.data?.message||"You have not entered Proper Data");
    } else {
      toastr.success("Success:Update Service");
      console.log({resssssssss:res?.data})
      if(res?.data?.skippedClasses.length){
    // ✅ Show each individual error as a warning toast
            if (Array.isArray(res?.data?.skippedClasses) && res?.data?.skippedClasses.length > 0) {
              res.data.skippedClasses.forEach((_class) => {
                toastr.warning(`Session on ${moment(_class.classTime).format("DD/MM/YYYY:H:mm")} not updated due to ${_class.reason}`, 
                "", { timeOut: 30000 }); // ⏱️ 8 seconds
              });
            }
      }
      else{
   JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
      JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
        "TRAINER"
        ? history.push("/trainer-panel/appointments")
        : history.push("/gym-panel/services");
      }
   
    }
  };
};
export const updateOnlineBookings = (value) => {
  return async (dispatch, store) => {
    let res = await api(
      `classes/updateOnlineBookings`,
      value,
      "patch"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("You have not entered Proper Data");
    } else {
      toastr.success("Success:Update Online Bookings");
      await dispatch(
        getGym(JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym)
      );

      JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
      JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
        "TRAINER"
        ? history.push("/trainer-panel/appointments")
        : history.push("/gym-panel/services");
    }
  };
};
export const hideClasses = (value) => {
  return async (dispatch, store) => {
    let res = await api(
      `classes/hide`,
      {},
      "patch"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("You have not entered Proper Data");
    } else {
      toastr.success("Success:Classes Have been hidden");
      await dispatch(
        getGym(JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym)
      );

      JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
      JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
        "TRAINER"
        ? history.push("/trainer-panel/appointments")
        : history.push("/gym-panel/services");
    }
  };
};

export const createAppointment = (value) => {
  if (skipVoiceCreate(value)) return () => {};
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(`appointment`, value, "post").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      dispatch(setLoading(false));

      return;
    }
    if (res.status === 400) {
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("You have not entered Proper Data");
    } else {
      dispatch(addAppointmentModal(false));
      !store().sidebar["servicesModal"] && dispatch(addServiceModal(false));
      dispatch(setLoading(false));
      toastr.success("Success:Add Appointment");
      JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
      JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
        "TRAINER"
        ? history.push("/trainer-panel/appointments")
        : history.push("/gym-panel/services/appointments");
    }
  };
};

export const getClasses = (page, limit, gymId, search, courtSlot, from, to) => {
  return async (dispatch, store) => {
    let url = `class?gym=${gymId}&page=${page}&limit=${limit}`;
    if (search) {
      url += `&search=${search}`;
    }
    if (courtSlot) {
      url += `&courtSlot=${courtSlot}`;
    }
    if (from && to) {
      url += `&from=${from}&to=${to}`;
    }

    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setClassesData(res.data.data));
      dispatch(setClassCount(res.data.totalCount));
    }
  };
};
export const getAppointments = (limit, page, gym, court,courtType,instructor,isArchived) => {
  return async (dispatch, store) => {
    let url = "appointment";
    let query=[]
    if (court) {
      query.push(`court=${encodeURIComponent(JSON.stringify(court))}`);
    }

    if (courtType) {
      query.push(`coachingType=${courtType}`);
    }
    if(instructor){
      query.push(`trainerId=${instructor}`)
    }
    if(isArchived){
      query.push(`isArchived=${true}`)
    }
    if (query.length) {
      url += "?" + query.join("&");
    }
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setAppointments(res.data.data));
    }
  };
};
export const getMemberSubscriptionsForDeduction = ({bookingId,service}) => {
  return async (dispatch, store) => {
    let url = `booking/activeSubscriptions?service=${service}&bookingId=${bookingId}`;

    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setActiveMemberSubscriptionsForDudction(res.data.data));
      return res.data.data
    }
  };
};
export const deductPackage = ({bookingId,service,memberSubscription,dates,action}) => {
  return async (dispatch, store) => {
    let url = `booking/deductPackage`;

    let res = await api(url,{bookingId,service,memberSubscription}, "post").catch((err) => err);
    const status = res?.status || res?.response?.status;
    if (!res || !service || !bookingId || status >= 400) {
      toastr.error(
        res?.data?.error ||
          res?.data?.message ||
          res?.response?.data?.error ||
          res?.response?.data?.message ||
          "Something went wrong!"
      );
      dispatch(toggleDeductFromPackageModal(false));
      return;
    }
    const deductedMessage = res?.data?.message;
    toastr.success(
      deductedMessage && deductedMessage !== "Booking updated successfully"
        ? deductedMessage
        : "Deduct Package successfully",
    )
    if (dates?.startDate && dates?.endDate) {
      const requestObj = dates?.trainer
      ? {
          startDate: dates?.startDate,
          endDate: dates?.endDate,
          trainer: dates?.trainer,
        }
      : { startDate: dates?.startDate, endDate: dates?.endDate };
      dispatch(getCourtsSlotsForBookingPageView(requestObj));
    }
    if(action){
      dispatch(getDataAgain({action:action,status:true}))

    }
    dispatch(toggleDeductFromPackageModal(false))
  };
};

export const getProducts = (data) => {
  return async (dispatch, store) => {
    dispatch(setProductLoading(true))
    let url = `products?limit=${
      data.limit ? data.limit : store().product.productsLimit
    }&page=${data.page ? data.page : store().product.productsPage}`;
    if (data?.supplier) {
      url += `&supplier=${data?.supplier}`;
    }
    if (data?.category) {
      url += `&category=${data?.category}`;
    }
    if (data?.available) {
      url += `&available=${data?.available}`;
    }
    if (data?.availablQuantity) {
      url += `&availablQuantity=${data?.availablQuantity}`;
    }

    if (data?.search) {
      url += `&name=${data?.search}`;
    }
    if (data?.price) {
      url += `&price=${data?.price}`;
    }
    if (data?.searchBarcode) {
      url += `&barcode=${data?.searchBarcode}`;
    }
    if (data?.dateFilter && data?.dateFilter?.startDate) {
      url += `&startDate=${data?.dateFilter?.startDate}`;
    }
    if (data?.dateFilter && data?.dateFilter?.endDate) {
      url += `&endDate=${data?.dateFilter?.endDate}`;
    }
    if(data.filterByNeededActions){
      url+=` &filterByNeededActions=true`
    }
    let res = await api(url, data, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setProducts(res.data.data));
      //skip transfer history call for POS system
      if (!data?.skipTransferHistory) {
        dispatch(getTransferedHistoryForProducts())
      }
      if (data?.available || data.availablQuantity)
        dispatch(setAvailableProducts(res.data.data));
      dispatch(setProductsCount(res.data.totalCount));
    }
    dispatch(setProductLoading(false))

  };
};
export const getTransferedHistoryForProducts = (data) => {
  return async (dispatch, store) => {
    let url = `transferedproducts`;

    let res = await api(url, data, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setTransferefProductsHistory(res.data.data))
    }
  };
};

export const getProductById = (id) => {
  return async (dispatch, store) => {
    let url = `product/${id}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (res.status !== 200) {
      toastr.error("some error occured");
    } else {
      console.log(res.data.data);
      dispatch(setProduct(res.data.data));
    }
  };
};
export const deactivateProduct = (id) => {
  return async (dispatch, store) => {
    let url = `product/deactivate/${id}`;
    let res = await api(url, {}, "patch").catch((err) => {});
    if (res.status !== 200) {
      toastr.error("some error occured");
    } else {
      toastr.success("Success:Deactivated Product");
      dispatch(getProducts({ limit: 10, page: 1 }));
    }
  };
};
export const activateProduct = (id) => {
  return async (dispatch, store) => {
    let url = `product/activate/${id}`;
    let res = await api(url, {}, "patch").catch((err) => {});
    if (res.status !== 200) {
      toastr.error("some error occured");
    } else {
      toastr.success("Success:Activated Product");
      dispatch(getProducts({ limit: 10, page: 1 }));
    }
  };
};
export const updateProduct = (id, values) => {
  return async (dispatch, store) => {
    let url = `product/${id}`;
    let res = await api(url, values, "patch").catch((err) => {});
    if (res.status !== 200) {
      toastr.error("some error occured");
    } else {
      toastr.success("Success:Updated Product");
      dispatch(getProducts({ limit: 10, page: 1 }));
      dispatch(setProductEdit(false));
    }
  };
};
export const getAppointmentById = (id) => {
  return async (dispatch, store) => {
    let url = `appointment/${id}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setSingleAppointment(res.data.data));
    }
  };
};
export const updateAppointment = (data,id) => {
  return async (dispatch, store) => {
    let url = `appointment/${id}`;
    let res = await api(url, data, "patch").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      toastr.success("Appointment Updated");
      dispatch(setSingleAppointment(res.data.data));
      history.push(`/gym-panel/services/appointments/${id}`)
    }
  };
};

export const getUniqueSuppliers = () => {
  return async (dispatch, store) => {
    let url = "products/unique/suppliers";
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setSuppliers(res.data.data));
    }
  };
};
export const getProductExpiryDates = ({ id }) => {
  return async (dispatch, store) => {
    console.log(store().product.productExpiryDatesLimit);
    let url = `product/expiryDates/${id}?limit=${
      store().product.productExpiryDatesLimit
    }&page=${store().product.productExpiryDatesPage}`;

    let res = await api(url, {}, "get").catch((err) => {});
    if (res.status !== 200) {
      toastr.error("some error occured");
    } else {
      dispatch(setProductExpiryDates(res.data.data));
      dispatch(setProductExpiryDatesCount(res.data.totalCount));
    }
  };
};

export const getMembersWithAssignablePackagesByAppointment = (
  id,
  trainer,
  numberOfPlayers,
  search = "",
  shouldStoreResults = true
) => {
  return async (dispatch, store) => {
    let url = `appointment/getAssociatedMembers/${id}`; 
    const params = [];
    if (trainer) {
      params.push(`trainer=${encodeURIComponent(trainer)}`);
    }
    if (numberOfPlayers) {
      params.push(`numberOfPlayers=${encodeURIComponent(numberOfPlayers)}`);
    }
    if (search) {
      params.push(`search=${encodeURIComponent(search)}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    if (memberSearchCancelTokenSource) {
      memberSearchCancelTokenSource.cancel(
        "Operation canceled due to new request."
      );
    }
    // Create a new CancelToken source
    memberSearchCancelTokenSource = generateCancelTokenSource();
    let res = await api(
      url,
      {},
      "get",
      null,
      memberSearchCancelTokenSource.token
    ).catch((err) => null);
    if (res) {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return [];
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          if (shouldStoreResults) {
            dispatch(setMembersData(res.data.data));
          }
          return res?.data?.data || [];
        }
    }
    return [];
  };
};
export const getMembersWithAssignablePackagesBySlot = (
  id,
  classId,
  search = "",
  shouldStoreResults = true,
  forMatch = false
) => {
  return async (dispatch, store) => {
    let url = `members/slots/subscriptions/${id}`;
    const params = [];
    if (classId) params.push(`classId=${encodeURIComponent(classId)}`);
    if (search) params.push(`search=${encodeURIComponent(search)}`);
    if (forMatch) params.push("forMatch=1");
    if (params.length) url += `?${params.join("&")}`;

    let res = await api(url, {}, "get").catch((err) => null);
    if (!res) return [];
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return [];
    }
    if (res.status === 400) {
      toastr.error(res?.data?.error||"Something went wrong");
    } else {
      if (shouldStoreResults) {
        dispatch(setMembersData(res.data.data));
      }
      return res?.data?.data || [];
    }
  };
};
export const getClassGroups = ({ restrictGender,name,isActive,groupType,isHidden,isArchived }) => {
  return async (dispatch, store) => {
    let url = `class/getBasicClassesInfo`;
        const params = [];

        if (restrictGender) {
          params.push(`restrictGender=${encodeURIComponent(restrictGender)}`);
        }
        if (name) {
          params.push(`name=${encodeURIComponent(name)}`);
        }
           if (groupType) {
          params.push(`groupType=${encodeURIComponent(groupType)}`);
        }
        if(isHidden){
          params.push(`isHidden=true`)
        }
        if (isActive!==undefined) {
          params.push(`isActive=${encodeURIComponent(isActive)}`);
        }
        if(isArchived){
          params.push(`isArchived=${true}`)
        }

        if (params.length > 0) {
          url += `?${params.join('&')}`;
        }
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setClassesData(res.data.data));
    }
  };
};

export const getClass = (value,showCancellationBooking=false) => {
  //console.log('get class', value);
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let url=`class/${value}`
    if(showCancellationBooking) url+="?showCancellationBooking=true"

    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setClassData(res.data.data));
    }
  };
};
export const getByGroupId = (value) => {
  //console.log('get class', value);
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api(
      `class/getByGroupId/${value}`,
      {},
      "get"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
      history.push("/gym-panel/appointments");
    } else {
      dispatch(setClassData(res.data.data));
    }
  };
};
export const updateClass = (value, id) => {
  return async (dispatch, store) => {
    let res = await api(`class/${id}`, value, "patch").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("You have not entered Proper Data");
    } else {
      toastr.success("Success:Edit Class");
      JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
      JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
        "TRAINER"
        ? history.push("/trainer-panel/appointments")
        : history.push("/gym-panel/appointments");
    }
  };
};

export const deleteClass = (id, groupId) => {
  return async (dispatch, store) => {
    let res = await api(
      `class/${id}`,
      { isGroupId: groupId },
      "delete"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error(res.data.error);
    } else {
      toastr.success("Success:Delete Class");
    }
  };
};

export const logout = (id) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`logout/${id}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          // check if (userrole is staff logout )
          let user = JSON.parse(
            localStorage.getItem("connectToFitGymPanelUser")
          );
          // if (user.role == "STAFF") {
          //   dispatch(setStaffCheckOut(user));
          // }
          localStorage.removeItem("connectToFitGymPanelUser");
          toastr.success("Success : User Logout");
          setTimeout(function() {
            dispatch({ type: "USER_LOGGED_OUT_SET_INITIAL" });
          }, 1500);
        }
      })
      .catch((err) => {});
  };
};
export const backToGym = (id, directUrl) => {
  return async (dispatch, store) => {
    await api(`logout/${id}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          localStorage.removeItem("connectToFitGymPanelUser");
          setTimeout(function() {
            window.location.href = `${directUrl}/dashboard`;
            // dispatch({ type: "USER_LOGGED_OUT_SET_INITIAL" });
          }, 1000);
        }
      })
      .catch((err) => {});
  };
};

export const transferSale = (membershipId, memberId) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`member/${membershipId}/sale-transfer/${memberId}`, {}, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          toastr.success("Suceess:Sale Transfered");
          // history.push("/gym-panel/memberslist");
          history.goBack();
        }
      })
      .catch((err) => {});
  };
};

export const AssignClass = (memberId, classId) => {
  //console.log('Assign Class', memberId, classId);
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`member/${memberId}/class/${classId}`, {}, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          toastr.success("Success : Member Assigned To Class");
        }
      })
      .catch((err) => {});
  };
};

export const checkPassword = (password) => {
  //console.log("Password", password)
  return async (dispatch, store) => {
    let res = await api(`checkPassword`, password, "patch").catch((err) => {});
    if (!res.data.data) {
      toastr.error("Invalid Password");
      return false;
    } else {
      return true;
    }
  };
};

export const sendForgotEmail = (email) => {
  //console.log("Password", password)
  return async (dispatch, store) => {
    let res = await api(
      `admin/forgotPassword`,
      { email: email },
      "patch"
    ).catch((err) => {});
    if (res && res.status !== 200) {
      toastr.error("Error : Invalid data");
      return false;
    } else {
      toastr.success("Success : OTP sent on e-mail");
      return true;
    }
  };
};

export const resetPassword = (data, flag) => {
  //console.log("Password", password)
  return async (dispatch, store) => {
    let res = await api(
      `admin/resetPassword`,
      data,
      "patch"
    ).catch((err) => {});
    if (res && res.status !== 200) {
      toastr.error("Error : Something went wrong. Try Again");
    } else {
      toastr.success("Success : Password Changed");
      if (flag) history.push("/");
    }
  };
};

export const toggleClassAttendence = (member_id, class_id, isAttended) => {
  //console.log("Password", password)
  return async (dispatch, store) => {
    let res = await api(
      `member/${member_id}/class/${class_id}`,
      { isAttended: isAttended },
      "patch"
    ).catch((err) => {});
    if (res && res.status !== 201) {
      toastr.error("Error : Something went wrong. Try Again");
    } else {
      toastr.success(
        `Success : ${
          res.data.data.isAttended ? "Marked Present" : "Marked Absent"
        }`
      );
    }
  };
};

export const toggleBookingStatus = (
  member_id,
  class_id,
  isAttended,
  status
) => {
  //console.log("Password", password)
  return async (dispatch, store) => {
    let res = await api(
      `member/${member_id}/class/${class_id}`,
      { status: status, isAttended: isAttended },
      "patch"
    ).catch((err) => {});
    if (res && res.status !== 201) {
      toastr.error("Error : Something went wrong. Try Again");
    } else {
      toastr.success(`Success : ${"Moved To Booked"}`);
    }
  };
};

export const getBookings = (class_id) => {
  //console.log("Password", password)
  return async (dispatch, store) => {
    let res = await api(
      `class/${class_id}/member`,
      {},
      "get"
    ).catch((err) => {});
    if (res && res.status !== 200) {
      toastr.error("Error : Something went wrong. Try Again");
    } else {
      // console.log(res.data.data);
      dispatch(setClassMembers(res.data.data));
    }
  };
};

export const giveBackMoney = (id) => {
  return async (dispatch, store) => {
    let res = await api(`member/${id}/getAmount`, {}, "get").catch((err) => {});
    if (res && res.status !== 200) {
      toastr.error("Error : Something went wrong. Try Again");
    } else {
      // console.log(res.data.data);
      dispatch(setGiveBackMoney(res.data.data));
    }
  };
};

export const notificationsApi = (page, limit) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    const user = JSON.parse(localStorage.getItem("connectToFitGymPanelUser"));
    const source = encodeURIComponent(JSON.stringify({ type: "gym", id: user?.gym }));
    await api(`notifications?page=${page}&limit=${limit}&source=${source}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setNotifications(res.data.data, res.data.totalCount));
          dispatch(setPageLimit(page, limit));
        }
      })
      .catch((err) => {});
  };
};

export const unreadNotificationCountApi = () => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`notifications/unread`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setUnreadNotificationCount(res.data.data));
        }
      })
      .catch((err) => {});
  };
};
// export const getMemberSubsriptionsBookings = (msp) => {
//   return async (dispatch, store) => {
//     // dispatch(setloader(true));
//     await api(`booking/subscriptions/${msp}`, {}, "get")
//       .then((res) => {
//         if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
//           toastr.error("Something went wrong!");
//           return;
//         }
//         if (res.status === 400) {
//           toastr.error("some error occured");
//         } else {
//           dispatch(setBookingMemberships(res.data.data));
//         }
//       })
//       .catch((err) => {});
//   };
// };


export const markReadApi = (id) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`notifications/toggle/${id}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        }
      })
      .catch((err) => {});
  };
};

export const getSubscribedUsers = (page, limit, search) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let url = search
      ? `transaction?page=${page}&limit=${limit}&search=${search}`
      : `transaction?page=${page}&limit=${limit}`;
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setSubscribedUsersData(res.data.data));
          dispatch(setSubscribedUsersCount(res.data.totalCount));
        }
      })
      .catch((err) => {});
  };
};

export const getSubscribedUsersForExport = (page, limit, search) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let url = search
      ? `transaction?page=${page}&limit=${limit}&search=${search}`
      : `transaction?page=${page}&limit=${limit}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      return res.data.data;
    }
  };
};

export const markCapturedApi = (id) => {
  return async (dispatch, store) => {
    await api(`pay/capture/${id}`, {}, "patch")
      .then((res) => {
        if (res.status === 200) {
          toastr.success("Payment Captured Successfully");
        } else {
          toastr.error("Some Error Occured. Please Try Again");
        }
      })
      .catch((err) => {});
  };
};

export const markDeclinedApi = (id) => {
  return async (dispatch, store) => {
    await api(`pay/decline/${id}`, {}, "patch")
      .then((res) => {
        if (res.status === 200) {
          toastr.success("Payment Declined Successfully");
        } else {
          toastr.error("Some Error Occured. Please Try Again");
        }
      })
      .catch((err) => {});
  };
};

export const goLiveNotificationApi = (id) => {
  return (dispatch, store) => {
    api(`class/${id}/live`, {}, "get")
      .then((res) => {
        if (res.status === 200) {
          // toastr.success("Payment Declined Successfully");
        } else {
          // toastr.error("Some Error Occured. Please Try Again");
        }
      })
      .catch((err) => {});
  };
};

export const markClassCompleteApi = (id) => {
  return (dispatch, store) => {
    api(`class/${id}/status`, { status: "C" }, "patch")
      .then((res) => {
        if (res.status === 200) {
          toastr.success("Marked Completed Successfully");
        } else {
          // toastr.error("Some Error Occured. Please Try Again");
        }
      })
      .catch((err) => {});
  };
};
export const trainerDashboardCardApi = (
  from = new Date().getTime(),
  to = new Date().getTime()
) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api(
      `trainer/stats?from=${from}&to=${to}`,
      {},
      "get"
    ).catch((err) => {});

    if (res.status !== 200) {
      toastr.error("some error occured");
    } else {
      dispatch(setTrainerDashboardCardData(res.data.data[0]));
    }
  };
};

export const trainerDashboardCardApiForTrainer = (
  from = new Date().getTime(),
  to = new Date().getTime()
) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api(
      `trainer/stats?from=${from}&to=${to}`,
      {},
      "get"
    ).catch((err) => {});

    if (res.status !== 200) {
      toastr.error("some error occured");
    } else {
      return res.data.data[0];
    }
  };
};

export const trainerLiveClassCardDataApi = (
  from = new Date().getTime(),
  to = new Date().getTime(),
  trainer
) => {
  return async (dispatch, store) => {
    let url = `user/stats/liveClass?from=${from}&to=${to}&trainer=${trainer}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (res && res.status !== 200) {
    } else {
      dispatch(setTrainerLiveClassCardData(res.data.data));
    }
  };
};

export const getClassesTrainer = (
  page,
  limit,
  search,
  filter,
  otherFilter,
  date
) => {
  return async (dispatch, store) => {
    let url = search
      ? `gym/dashboard/classes?page=${page}&limit=${limit}${search}`
      : `gym/dashboard/classes?page=${page}&limit=${limit}`;

    if (filter) {
      if (filter === "DATE") {
        if (date) {
          url = url.concat(`&from=${date.from}&to=${date.to}`);
        }
      } else {
        url = url.concat(`&${filter}`);
      }
    }
    if (otherFilter) {
      url = url.concat(`${otherFilter}`);
    }
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setSales(res.data.data));
          dispatch(setExpansionSummary(res.data.counts[0]));
          dispatch(setExpansionCount(res.data.totalCount));
        }
      })
      .catch((err) => {});
  };
};

export const getClassesTrainerForExport = (
  page,
  limit,
  search,
  filter,
  otherFilter,
  date
) => {
  return async (dispatch, store) => {
    let url = search
      ? `gym/dashboard/classes?page=${page}&limit=${limit}${search}`
      : `gym/dashboard/classes?page=${page}&limit=${limit}`;

    if (filter) {
      if (filter === "DATE") {
        if (date) {
          url = url.concat(`&from=${date.from}&to=${date.to}`);
        }
      } else {
        url = url.concat(`&${filter}`);
      }
    }
    if (otherFilter) {
      url = url.concat(`${otherFilter}`);
    }
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      return res.data.data;
    }
  };
};

export const getSalesByTrainer = (
  page,
  limit,
  search,
  filter,
  otherFilter,
  date
) => {
  return async (dispatch, store) => {
    let url = search
      ? `gym/dashboard/sales?page=${page}&limit=${limit}&timeZone=${
          Intl.DateTimeFormat().resolvedOptions().timeZone
        }&prTraining=Y${search}`
      : `gym/dashboard/sales?page=${page}&limit=${limit}&timeZone=${
          Intl.DateTimeFormat().resolvedOptions().timeZone
        }&prTraining=Y`;
    if (filter) {
      if (filter === "DATE") {
        if (date) {
          if (date.from === undefined) return;
          url = url.concat(`&from=${date.from}&to=${date.to}`);
        }
      } else {
        url = url.concat(`&${filter}`);
      }
    }
    if (otherFilter) {
      url = url.concat(`${otherFilter}`);
    }
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setSales(res.data.data));
          dispatch(setExpansionSummary(res.data.counts[0]));
          dispatch(setExpansionCount(res.data.totalCount));
        }
      })
      .catch((err) => {});
  };
};

export const getSalesByTrainerForExport = (
  page,
  limit,
  search,
  filter,
  otherFilter,
  date
) => {
  return async (dispatch, store) => {
    let url = search
      ? `gym/dashboard/sales?page=${page}&limit=${limit}&timeZone=${
          Intl.DateTimeFormat().resolvedOptions().timeZone
        }&prTraining=Y${search}`
      : `gym/dashboard/sales?page=${page}&limit=${limit}&timeZone=${
          Intl.DateTimeFormat().resolvedOptions().timeZone
        }&prTraining=Y`;
    if (filter) {
      if (filter === "DATE") {
        if (date) {
          if (date.from === undefined) return;
          url = url.concat(`&from=${date.from}&to=${date.to}`);
        }
      } else {
        url = url.concat(`&${filter}`);
      }
    }
    if (otherFilter) {
      url = url.concat(`${otherFilter}`);
    }
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      return res.data.data;
    }
  };
};

export const getSalesExpansions = (
  page,
  limit,
  search,
  filter,
  otherFilter,
  date,
  status,
  memberStatus=""
) => {
  return async (dispatch, store) => {
    let url = search
      ? `gym/dashboard/sales?page=${page}&limit=${limit}&timeZone=${
          Intl.DateTimeFormat().resolvedOptions().timeZone
        }${search}`
      : `gym/dashboard/sales?page=${page}&limit=${limit}&timeZone=${
          Intl.DateTimeFormat().resolvedOptions().timeZone
        }`;
    if (filter) {
      if (filter === "DATE") {
        if (date) {
          if (date.from === undefined) return;
          url = url.concat(`&from=${date.from}&to=${date.to}`);
        }
      } else if (filter === "EXM") {
        url = url.concat(`&filter=${filter}`);
      } else {
        url = url.concat(`&${filter}`);
      }
    }
    if (otherFilter) {
      url = url.concat(`${otherFilter}`);
    }
    if (status) {
      url = url.concat(`&status=${status}`);
    }
    if(memberStatus){
      url=url.concat(`&memberStatus=${memberStatus}`);
    }
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setSales(res.data.data));
          dispatch(setExpansionSummary(res.data.counts[0]));
          dispatch(setSalesTotalData(res.data.counts[0]));
          dispatch(setExpansionCount(res.data.totalCount));
        }
      })
      .catch((err) => {});
  };
};

export const getSalesExpansionsForExport = (
  page,
  limit,
  search,
  filter,
  otherFilter,
  date
) => {
  return async (dispatch, store) => {
    let url = search
      ? `gym/dashboard/sales?page=${page}&limit=${limit}&timeZone=${
          Intl.DateTimeFormat().resolvedOptions().timeZone
        }${search}`
      : `gym/dashboard/sales?page=${page}&limit=${limit}&timeZone=${
          Intl.DateTimeFormat().resolvedOptions().timeZone
        }`;
    if (filter) {
      if (filter === "DATE") {
        if (date) {
          if (date.from === undefined) return;
          url = url.concat(`&from=${date.from}&to=${date.to}`);
        }
      } else {
        url = url.concat(`&${filter}`);
      }
    }
    if (otherFilter) {
      url = url.concat(`${otherFilter}`);
    }
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      return res.data.data;
    }
  };
};

export const getBookingsExpansion = (page, limit, search, filter, date) => {
  return async (dispatch, store) => {
    let url = search
      ? `gym/dashboard/bookings?page=${page}&limit=${limit}&search=${search}`
      : `gym/dashboard/bookings?page=${page}&limit=${limit}`;
    if (filter) {
      if (filter === "DATE") {
        if (date) {
          url = url.concat(`&from=${date.from}&to=${date.to}`);
        }
      } else {
        url = url.concat(`&${filter}`);
      }
    }

    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setBookings(res.data.data));
          dispatch(setExpansionCount(res.data.totalCount));
        }
      })
      .catch((err) => {});
  };
};

export const getBookingsExpansionForExport = (
  page,
  limit,
  search,
  filter,
  date
) => {
  return async (dispatch, store) => {
    let url = search
      ? `gym/dashboard/bookings?page=${page}&limit=${limit}&search=${search}`
      : `gym/dashboard/bookings?page=${page}&limit=${limit}`;
    if (filter) {
      if (filter === "DATE") {
        if (date) {
          url = url.concat(`&from=${date.from}&to=${date.to}`);
        }
      } else {
        url = url.concat(`&${filter}`);
      }
    }

    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      return res.data.data;
    }
  };
};

export const gymDashboardCardApi = (
  from = new Date().getTime(),
  to = new Date().getTime()
) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api(
      `gym/stats?from=${from}&to=${to}&timeZone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`,
      {},
      "get"
    ).catch((err) => {});

    if (!res || res.status !== 200) {
      toastr.error("some error occured");
    } else {
      dispatch(setGymDashboardCardData(res.data.data));
    }
  };
};
export const getDashboardCharts = (year) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    dispatch(setDashboardCharts(undefined));
    let res = await api(
      `gym/stats/charts?year=${year}&timeZone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`,
      {},
      "get"
    ).catch((err) => {
      toastr.error("Something went wrong");
    });
    if (res.status !== 200) {
      toastr.error("some error occured");
    } else {
      const salesData = res.data.data.sale[0];

      const finalSalesObject = Object.keys(salesData).map((month) => ({
        x: month,
        y: parseFloat(salesData[month].toFixed(2)),
      }));
      res.data.data.sale[0] = finalSalesObject;
      dispatch(setDashboardCharts(res.data.data));
    }
  };
};

export const gymDashboardCardApiForExport = (
  from = new Date().getTime(),
  to = new Date().getTime()
) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api(
      `gym/stats?from=${from}&to=${to}`,
      {},
      "get"
    ).catch((err) => {});

    if (res.status !== 200) {
      toastr.error("some error occured");
    } else {
      return res.data.data[0];
    }
  };
};

export const getMembersSupportedPackagesForClass = (memberId, classId) => {
  return async (dispatch, store) => {
    let url = `member/getClassPackages/${memberId}?classId=${classId}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (res && res.status !== 200) {
    } else {
      dispatch(setMemberSupportedPackagesForClass(res.data.data));
    }
  };
};

export const gymLiveClassCardDataApi = (
  from = new Date().getTime(),
  to = new Date().getTime(),
  gym
) => {
  return async (dispatch, store) => {
    let url = `user/stats/liveClass?from=${from}&to=${to}&gym=${gym}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (res && res.status !== 200) {
    } else {
      dispatch(setGymLiveClassCardData(res.data.data));
    }
  };
};

export const checkValidation = async (data) => {
  let res = await api(`member/check`, data, "post").catch((err) => {});
  if (res.status === 200) {
    return res.data.data ? true : false;
  } else {
    return false;
  }
};

export const AddToBookingList = (data, classId,dates) => {
  return async (dispatch, store) => {
    let url = `booking`;
    let res = await api(url, data, "post").catch((err) => {});
    if (res && res.status !== 201) {
      if (res.status === 423) {
        toastr.error("Class is Already Full");
      } else if (res?.response?.data?.status === 409) {
        toastr.error(res.response.data.error);
      } else {
        toastr.error(res?.response?.data?.error);
      }
    } else {
      dispatch(toggleAddToBookingListModal());
      console.log([dates])
      if(dates){
        const startDate=dates.startDate||moment(new Date())
        .startOf("day")
        .valueOf()
        const endDate=dates.endDate|| moment(new Date())
              .endOf("day")
              .valueOf()
        dispatch(
          getCourtsSlotsForBookingPageView({
            startDate,
            endDate,
          })
        );
      }else dispatch(getClass(classId));
      if(store().court.bookCourtModal) {
        dispatch(toggleBookCourtModal());
      }
      toastr.success("User Added Successfully");
    }
  };
};
export const AddToPreBookingList = (data, classId,dates) => {
  return async (dispatch, store) => {
    let url = `booking/prepaid`;
    let res = await api(url, data, "post").catch((err) => {});
    if (res && res.status !== 201) {
      if (res.status === 423) {
        toastr.error("Class is Already Full");
      } else if (res?.response?.data?.status === 409) {
        toastr.error(res.response.data.error);
      } else {
        toastr.error(res?.response?.data?.error);
      }
    } else {
      dispatch(toggleAddToBookingListModal());
       if(dates){
        const startDate=dates.startDate||moment(new Date())
        .startOf("day")
        .valueOf()
        const endDate=dates.endDate|| moment(new Date())
              .endOf("day")
              .valueOf()
        dispatch(
          getCourtsSlotsForBookingPageView({
            startDate,
            endDate,
          })
        );
      }else dispatch(getClass(classId));
      if(store().court.bookCourtModal) {
        dispatch(toggleBookCourtModal());
      }
      toastr.success("User Added Successfully");
    }
  };
};


export const freezeMember = (data) => {
  return async (dispatch, store) => {
    try {
      dispatch(setCommonLoading(true))
      let res = await api("member/freezeMemberShip", data, "post");
      console.log({ res });
      if (res.status == 201 || res.status == 200) {
        dispatch(
          getMembers(
            1,
            10,
            JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
          )
        );
        toastr.success("Success: Freezed");
        dispatch(getMemberInfo(data.memberId));
        dispatch(
          getMemberTabsInfo({
            params: "purchases",
            page: store().member.dataPage,
            limit: store().member.dataLimit,
            query: "",
            member: data.memberId,
          })
        );
      } else {
        toastr.error(res?.data?.message);
      }
     dispatch(setCommonLoading(false))

    } catch (e) {
      toastr.error(e.message);
    } finally {
      dispatch(setFreezeMembershipOpen(false));
    }
  };
};
export const payExtraFees = (data) => {
  return async (dispatch, store) => {
    try {
      dispatch(setCommonLoading(true))
      let res = await api("member/booking/payExtraFees", data, "post");
      console.log({ res });
      if (res.status == 201 || res.status == 200) {
        // dispatch(
        //   getMembers(
        //     1,
        //     10,
        //     JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
        //   )
        // );
        toastr.success("Success: Fees Added");
      
      } else {
        toastr.error(res?.data?.message);
      }
     dispatch(setCommonLoading(false))

    } catch (e) {
      toastr.error(e.message);
    } finally {
    }
  };
};

export const unfreezeMember = (id, memberId,isCanceled) => {
  return async (dispatch, store) => {
    try {
      dispatch(setCommonLoading(true))
      let res = await api(`member/unfreezeMemberShip/${id}`, {isCanceled}, "post");
      if (res.status !== 201 && res.status !== 200)
        throw new Error("Something went wrong");
      dispatch(getMemberInfo(memberId));
      dispatch(
        getMemberTabsInfo({
          params: "purchases",
          page: store().member.dataPage,
          limit: store().member.dataLimit,
          query: "",
          member: memberId,
        })
      );
      toastr.success(`Membership ${isCanceled?"canceled":"unfreezed"} successfully`);
      dispatch(setCommonLoading(false))

    } catch (e) {
      toastr.error(e.message);
    } finally {
      dispatch(setFreezeMembershipOpen(false));
      dispatch(setShowMemberFreezeHistory(false))
    }
  };
};
export const getMemberGymSubscriptionList = ({
  page,
  limit,
  member,
  query,
}) => {
  return async (dispatch, store) => {
    let url = `member/${member}/gym/subscriptions`;
    if (page && limit) {
      url += `?page=${page}&limit=${limit}`;
    }
    if (query) {
      Object.keys(query).forEach((item) => {
        url += `&${item}=${query[item]}`;
      });
    }
    try {
      dispatch(setGymSubscriptionLoading(true));
      let res = await api(url, {}, "get");
      let data = res.data.data;
      let count = res.data.totalCount;
      dispatch(setGymSubscriptionLoading(false));
      dispatch(setMemberMemberSubscriptionsList(data));
      dispatch(setMemberMemberSubscriptionsCount(count));
    } catch (e) {
      toastr.error("Something went wrong");
    }
  };
};

export const freezeAll = (data) => {
  return async (dispatch, store) => {
    try {
      let response = await api("member/freezeAll", data, "post");
      if (response.status !== 201 && response.status !== 200)
        throw new Error("Waiting for API");
      dispatch(
        getMembers(
          1,
          10,
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
        )
      );
      response?.data?.message
        ? toastr.success(response.data.message)
        : toastr.success(
            "All member ships are freezed, if you wish to unfreeze them before the end of the duration please access the quick actions menu"
          );
    } catch (e) {
      toastr.error(e.message);
    } finally {
      dispatch(setFreezeAllModalOpen(false));
    }
  };
};
export const pushNotification = (data) => {
  return async (dispatch, store) => {
    try {
      dispatch(setCommonLoading(true))
      let response = await api("pushNotification", data, "post");
      if (response.status !== 201 && response.status !== 200) {
        toastr.error("Something went wrong");
      } else {
            dispatch(setPushNotificationResult({ successCount: response.data.data.totalSuccess,
            failedCount: response.data.data.totalFailed,
            openModal:true
          })) 
            toastr.success(response?.data?.message);
      }
      dispatch(setCommonLoading(false))
      dispatch(
        getMembers(
          1,
          10,
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
        )
      );
      dispatch(setPushNotificationModal(false));
      dispatch(clearSelection("members"));

    } catch (e) {
      toastr.error(e.message);
    } finally {
      dispatch(setFreezeAllModalOpen(false));
    }
  };
};

export const addPriceRelation = (
  value,
  id,
  toggle,
  setIssubmitted,
  setRelation
) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    try {
      await api(`package/${id}`, value, "patch");
       dispatch(addPackageModal(false, false, {}));
      await dispatch(getPackages(1, 300, true));
      toastr.success("Suceess:Relation Added!");
      toggle();
    } catch (e) {
      toastr.error("Something Went Wrong");
    }
  };
};

export const cancelClass = (payload) => {
  return async (dispatch) => {
    console.log({ payload });
    let url;
    if (payload.canelationType === "allFutureClasses") {
      url = `class/${payload.groupId}/groupCancellation/${payload.classId}`;
    } else if (payload.canelationType === "singleClass") {
      url = `class/${payload.classId}/cancellation`;
    }
    try {
      let res = await api(url, {}, "patch");
      if (res.status !== 200) {
        toastr.error("Something went wrong please try again");
      } else {
        toastr.success("Class Cancelled Successfully");
      }
      dispatch(
        getClassesForWeek(
          moment(payload?.startDate).format("x"),
          payload?.trainer|| null,
          "class"
        )
      );
      dispatch(toggleClassCancelModal());
    } catch (e) {
      toastr.error("Something went wrong please try again");
    } finally {
      // dispatch(toggleCancelClassModal());
    }
  };
};

export const cancelClassBooking = (body, class_id,action,dates) => {
  return async (dispatch) => {
    let url = "booking/cancelBooking";
    api(url, body, "post")
      .then((res) => {
        if (res.status === 200) {
          toastr.success("Booking canceled successfully");
          if (class_id) {
            dispatch(getClass(class_id));
            dispatch(toggleCancelBookingModal());
          }
          if(action){
            dispatch(getDataAgain({action:action,status:true}))
          } 
          if(dates){
            const startDate=dates.startDate||moment(new Date())
            .startOf("day")
            .valueOf()
            const endDate=dates.endDate|| moment(new Date())
                  .endOf("day")
                  .valueOf()
            dispatch(
              getCourtsSlotsForBookingPageView({
                startDate,
                endDate,
              })
            );
          }
        } else toastr.error(res.message);
      })
      .catch((err) => console.log(err));
  };
};

export const addToClassWaitingList = ({member,_class}) => {
  return async (dispatch) => {
    let url = "booking/addToWaitingList";
    try {
      const res = await api(url, {member,class:_class}, "post");
      if (res.status === 201) {
        toastr.success("Booking canceled successfully");
        dispatch(getClass(_class));
        dispatch(toggleAddToBookingListModal());
      } else {
        toastr.error(res?.response?.data?.message||res?.message);
      }
    } catch (err) {
      console.log(err);
    }
  };
};
export const moveMemberToBookingList = (bookingId,_class) => {
  return async (dispatch) => {
    let url = "booking/moveMemberToBookingList";
    api(url, {bookingId}, "post")
      .then((res) => {
        if (res.status === 200) {
          toastr.success("Member Moved Successfully");
          dispatch(getClass(_class));
          // dispatch(toggleAddToBookingListModal());
        } 
        else {
          toastr.error(res?.response?.data?.message||res?.message);
        }
      })
      .catch((err) => console.log(err));
  };
};

export const bookAppointment = (body, dates, courtData, type,action) => {
  return async (dispatch) => {
    let url = "booking/appointment";
    dispatch(setLoading(true));
    api(url, { ...body, ...courtData }, "post")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          toastr.success("Booked successfully");
          dispatch(setLoading(false));
          if(action){
            console.log("actioooooooooooooon")
            dispatch(getDataAgain({action:action,status:true}))
          } 
          if (
            ((courtData?.courtData && courtData?.courtData?.appointment)) &&
            dates &&
            dates.start &&
            dates.end
          ) {
            //for appointment book coming from court (private lesson)
            dispatch(toggleBookCourtModal());
            const requestObj = dates?.trainer
              ? {
                  startDate: dates.start,
                  endDate: dates.end,
                  trainer: dates?.trainer,
                }
              : { startDate: dates.start, endDate: dates.end };
            dispatch(getCourtsSlotsForBookingPageView(requestObj));
          } 
          else if(type === "complex"){
            dispatch(toggleBookAppointmentModal());
            const requestObj = dates?.trainer
            ? {
                startDate: dates.start,
                endDate: dates.end,
                trainer: dates?.trainer,
              }
            : { startDate: dates.start, endDate: dates.end };
          dispatch(getCourtsSlotsForBookingPageView(requestObj));
          }
          else {
            dispatch(toggleBookAppointmentModal());
            dates && dispatch(getAppointmentBookingByMonth(dates));
            dispatch(setLoading(false));
           
          }
        } else {
          toastr.error(res?.data?.error||res?.response?.data?.error);
          dispatch(setLoading(false));
        }
      })
      .catch((err) => {
        console.log(err)
        dispatch(setLoading(false));

      });
  };
};
export const prePaidBookAppointment = (body, dates, courtData, type,action) => {
  return async (dispatch) => {
    let url = "prePaid/booking/appointment";
    dispatch(setLoading(true));
    api(url, { ...body, ...courtData }, "post")
      .then((res) => {
        console.log({res})
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error(res?.response?.data?.error||"Something went wrong!");
        }
        if (res.status === 201 || res.status === 200) {
          toastr.success("Booked successfully");
          dispatch(setLoading(false));
          if(action){
            dispatch(getDataAgain({action:action,status:true}))
          } 
          if (
            ((courtData?.courtData && courtData?.courtData?.appointment)
              ) &&
            dates &&
            dates.start &&
            dates.end
          ) {
            //for appointment book coming from court (private lesson)
            dispatch(toggleBookCourtModal());
            const requestObj = dates?.trainer
              ? {
                  startDate: dates.start,
                  endDate: dates.end,
                  trainer: dates?.trainer,
                }
              : { startDate: dates.start, endDate: dates.end };
            dispatch(getCourtsSlotsForBookingPageView(requestObj));
            dispatch(setLoading(false));

          }
          else if(type === "complex"){
            dispatch(toggleBookAppointmentModal());
            const requestObj = dates?.trainer
            ? {
                startDate: dates.start,
                endDate: dates.end,
                trainer: dates?.trainer,
              }
            : { startDate: dates.start, endDate: dates.end };
          dispatch(getCourtsSlotsForBookingPageView(requestObj));
          } 
          else {
            dispatch(toggleBookAppointmentModal());
            dates && dispatch(getAppointmentBookingByMonth(dates));
            dispatch(setLoading(false));
          }
        } else {
          toastr.error(res.data.error);
          dispatch(setLoading(false));
        }
        dispatch(setLoading(false));

      })
      .catch((err) => {console.log(err)
        dispatch(setLoading(false));

      });
  };
};
export const bookAppointmentV2 = (body, dates, courtData, type,action) => {
  return async (dispatch) => {
    let url = "v2/booking/appointment";
    dispatch(setLoading(true));
    api(url, { ...body, ...courtData }, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error(res?.response?.data?.error||"Something went wrong!");
        }
        if (res.status === 201 || res.status === 200) {
          toastr.success("Booked successfully");
          if (Array.isArray(res?.data?.data?.failedBookings) && res?.data?.data?.failedBookings.length > 0) {
            res.data.data.failedBookings.forEach((errMsg) => {
              toastr.warning(`Booking Copied Issue : ${moment(errMsg.dateTime).format("DD/MM/YYYY HH:mm")} ${errMsg.reason}`, "", { timeOut: 6000 }); // ⏱️ 8 seconds
            });
          }
          if(Array.isArray(res?.data?.data?.successfulBookings)&&res?.data?.data?.successfulBookings?.length){
            toastr.success(`${res?.data?.data?.successfulBookings.length} booking(s) duplicated`);
          }
          dispatch(setLoading(false));
          if(action){
            dispatch(getDataAgain({action:action,status:true}))
          } 
          if (
            ((courtData?.courtData && courtData?.courtData?.appointment)
              ) &&
            dates &&
            dates.start &&
            dates.end
          ) {
            //for appointment book coming from court (private lesson)
            dispatch(toggleBookCourtModal());
            const requestObj = dates?.trainer
              ? {
                  startDate: dates.start,
                  endDate: dates.end,
                  trainer: dates?.trainer,
                }
              : { startDate: dates.start, endDate: dates.end };
            dispatch(getCourtsSlotsForBookingPageView(requestObj));
            dispatch(setLoading(false));

          }
          else if(type === "complex"){
            dispatch(toggleBookAppointmentModal());
            const requestObj = dates?.trainer
            ? {
                startDate: dates.start,
                endDate: dates.end,
                trainer: dates?.trainer,
              }
            : { startDate: dates.start, endDate: dates.end };
          dispatch(getCourtsSlotsForBookingPageView(requestObj));
          } 
          else {
            dispatch(toggleBookAppointmentModal());
            dates && dispatch(getAppointmentBookingByMonth(dates));
            dispatch(setLoading(false));
          }
        } else {
          toastr.error(res.data.error);
          dispatch(setLoading(false));
        }
        dispatch(setLoading(false));

      })
      .catch((err) => {console.log(err)
        dispatch(setLoading(false));

      });
  };
};
const refreshCourtCalendar = (dispatch, dates) => {
  const start = dates && (dates.start || dates.startDate);
  const end = dates && (dates.end || dates.endDate);
  if (start && end) {
    const requestObj = dates?.trainer
      ? {
          startDate: start,
          endDate: end,
          trainer: dates?.trainer,
        }
      : { startDate: start, endDate: end };
    dispatch(getCourtsSlotsForBookingPageView(requestObj));
  }
};

export const createCourtMatch = (body, action) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    api("slot/match", body, "post")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          toastr.success("Open match created");
          dispatch(toggleBookCourtModal());
          if (action) {
            dispatch(getDataAgain({ action: action, status: true }));
          }
          refreshCourtCalendar(dispatch, body.dates);
          dispatch(setLoading(false));
        } else {
          toastr.error(res?.response?.data?.error || res?.data?.error);
          dispatch(setLoading(false));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };
};

export const addMatchSeat = (matchId, body, dates) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return api(`slot/match/${matchId}/seat`, body, "post")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          toastr.success("Player added");
          refreshCourtCalendar(dispatch, {
            start: dates?.startDate,
            end: dates?.endDate,
            trainer: dates?.trainer,
          });
          return true;
        }
        toastr.error(res?.response?.data?.error || res?.data?.error);
        return false;
      })
      .catch((err) => {
        console.log(err);
        return false;
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const updateCourtMatchCapacity = (matchId, capacity, dates) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return api(`slot/match/${matchId}/capacity`, { capacity }, "post")
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          toastr.success("Match size updated");
          refreshCourtCalendar(dispatch, {
            start: dates?.startDate,
            end: dates?.endDate,
            trainer: dates?.trainer,
          });
          return true;
        }
        toastr.error(res?.response?.data?.error || res?.data?.error);
        return false;
      })
      .catch((err) => {
        console.log(err);
        return false;
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const cancelCourtMatch = (matchId, dates) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    api(`slot/match/${matchId}/cancel`, {}, "post")
      .then((res) => {
        if (res.status === 200) {
          toastr.success("Open match canceled");
          refreshCourtCalendar(dispatch, {
            start: dates?.startDate,
            end: dates?.endDate,
            trainer: dates?.trainer,
          });
          dispatch(setLoading(false));
        } else {
          toastr.error(res?.response?.data?.error || res?.data?.error);
          dispatch(setLoading(false));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };
};

export const bookSlot = (body,action) => {
  return async (dispatch) => {
    let url = "slot/booking";
    dispatch(setLoading(true));
    api(url, body, "post")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          toastr.success("Booked successfully");
          dispatch(toggleBookCourtModal());
          if(action){
            dispatch(getDataAgain({action:action,status:true}))
      
          } 
          if (body.dates && body.dates.start && body.dates.end) {
            const requestObj = body.dates?.trainer
              ? {
                  startDate: body.dates.start,
                  endDate: body.dates.end,
                  trainer: body.dates?.trainer,
                }
              : { startDate: body.dates.start, endDate: body.dates.end };
            dispatch(getCourtsSlotsForBookingPageView(requestObj));
            dispatch(setLoading(false));
          }
        } else {
          toastr.error(res?.response?.data?.error);
          dispatch(setLoading(false));
        }
      })
      .catch((err) => {
        console.log(err)
        dispatch(setLoading(false));
      });
  };
};
export const preBookSlot = (body,action) => {
  return async (dispatch) => {
    let url = "slot/prePaid/booking";
    dispatch(setLoading(true));
    api(url, body, "post")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          toastr.success("Booked successfully");
          dispatch(toggleBookCourtModal());
          if(action){
            dispatch(getDataAgain({action:action,status:true}))
      
          } 
          if (body.dates && body.dates.start && body.dates.end) {
            const requestObj = body.dates?.trainer
              ? {
                  startDate: body.dates.start,
                  endDate: body.dates.end,
                  trainer: body.dates?.trainer,
                }
              : { startDate: body.dates.start, endDate: body.dates.end };
            dispatch(getCourtsSlotsForBookingPageView(requestObj));
            dispatch(setLoading(false));
          }
        } else {
          toastr.error(res?.response?.data?.error);
          dispatch(setLoading(false));
        }
      })
      .catch((err) => {
        console.log(err)
        dispatch(setLoading(false));

      });
  };
};

export const getAppointmentBookingByMonth = (params) => {
  return async (dispatch) => {
    let url = `booking/appointment?start=${params.start}&end=${params.end}${
      params.trainer ? `&trainer=${params.trainer}` : ""
    }`;
    api(url, {}, "get")
      .then((res) => dispatch(setAppointmentsBookings(res.data.data)))
      .catch((err) => toastr.error("Something wen wrong, please try again"));
  };
};

export const getBookingAppointmentActivity = (bookingId) => {
  return async () => {
    const [logsResponse, statusHistoryResponse] = await Promise.all([
      api(`booking-appointments/${bookingId}/logs?limit=100`, {}, "get"),
      api(
        `booking-appointments/${bookingId}/status-history?limit=100`,
        {},
        "get"
      ),
    ]);

    const logs = logsResponse?.data?.data;
    const statusHistory = statusHistoryResponse?.data?.data;

    if (!Array.isArray(logs) || !Array.isArray(statusHistory)) {
      throw new Error("Could not load appointment activity");
    }

    return { logs, statusHistory };
  };
};

const bookingActivityActorCache = {};

export const getBookingActivityActors = (logs, statusHistory) => {
  return async () => {
    const actorReferences = [
      ...logs.map((log) => ({ id: log.performedBy, type: log.performedByType })),
      ...statusHistory.map((status) => ({ id: status.changedBy, type: "USER" })),
    ].filter((actor) => actor.id != null && actor.type !== "SYSTEM");

    const uniqueActors = actorReferences.filter(
      (actor, index, actors) =>
        actors.findIndex(
          (candidate) =>
            Number(candidate.id) === Number(actor.id) &&
            candidate.type === actor.type
        ) === index
    );

    await Promise.all(
      uniqueActors.map(async ({ id, type }) => {
        const actorType = type === "MEMBER" ? "MEMBER" : "USER";
        const cacheKey = `${actorType}:${id}`;
        if (bookingActivityActorCache[cacheKey]) return;

        const response = await api(
          `${actorType === "MEMBER" ? "member" : "user"}/${id}`,
          {},
          "get"
        );
        const name = response?.data?.data?.name;
        if (name) bookingActivityActorCache[cacheKey] = name;
      })
    );

    return { ...bookingActivityActorCache };
  };
};

export const copyAppointment = (body, startDate, endDate,fromCourtSchdule=false) => {
  return async (dispatch) => {
    let url = "booking/cloneBookedAppointment";
    api(url, body, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.data.status === 400) {
          toastr.error(res.data.error);
          return;
        }
        if (Array.isArray(res?.data?.data?.failedBookings) && res?.data?.data?.failedBookings.length > 0) {
          res.data.data.failedBookings.forEach((errMsg) => {
            toastr.warning(`${moment(errMsg.dateTime).format("DD/MM/YYYY HH:mm")} ${errMsg.reason}`, "", { timeOut: 6000 }); // ⏱️ 8 seconds
          });
        }
        if(res?.data?.data?.successfulBookings.length){
          toastr.success(`${res?.data?.data?.successfulBookings.length} booking(s) duplicated`);
          if(fromCourtSchdule)return dispatch(getCourtsSlotsForBookingPageView({ startDate, endDate}));
          dispatch(
            getAppointmentBookingByMonth({ start: startDate, end: endDate })
          );
        
        }
        
      })
      .catch((err) => console.log(err));
  };
};
export const copySlotsAppointment = (body, startDate, endDate) => {
  return async (dispatch) => {
    let url = "booking/slots/cloneBookedAppointment";
    api(url, body, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          console.log({res})
          toastr.error(res?.response?.data?.error?res?.response?.data?.error:"Something went wrong!");
          return;
        }
        if (res.data.status === 400) {
          toastr.error(res.data.error);
          return;
        }
        const failedBookings = Array.isArray(res?.data?.data?.failedBookings)
          ? res.data.data.failedBookings
          : [];
        const successfulBookings = Array.isArray(
          res?.data?.data?.successfulBookings
        )
          ? res.data.data.successfulBookings
          : [];

        failedBookings.forEach((failedBooking) => {
          toastr.warning(
            `${moment(failedBooking.dateTime).format("DD/MM/YYYY")} ${
              failedBooking.reason
            }`,
            "",
            { timeOut: 6000 }
          );
        });

        if (successfulBookings.length > 0) {
          toastr.success(
            `${successfulBookings.length} booking(s) duplicated`
          );
          dispatch(getCourtsSlotsForBookingPageView({ startDate, endDate }));
        }
      })
      .catch((err) => console.log(err));
  };
};
export const copyClassBooking = (body, startDate, endDate) => {
  return async (dispatch) => {
    let url = "booking/cloneBookedClass";
    api(url, body, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          console.log({res})
          toastr.error("Something went wrong!");
          return;
        }
        if (res.data.status === 400) {
          toastr.error(res.data.error);
          return;
        }
        // dispatch(getCourtsSlotsForBookingPageView({ startDate, endDate}));
    // ✅ Show success toast
    if(res.data?.data?.created.length){
    toastr.success(` ${res.data?.data?.created.length} Bookings Copied Successfully`);
    }
    // ✅ Show each individual error as a warning toast
    if (Array.isArray(res?.data?.data?.errors) && res?.data?.data?.errors.length > 0) {
      res.data.data.errors.forEach((errMsg) => {
        toastr.warning(`${errMsg?.reason} at ${moment(errMsg.dateTime).format("DD/MM/YYYY HH:mm")}`); // ⏱️ 8 seconds
      });
    }
      })
      .catch((err) => console.log(err));
  };
};
export const editAppointment = (data, startDate, endDate,isFromCourt) => {
  return async (dispatch) => {
    let url = `booking/appointment/${data.bookingId}`;
    api(url, { dateTime: data.dateTime }, "patch")
      .then((res) => {
        if(res.status==200){
          toastr.success("Appointment Edited");
          if(isFromCourt){
          return dispatch(getCourtsSlotsForBookingPageView({ startDate, endDate}));
          }
          dispatch(
            getAppointmentBookingByMonth({ start: startDate, end: endDate })
          );
        }
        else {
         toastr.error(res?.data?.error||"Something went wrong, please try again")
       }        
      })
      .catch((err) => toastr.error("Something went wrong, please try again"));
  };
};
export const markAppointmentBookingSeen = (bookingId, dates) => {
  return async (dispatch) => {
    const response = await api(
      `booking/appointment/${bookingId}/seen`,
      {},
      "patch"
    );

    if (response?.status !== 200) {
      toastr.error(
        response?.data?.error || "Could not mark this member as seen"
      );
      return false;
    }

    toastr.success("Member marked as seen");
    dispatch(getCourtsSlotsForBookingPageView(dates));
    return true;
  };
};
export const editSlot = (data, startDate, endDate) => {
  return async (dispatch) => {
    let url = `booking/slot/${data.bookingId}`;
    api(url, { dateTime: data.dateTime,isMovedToAvailabeLocation:data.isMovedToAvailabeLocation}, "patch")
      .then((res) => {
        if(res.status==200){
          toastr.success("Slot Booking Edited");
           dispatch(getCourtsSlotsForBookingPageView({ startDate, endDate}));
        }
       else {
         toastr.error(res?.data?.message||"Something went wrong, please try again")
       }

      })
      .catch((err) => {
        toastr.error("Something went wrong, please try again")});
  };
};
export const cancelAppointment = (data, startDate, endDate,type,action,dates) => {
  return async (dispatch) => {
    let url = `booking/appointment/cancelBookdedAppointment/${data.bookingId}`;
    return api(url, {
      cancelationType: data.cancelationType,
      isHidden: data.isHidden || false,
      cancelRecurring: Boolean(data.cancelRecurring),
    }, "post")
      .then((res) => {
        if (!res || res.status >= 400 || res?.data?.status >= 400) {
          toastr.error(
            res?.data?.error || "Could not cancel the appointment"
          );
          return false;
        }
        toastr.success(
          data.cancelRecurring
            ? res?.data?.message || "Recurring appointments canceled"
            : "Appointment Canceled"
        );
        if (startDate && endDate)
          dispatch(
            getAppointmentBookingByMonth({ start: startDate, end: endDate })
          );
          if(type&&type=="complex"){
            const startDate=dates.startDate||moment(new Date())
              .startOf("day")
              .valueOf()
            const endDate=dates.endDate|| moment(new Date())
                  .endOf("day")
                  .valueOf()
              dispatch(
                getCourtsSlotsForBookingPageView({
                  startDate,
                  endDate,
                })
              );
          }
          if(action){
            dispatch(getDataAgain({action:action,status:true}))
      
          }
        return true;
      })
      .catch((err) => {
        toastr.error(
          err?.response?.data?.error ||
            "Something went wrong, please try again"
        );
        return false;
      });
  };
};
export const checkinAppointment = (
  packageAppointmentMemberId,
  bookingAppointmentId,
  courtSlotBooking,getBookingList,redirectToMemberProfile=false,memberId,dates
) => {
  return async (dispatch) => {
    let url = `member/checkInAppointment/${packageAppointmentMemberId}/${bookingAppointmentId}`;
    try {
      const res = await api(url, { courtSlotBooking }, "post");
      if (res.status !== 201) {
        // throw new Error(res.data.error);
        if(res.status === 500){
            return toastr.error("something went wrong, please try again")
          }
          if(res?.data?.data?.error) return toastr.error(res?.data?.data?.error)
          else return toastr.error("Declined", "Member already checked in")  
      }
      if(redirectToMemberProfile&&memberId){
          return history.push(`/gym-panel/membersinfo/${memberId}`);
      }
      if(getBookingList){
        const startDate=dates.startDate||moment(new Date())
              .startOf("day")
              .valueOf()
         const endDate=dates.endDate|| moment(new Date())
              .endOf("day")
              .valueOf()
        dispatch(
          getCourtsSlotsForBookingPageView({
            startDate,
            endDate,
          })
        );
      }
      toastr.success("Checked in");
      return;
    } catch (e) {
      console.log({e})
      toastr.error("Declined", "Member already checked in");
    }
  };
};
export const unCheckInAppointment = (
  packageAppointmentMemberId,
  bookingAppointmentId,
  getBookingList,
  dates
) => {
  return async (dispatch) => {
    let url = `member/unCheckInAppointment/${packageAppointmentMemberId}/${bookingAppointmentId}`;
    try {
      const res = await api(url, {}, "post");
      console.log(res);
      if (res.status !== 201) {
        console.log(res.data.error);
        // throw new Error(res.data.error);
        return toastr.error("Declined", "Member has not checked in");
      }
      if(getBookingList){
        const startDate=dates.startDate||moment(new Date())
              .startOf("day")
              .valueOf()
         const endDate=dates.endDate|| moment(new Date())
              .endOf("day")
              .valueOf()

        dispatch(
          getCourtsSlotsForBookingPageView({
            startDate,
            endDate,
          })
        );
      }
      toastr.success("Checked in Member Canceled");
      return;
    } catch (e) {
      toastr.error("Declined", "Member already checked in");
    }
  };
};

export const checkinGym = (packGymMemberId, courtSlotBooking) => {
  return async (dispatch) => {
    let url = `gym/checkin/${packGymMemberId}`;
    try {
      let res = await api(url, { courtSlotBooking }, "post");
      if (res.status == 200 || res.status == 201) {
        toastr.success("Checked in ");
        history.push("/gym-panel/check-in");
      } else {
        console.log({ res });
        toastr.error(res?.data?.error);
      }
    } catch (e) {
      toastr.error("Something went wrong, please try again");
    }
  };
};
export const unCheckIn = (packGymMemberId,bookingCourtSlot) => {
  return async (dispatch) => {
    let url = `gym/unCheckIn/${packGymMemberId}`;

    try {
      let res = await api(url, {bookingCourtSlot}, "post");
      toastr.success("Checked in Canceled ");
      history.push("/gym-panel/check-in");
    } catch (e) {
      toastr.error("Something went wrong, please try again");
    }
  };
};

export const listCheckins = (member, classId, date, endDate, page = 1, limit = 20) => {
  return async (dispatch) => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Operation canceled due to new request.");
    }
    cancelTokenSource = generateCancelTokenSource();
    let params = new URLSearchParams();
    if (date) params.append("date", date);
    if (endDate) params.append("endDate", endDate);
    if (member) params.append("member", member);
    if (classId) params.append("classId", classId);
    params.append("page", page);
    params.append("limit", limit);
    const url = `gym/getCheckIns?${params.toString()}`;

    try {
      dispatch(resetCheckinsData());
      let res = await api(url, {}, "get",null,cancelTokenSource.token);
      if (res) {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("Some error occurred");
        } else {
             dispatch(setCheckinsData(res.data));

        }
      }
    } catch (err) {
      console.error(err);
      if (isCancelAxios(err)) {
        console.log("Request canceled", err.message);
      } else {
        // Handle error
        toastr.error("An error occurred while fetching data");
      }
    }
  };
};

export const togglePackageActivation = (id, type) => {
  return async (dispatch, store) => {
    let url = `package/${id}/toggleActivation`;
    await api(url, {}, "patch")
      .then((res) => {
        toastr.success(res.data.message);
        store().packages.deactivateModalOpen
          ? dispatch(toggleDeactivateModalOpen())
          : dispatch(toggleActivateModalOpen());
      })
      .then(() => dispatch(getPackages(1, 1000, type)))

      .catch((err) => {
        toastr.error(err.message);
      });
  };
};

export const getMembersFiltered = (
  page,
  limit,
  search,
  sort = "createdAt desc",
  planType
) => {
  return async (dispatch, store) => {
    let url = search
      ? `member?page=${page}&limit=${limit}&name=${search}&planType=${planType}`
      : `member?page=${page}&limit=${limit}&sort=${sort}&planType=${planType}`;
    await api(url, {}, "get")
      .then((res) => {
        if (res.status !== 200) {
          toastr.error("some error occured");
        } else {
          dispatch(setMembersData(res.data.data));
        }
      })
      .catch((err) => {});
  };
};

export const getMembersAssociatedWithTrainer = ({
  page,
  limit,
  search,
  filter,
  sort,
}) => {
  return async (dispatch, store) => {
    try {
      let url = `member/getMembersAssociatedWithTrainer?page=${page}&limit=${limit}`;
      if (!!search) url += `&search=${search}`;
      if (!!filter) url += `&filter=${filter}`;
      if (!!sort) url += `&sort=${sort}`;

      const members = await api(url, {}, "get");
      // dispatch(setMembersData(members))
    } catch (err) {
      console.log(err);
    }
  };
};

export const getTrainerScheduleForCalendar = ({ start, end }) => {
  return async (dispatch, store) => {
    try {
      let url = `trainer/getTrainerScheduleForCalendar?start=${start}&end=${end}`;
      const response = await api(url, {}, "get");
      dispatch(setTrainerCalendarSchedule(response.data.data));
    } catch (err) {
      console.log(err);
    }
  };
};

export const getSaledDetails = (payload) => {
  return async (dispatch, store) => {
    let { member, limit, page, outstandingOnly } = payload;
    const outstanding =
      outstandingOnly === "1" ||
      outstandingOnly === 1 ||
      outstandingOnly === true;
    let res = await api(
      `reports/accountBalanceDetails?member=${member}&page=${page}&limit=${limit}${
        outstanding ? "&outstandingOnly=1" : ""
      }`,
      {},
      "get"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setSalesDetailsData(res.data.data));
      dispatch(setSalesDetailsCount(res.data.totalCount));
    }
  };
};

export const settleAccountBalance = (payload) => {
  return async (dispatch, getState) => {
    let { limit, page, detailsPage, detailsLimit, reportQuery } = getState().report;
    let res = await api(
      "member/membership/settleBalance",
      payload,
      "patch"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      toastr.success("Balance has been setteled");
      dispatch(
        getSaledDetails({
          member: payload.member,
          limit: detailsLimit,
          page: detailsPage,
          outstandingOnly: reportQuery?.outstandingOnly,
        })
      );
      dispatch(getReports({ reportName: "accountBalance", page, limit }));
    }
  };
};

export const getExpiringToday = (payload) => {
  return async (dispatch, store) => {
    let res = await api(
      `expiringTodayMemberships`,
      {},
      "get"
    ).then((res)=>{
      if (res.status === 400 || res.status === 500) {
        toastr.error("some error occured");
      } else {
        dispatch(setExpiringTodayData(res.data.data));
      }
    }).catch((err) => {});

  };
};

export const getGymFeatures = (id) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api(`gymFeatures/${id}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setGymFeatures(res.data.data));
          let gymFeatures = res.data.data;
          let customisedFeatures = {};
          for (let i = 0; i < gymFeatures.length; i++) {
            customisedFeatures[gymFeatures[i].featureName] =
              gymFeatures[i].featureValue == "ENABLED" ? true : false;
          }
          dispatch(setFeatures(customisedFeatures));
        }
      })
      .catch((err) => {});
  };
};

export const getPaymentGatewaysFields = (gateway) => async (dispatch) => {
  try {
    const url = `setting/gateway/${gateway}`;
    const res = await api(url, {}, "get");

    if (res.status === 200) {
      dispatch(setPaymentGatewaysFields(res.data.data));
    }
  } catch (err) {}
};

export const setPaymentFieldsValue = (key, value, enabled) => async (
  dispatch
) => {
  try {
    const url = "setting/payment";
    const data = {
      key: key,
      value: value,
      enabled: enabled,
    };

    const response = await api(url, data, "post");

    if (response.status === 200) {
      dispatch(setSaveGatewayValueFields(response));
      toastr.success(response.data.message);
    } else {
      toastr.error(`Authentication with ${key} failed`);
    }
  } catch (err) {
    dispatch({
      type: SET_PAYMENT_GATEWAY_FIELDS_ERROR,
      payload: err.toString(),
    });
  }
};

export const downloadTemplate = () => {
  return async (dispatch, store) => {
    let res = await api(
      `member/import/downloadTemplate`,
      {},
      "get",
      "blob"
    ).catch((err) => {
      console.error("Error While downloading template", err);
      toastr.error("Error While downloading template");
    });

    if (res.status === 200) {
    } else if (res.status !== 201) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Error While downloading template");
    } else {
    }

    return res;
  };
};

export const getGymMemberByMembershipCardNumber = (cardMembershipId) => {
  return async (dispatch, store) => {
    let url = `member/getGymMemberByMembershipCardNumber/${cardMembershipId}`;
    try {
      let res = await api(url, {}, "get");
      if (res && res.status !== 200) {
        toastr.error("some error occured");
      } else {
        const member = res.data.data ? res.data.data : {};
        dispatch(setMemberGymByMembershipCardId(member));
        return member;
      }
    } catch (error) {
      const _error = typeof error == "string" ? error : JSON.stringify(error);
      toastr.error(`Error:: ${_error}`);
    }
  };
};

export const deleteMembershipCard = (cardNumber) => {
  return async (dispatch, store) => {
    let res = await api(
      `membershipcard/${cardNumber}`,
      {},
      "delete"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error(res.data.error);
    } else {
      toastr.success("Success:Delete Membership Card");
    }
    history.push("/gym-panel/memberslist");
  };
};

export const freezeMembershipCard = (cardNumber) => {
  return async (dispatch, store) => {
    let res = await api(
      `membershipcard/freeze/${cardNumber}`,
      {},
      "patch"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error(res.data.error);
    } else {
      toastr.success("Success:Freezed Membership Card");
    }
    history.push("/gym-panel/memberslist");
  };
};

export const unfreezeMembershipCard = (cardNumber) => {
  return async (dispatch, store) => {
    let res = await api(
      `membershipcard/unfreeze/${cardNumber}`,
      {},
      "patch"
    ).catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error(res.data.error);
    } else {
      toastr.success("Success:Unfreezed Membership Card");
    }
    history.push("/gym-panel/memberslist");
  };
};

export const ReplaceGymMemberMembershipCard = (
  id,
  oldCardId,
  newCardId,
  product,
  paymentType
) => {
  return async (dispatch, store) => {
    const res = await api(
      `member/${id}/gym/replaceMembershipCard`,
      { oldCardId, newCardId, product, paymentType },
      "patch"
    ).catch((err) => {
      toastr.error("Error:Unable to Replace Membership Card");
    });
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status == 400) {
      toastr.error(res.data.error);
    } else {
      toastr.success("Success:Replaced Membership Card");
    }
    history.push("/gym-panel/memberslist");
  };
};

export const createGate = (data) => {
  if (skipVoiceCreate(data)) return () => {};
  return async (dispatch, store) => {
    const body = {
      gateName: data.name,
      type: data.type,
      openingSchedule: data.openingSchedule,
    };
    await api(`gym/gate`, body, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          toastr.success("Success: Added Gate");
          dispatch(addGateModal(false));

          history.push("/gym-panel/gate");
        }
      })
      .catch((err) => {
        toastr.error("some error occured");
      });
  };
};

export const getGates = (limit = 10, page = 1, search = "") => {
  return async (dispatch, store) => {
    await api(
      `gym/gate?page=${page}&limit=${limit}&search=${search}`,
      {},
      "get"
    )
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setGateCount(res.data.totalCount));
          dispatch(setGatesData(res.data.data));
        }
      })
      .catch((err) => {
        toastr.error("some error occured");
      });
  };
};

export const getGate = (id) => {
  return async (dispatch, store) => {
    await api(`gym/gate/${id}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setGateData(res.data.data));
        }
      })
      .catch((err) => {
        toastr.error("some error occured");
      });
  };
};

export const updateGate = (id, value) => {
  return async (dispatch, store) => {
    await api(`gym/gate/${id}`, value, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          toastr.success("Success: Gate Updated");
          dispatch(addGateModal(false));
          dispatch(getGates());
          history.push("/gym-panel/gate");
        }
      })
      .catch((err) => {
        toastr.error("some error occured");
      });
  };
};

export const deleteGate = (id) => {
  return async (dispatch, store) => {
    let res = await api(`gym/gate/${id}`, {}, "delete").catch((err) => {
      toastr.error("some error occured");
    });
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error(res.data.error);
    } else {
      toastr.success("Success:Delete Gate");
      history.push("/gym-panel/gate");
    }
  };
};

// ===================== Permanent Access (QR Codes & RFID Cards) =====================

export const getPermanentAccessList = (limit = 50, page = 1, search = "", accessType = "") => {
  return async (dispatch, store) => {
    dispatch(setPermanentAccessLoading(true));
    let url = `gym/gate-permanent-access?page=${page}&limit=${limit}`;
    if (search) url += `&search=${search}`;
    if (accessType) url += `&accessType=${accessType}`;
    
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error(res.data.error || "Error fetching permanent access list");
        } else {
          dispatch(setPermanentAccessCount(res.data.totalCount));
          dispatch(setPermanentAccessData(res.data.data));
        }
      })
      .catch((err) => {
        toastr.error("Error fetching permanent access list");
      })
      .finally(() => {
        dispatch(setPermanentAccessLoading(false));
      });
  };
};

export const generateQRCode = (label = "") => {
  return async (dispatch, store) => {
    dispatch(setPermanentAccessLoading(true));
    await api(`gym/gate-permanent-access/generate-qr`, { label }, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error(res.data.error || "Error generating QR code");
        } else {
          toastr.success("QR Code generated successfully");
          dispatch(getPermanentAccessList());
        }
      })
      .catch((err) => {
        toastr.error("Error generating QR code");
      })
      .finally(() => {
        dispatch(setPermanentAccessLoading(false));
      });
  };
};

export const registerRFIDCard = (rfidCode, label = "") => {
  return async (dispatch, store) => {
    dispatch(setPermanentAccessLoading(true));
    await api(`gym/gate-permanent-access/scan-rfid`, { rfidCode, label }, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error(res.data.error || "Error registering RFID card");
        } else {
          toastr.success("RFID card registered successfully");
          dispatch(getPermanentAccessList());
        }
      })
      .catch((err) => {
        toastr.error("Error registering RFID card");
      })
      .finally(() => {
        dispatch(setPermanentAccessLoading(false));
      });
  };
};

export const updatePermanentAccess = (id, data) => {
  return async (dispatch, store) => {
    dispatch(setPermanentAccessLoading(true));
    await api(`gym/gate-permanent-access/${id}`, data, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error(res.data.error || "Error updating permanent access");
        } else {
          toastr.success("Permanent access updated successfully");
          dispatch(getPermanentAccessList());
        }
      })
      .catch((err) => {
        toastr.error("Error updating permanent access");
      })
      .finally(() => {
        dispatch(setPermanentAccessLoading(false));
      });
  };
};

export const deletePermanentAccess = (id) => {
  return async (dispatch, store) => {
    dispatch(setPermanentAccessLoading(true));
    await api(`gym/gate-permanent-access/${id}`, {}, "delete")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error(res.data.error || "Error deleting permanent access");
        } else {
          toastr.success("Permanent access deleted successfully");
          dispatch(getPermanentAccessList());
        }
      })
      .catch((err) => {
        toastr.error("Error deleting permanent access");
      })
      .finally(() => {
        dispatch(setPermanentAccessLoading(false));
      });
  };
};

// ===================== End Permanent Access =====================

export const getPaymentGatewaysByRegion = (region) => async (dispatch) => {
  try {
    const url = `setting/region/${region}`;
    const res = await api(url, {}, "get");

    if (res.status === 200) {
      dispatch(setPaymentGateways(res.data.data));
    }
  } catch (err) {}
};

export const getPaymentGatewayFieldsValue = (paymentGateway) => async (
  dispatch
) => {
  try {
    const url = `setting/payment/${paymentGateway}`;
    const res = await api(url, {}, "get");

    if (res.status === 200) {
      dispatch(setPaymentGatewayFieldSValue(res.data.data));
    }
  } catch (err) {}
};

export const getPaymentGatewaysUsed = () => async (dispatch) => {
  try {
    const url = `setting/payment-gateway-used`;
    const res = await api(url, {}, "get");

    if (res.status === 200) {
      dispatch(setPaymentGatewaysUsed(res.data.data));
    } else {
      toastr.error(`Erorr`);
    }
  } catch (err) {}
};

export const getClientToRist = () => {
  return async (dispatch) => {
    let res = await api(`gym/members/at-risk`, {}, "get");
    dispatch(setMemberAtRisk(res.data));
  };
};
 let cancelGetStatusTokenSource=''
export const getStats = (start, end) => {
   return async (dispatch) => {
    if (cancelGetStatusTokenSource) {
      cancelGetStatusTokenSource.cancel("Operation canceled due to new request.");
    }
    // Create a new CancelToken source
     cancelGetStatusTokenSource = generateCancelTokenSource();
    let params = new URLSearchParams();
    if (start) params.append("startDate", start);
    if (end) params.append("endDate", end);
    const url = `gym/dashboard/stats?${params.toString()}`;

    try {
      let res = await api(url, {}, "get",null,cancelGetStatusTokenSource.token);
      if (res) {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("Some error occurred");
        } else {
             dispatch(setStats(res.data.data))

        }
      }
    } catch (err) {
      console.error(err);
      if (isCancelAxios(err)) {
        console.log("Request canceled", err.message);
      } else {
        // Handle error
        toastr.error("An error occurred while fetching data");
      }
    }
  };
};
export const importMembers = (data) => {
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(`member/import`, data, "post").catch((err) => {
      console.error("Error While importing data", err);
      toastr.error("Error while importing data");
    });

    if (res.status === 200) {
      dispatch(setLoading(false));
    } else if (res.status !== 201) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Error while importing data");
    } else {
      toastr.success("Success:Imported Members");
      dispatch(setLoading(false));
    }
    if (res.data && res.data.failedRecordsExcel) {
      // Download Excel file for failed records
      downloadFailedRecordsExcel(
        res.data.failedRecordsExcel,
        "Members_Failed_Records"
      );
    }
    JSON.parse(localStorage.getItem("connectToFitGymPanelUser")) &&
    JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
      "TRAINER"
      ? history.push("/trainer-panel/memberslist")
      : history.push("/gym-panel/memberslist");
  };
};

export const downloadMembersTemplate = () => {
  return async (dispatch, store) => {
    let res = await api(
      `member/import/downloadTemplate`,
      {},
      "get",
      "blob"
    ).catch((err) => {
      console.error("Error While downloading template", err);
      toastr.error("Error While downloading template");
    });

    if (res.status === 200) {
    } else if (res.status !== 201) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Error While downloading template");
    } else {
    }

    return res;
  };
};

export const importPackages = (data) => {
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(`package/import`, data, "post").catch((err) => {
      console.error("Error While importing packages data", err);
      toastr.error("Error while importing packages data");
    });

    if (res.status === 200) {
      dispatch(setLoading(false));
    } else if (res.status !== 201) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Error while importing packages data");
    } else {
      toastr.success("Success:Imported Packages");
      dispatch(setLoading(false));
    }

    if (res.data && res.data.failedRecordsExcel) {
      // Download Excel file for failed records
      downloadFailedRecordsExcel(
        res.data.failedRecordsExcel,
        "Packages_Failed_Records"
      );
    }
    JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
    "TRAINER"
      ? history.push("/trainer-panel/packages")
      : history.push("/gym-panel/packages");
  };
};

export const downloadPackagesTemplate = () => {
  return async (dispatch, store) => {
    let res = await api(
      `package/import/downloadTemplate`,
      {},
      "get",
      "blob"
    ).catch((err) => {
      console.error("Error While downloading packages template", err);
      toastr.error("Error While downloading packages template");
    });

    if (res.status === 200) {
    } else if (res.status !== 201) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Error While downloading packages template");
    } else {
    }

    return res;
  };
};


export const getPayRatesType = () => {
  return async (dispatch) => {
    let res = await api(`payrate-types`, {}, "get");
    dispatch(setPayRatesType(res.data.data));
  };
}
export const getAppointmentTypes = () => {
  return async (dispatch) => {
    let res = await api(`appointment-types`, {}, "get");
    dispatch(setAppointmentTypes(res.data.data));
  };
}

export const setPayRatesApi = (value) => {
  return async (dispatch) => {
    let res = await api(`payrate/create`, value, "post");
    if(res.status === 201)
      toastr.success("Success: Added Pay Rate");
  };
}

export const getPayRates = (id) => {
  return async (dispatch) => {
    let res = await api(`payrates/${id}`, {}, "get");
    if(res && res.status === 200)
    dispatch(setPayRatesData(res.data));
  };
}

export const getPayRate = (id) => {
  return async (dispatch) => {
    let res = await api(`payrate/${id}`, {}, "get");
    if(res && res.status === 200)
    dispatch(setPayRate(res.data));
  };
}

export const updatePayRates = (id, value) => {
  return async (dispatch) => {
    let res = await api(`payrate-update/${id}`, value, "patch");
    if(res && res.status === 200)
    toastr.success("Success: Updated Pay Rate");
    else
    toastr.error("Error: Updated Pay Rate");
  };
}

export const getPayRatesByStaff = (id) => {
  return async (dispatch) => {
    let res = await api(`payrate/staff/${id}`, {}, "get");
    if(res && res.status === 200)
    dispatch(setPayRatesByStaff(res.data));
  };
}

export const importSales = (data) => {
  return async (dispatch, store) => {
    // dispatch(setLoading(true));
    let res = await api(`membership/import`, data, "post").catch((err) => {
      console.error("Error While importing sales data", err);
      toastr.error("Error while importing sales data");
    });

    if (res.status === 200) {
      // dispatch(setLoading(false));
    } else if (res.status !== 201) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Error while importing sales data");
    } else {
      toastr.success("Success:Imported sales");
      // dispatch(setLoading(false));
    }

    if (res.data && res.data.failedRecordsExcel) {
      // Download Excel file for failed records
      downloadFailedRecordsExcel(
        res.data.failedRecordsExcel,
        "Sales_Failed_Records"
      );
    }
    JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role ===
    "TRAINER"
      ? history.push("/trainer-panel/packages")
      : history.push("/gym-panel/packages");
  };
};

export const downloadSalesTemplate = () => {
  return async (dispatch, store) => {
    let res = await api(
      `membership/import/downloadTemplate`,
      {},
      "get",
      "blob"
    ).catch((err) => {
      console.error("Error While downloading sales template", err);
      toastr.error("Error While downloading sales template");
    });

    if (res.status === 200) {
    } else if (res.status !== 201) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Error While downloading sales template");
    } else {
    }

    return res;
  };
};
export const downloadFailedNotificationTemplate = (fileName) => {
  return async (dispatch, store) => {
    let res = await api(
      `notifications/import/downloadFailedTemplate?fileName=${fileName}`,
      {},
      "get",
      "blob"
    ).catch((err) => {
      console.error("Error While downloading failed Notifications template", err);
      toastr.error("Error While downloading failed Notifications template");
    });

    if (res.status === 200) {
    } else if (res.status !== 201) {
      if (res?.data?.error) toastr.error(res.data.error);
      else toastr.error("Error While downloading sales template");
    } else {
    }

    return res;
  };
};

export const setPackageHasClassAccess = (value, packageObj) => {
  return async (dispatch, store) => {
    const url = `package/${packageObj.id}/setHasClassessAccess`;
    await api(url, value, "patch")
      .then((res) => {
        toastr.success(res.data.message || "Suceess:Package Update");
        dispatch(toggleSetPackageToBookAllClassesModalOpen());
      })
      .then(() =>
        dispatch(getPackages(1, 1000, packageObj.isActive == 1 ? true : false))
      )

      .catch((err) => {
        toastr.error(err.message || "Error While Updating Package!");
      });
  };
};

export const createCourt = (value) => {
  if (skipVoiceCreate(value)) return () => {};
  return async (dispatch, store) => {
    await api(`court`, value, "post")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("Error while creating court!");
        } else {
          dispatch(setCourtModal(false));
          toastr.success("Success: Added");
          history.push("/gym-panel/courtslist");
        }
      })
      .catch((err) => {});
  };
};

export const getCourts = (
courtType,
options = {}
) => {
  return async (dispatch, store) => {
    // let url = search
    //   ? `courts?gym=${gymId}&page=${page}&limit=${limit}&name=${search}&sort=${sort}&isActive=${filter}`
    //   : `courts?gym=${gymId}&page=${page}&limit=${limit}&sort=${sort}&isActive=${filter}`;
    const params = [];
    if (courtType) {
      params.push(`courtType=${encodeURIComponent(courtType)}`);
    }
    if (options.limit) {
      params.push(`limit=${options.limit}`);
    }
    if (options.status) {
      params.push(`status=${encodeURIComponent(options.status)}`);
    }
    let url = params.length ? `courts?${params.join("&")}` : "courts";
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setCourtsData(res.data.data));
          if (!res.data.totalCount) {
            res.data.totalCount = res.data.data.length;
          }
          dispatch(setCourtCount(res.data.totalCount));
        }
      })
      .catch((err) => {});
  };
};

export const getCourt = (id) => {
  return async (dispatch, store) => {
    await api(`court/${id}`, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setCourtData(res.data.data));
          // dispatch(setIntialCourtDate(res.data.data))
        }
      })
      .catch((err) => {});
  };
};
export const getBookingsForUpdatedSlots = (id,value) => {
  return async (dispatch, store) => {
    await api(`court/getBookingsForUpdatedSlots/${id}`, {...value}, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setBookingForUpdatedSlots(res.data.data));
          return res.data.data
          // dispatch(setIntialCourtDate(res.data.data))
        }
      })
      .catch((err) => {});
  };
};
export const earlyCancelAllBookingsForUpdatedSlots = (value) => {
  return async (dispatch, store) => {
    await api(`court/earlyCancelAllBookingsForUpdatedSlots`, {bookingIds:value}, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setBookingForUpdatedSlots(res.data.data));
          return res.data.data
          // dispatch(setIntialCourtDate(res.data.data))
        }
      })
      .catch((err) => {});
  };
};

export const updateCourtStatus = (id, status) => {
  return async (dispatch) => {
    const res = await api(`court/${id}/status`, { status }, "patch").catch(
      () => null
    );
    const failed =
      !res ||
      res.status === 400 ||
      String(res.status).startsWith("5") ||
      String(res?.response?.status).startsWith("5");
    if (failed) {
      toastr.error(
        res?.data?.message ||
          res?.response?.data?.message ||
          "Could not update court status"
      );
      return false;
    }
    toastr.success(status === "ACTIVE" ? "Court activated" : "Court deactivated");
    dispatch(getCourts());
    return true;
  };
};

export const updateCourt = (id, value) => {
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    await api(`court/${id}`, { ...value }, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          dispatch(setLoading(false));
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setLoading(false));
          toastr.success("Success : Updated");
          dispatch(setCourtData(res.data.data));
          history.push(`/gym-panel/courtslist`);
        }
        dispatch(setLoading(false));

      })
      .catch((err) => {
        dispatch(setLoading(false));
        toastr.error(err?.response?.data?.message || "Something went wrong!");
      });
  };
};
export const updateCourtSlots = (id, value) => {
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    await api(`court/updateSlots/${id}`, { ...value }, "patch")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error(res?.response?.data?.message||"Something went wrong!");
           dispatch(setLoading(false))
          return;
        }
        if (res.status === 400) {
          toastr.error(res?.data?.message||"some error occured");
        } else {
          dispatch(setLoading(false));
          toastr.success("Success : Updated");
          dispatch(setCourtData(res.data.data));
          history.push(`/gym-panel/courtslist`);
        }
        dispatch(setLoading(false));

      })
      .catch((err) => {});
  };
};
export const getSlotsTypes = (id, value) => {
  return async (dispatch, store) => {
    await api(`slots/types`, {  }, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setSlotsTypesData(res.data.data));
        }

      })
      .catch((err) => {});
  };
};
export const getCourtsSlotsForWeek = (startDate, court) => {
  return async (dispatch, store) => {
    let url = `courts/slots?startDate=${startDate}`;
    if (court) {
      url += `&court=${court}`;
    }
    api(url, {}, "get")
      .then((res) => {
        dispatch(setCourtsSlotsForWeek(res.data.data));
      })
      .catch((err) => toastr.error("Something went wrong, please try again"));
  };
};

export const getCourtDurations = () => {
  return async (dispatch, store) => {
    let url = `durations`;
    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setCourtDurations(res.data.data));
        }
      })
      .catch((err) => {});
  };
};
 
let cancelBookingTokenSource=''
export const getCourtsSlotsForBookingPageView = ({
  startDate = null,
  endDate = null,
  trainer = null,
  court = null,
  bookingStatus=null,
  bookingSource=null
}) => {
  return async (dispatch, store) => {
    if (cancelBookingTokenSource) {
      cancelBookingTokenSource.cancel("Operation canceled due to new request.");
    }
    // Create a new CancelToken source
    cancelBookingTokenSource = generateCancelTokenSource();
    let filter = {
      startDate,
      endDate,
      slotStatus: "booked",
      trainer,
      court,
      bookingStatus,
      bookingSource
    };
    const showCanceledBookings =
      store()?.gym?.gym?.settings?.onsiteBookingSetting?.showCanceledBookings
        ?.enabled === true;
    if (showCanceledBookings) {
      filter.showCanceledBookings = true;
    }
    console.log({filter})
    let params = {
      filter,
    };

    const queryString = Object.keys(params)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(
            JSON.stringify(params[key])
          )}`
      )
      .join("&");

    let url = `slots/bookings?${queryString}`;

    await api(url, {}, "get",null,cancelBookingTokenSource.token)
      .then((res) => {
       if(res){
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("Some error occurred");
        } else {
          const groupedData = groupByBookingDate(res.data.data);
          console.log({groupedData})
          res.data.data = [...groupedData,...res.data.classBookedBy];
          dispatch(
            setCourtsSlotsForBookingPageView({
              data: res.data.data,
              totalRecords: res.data.totalRecords,
            })
          );
        }
       }
      })
      .catch((err) => {
        if (isCancelAxios(err)) {
        console.log("Request canceled", err.message);
      } else {
        // Handle error
        toastr.error("An error occurred while fetching data");
      }
      });
  };
};
export const getBlockedSlots = ({
  startDate = null,
  endDate = null,
  trainer = null,
  bookingStatus=null,
  bookingSource=null


}) => {
  return async (dispatch, store) => {
    let filter = {
      startDate,
      endDate,
      trainer,
    };
    let params = {
      filter,
    };

    const queryString = Object.keys(params)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(
            JSON.stringify(params[key])
          )}`
      )
      .join("&");

    let url = `slots/blocked?${queryString}`;

    await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("Some error occurred");
        } else {
     
          dispatch(
            setCourtsSlotsBlockedForBookingPageView(
             res.data.data,
            )
          );
          dispatch(
            getCourtsSlotsForBookingPageView({
              startDate:startDate ,
              endDate:endDate,
              bookingStatus, 
              bookingSource


            })
          );
        }
      })
      .catch((err) => {
        toastr.error("An error occurred while fetching the slots");
      });
  };
};
 let cancelSearchTokenSource=''

export const getCourtsSlotsForBookingWindow = ({
  type = [], // array of slot types (e.g., ["onlyCourt", "groupSession", "privateLesson"])
  startDate = null, //timestamp
  endDate = null, //timestamp
  court = [], // array of court ids (e.g., [1, 2])
  courtType = [], // array of court types (e.g., ["tennis", "padel"])
  appointment = [], // array of appointment ids (e.g., [2, 3])
  duration = [], // array of duration ids (e.g., [1, 6])
  slotStatus = "available", // status of the slot ("available", "booked", "all")
  instructor = [], // array of instructor ids (e.g., [1, 3])
  limit = 200, // maximum number of results to return
  page = 1, // page number for pagination
  day = [],
  timeFormat = 24,
  sort = { date: -1 }, // sorting criteria (default: date descending) (e,g., {date: -1, duration: -1, court: "desc"})
}) => {
  return async (dispatch, store) => {
    try {
      let filter = {
        type,
        startDate,
        endDate,
        court,
        courtType,
        appointment,
        duration,
        slotStatus,
        instructor,
        day,
        timeFormat,
      };
      let params = {
        filter,
        timeFormat,
        limit,
        page,
        sort,
      };

      const queryString = Object.keys(params)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(
              JSON.stringify(params[key])
            )}`
        )
        .join("&");

      let url = `slots/search?${queryString}`;
      if (cancelSearchTokenSource) {
        cancelSearchTokenSource.cancel("Operation canceled due to new request.");
      }

      // Create a new CancelToken source
      cancelSearchTokenSource = generateCancelTokenSource();
      const res = await api(url, {}, "get",null,cancelSearchTokenSource.token);
      if(res){
          if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
            toastr.error("Something went wrong!");
            return;
          }
          if (res.status === 400) {
            toastr.error("Some error occurred");
          } else {
            res.data.data.forEach((s) => {
              s.name = s.slotLabel || s.slotStartLabel || s.slotStart;
            });
            dispatch(
              setCourtsSlotsForBookingWindow({
                data: res.data.data,
                totalRecords: res?.data.totalRecords,
              })
            );
          }
      }
  
    } catch (err) {
      console.error(err);
      if (isCancelAxios(err)) {
        console.log("Request canceled", err.message);
      } else {
        // Handle error
        toastr.error("An error occurred while fetching data");
      }
    }
  };
};

export const cancelCourtSlotBooking = (
  {
    slotId,
    isLate,
    packageClassMember = null,
    packageAppointmentMember = null,
    packageGymMember = null,
    memberId,
    bookingAppointment,
    cancelAppointment,
    id,
  },
  dates,
  getMemberBookings = false
) => {
  return async (dispatch, store) => {
    let url = "slot/booking/cancel";
    api(
      url,
      {
        slotId,
        isLate,
        packageClassMember,
        packageAppointmentMember,
        packageGymMember,
        memberId,
        bookingAppointment,
        cancelAppointment,
        id,
      },
      "post"
    )
      .then((res) => {
        if (res.status === 200) {
          toastr.success("Booking canceled successfully");
          dispatch(
            getCourtsSlotsForBookingPageView({
              startDate: dates ? dates?.startDate : moment().valueOf(),
              endDate: dates
                ? dates?.endDate
                : moment()
                    .clone()
                    .add("1", "month")
                    .startOf("month")
                    .valueOf(),
            })
          );
          if (getMemberBookings) {
            dispatch(
              getMemberTabsInfo({
                params: "visits",
                page: store().member.dataPage,
                limit: store().member.dataLimit,
                member: memberId,
              })
            );
          }
        } else toastr.error(res.message);
      })
      .catch((err) => console.log(err));
  };
};
export const unblockSlot = (
  {
  id
  },
  dates,
) => {
  return async (dispatch, store) => {
    let url = `slot/unblock/${id}`;
    api(
      url,
      {},
      "delete"
    )
      .then((res) => {
        if (res.status === 200) {
          toastr.success("Time unblocked successfully");
          dispatch(
            getBlockedSlots({
              startDate: dates ? dates?.startDate : moment().valueOf(),
              endDate: dates
                ? dates?.endDate
                : moment()
                    .clone()
                    .add("1", "month")
                    .startOf("month")
                    .valueOf(),
            })
          );
      
        } else toastr.error(res.message);
      })
      .catch((err) => console.log(err));
  };
};

const courtBlockRange = (dates) => ({
  startDate: dates ? dates?.startDate : moment().valueOf(),
  endDate: dates
    ? dates?.endDate
    : moment()
        .clone()
        .add(1, "month")
        .startOf("month")
        .valueOf(),
});

export const getCourtBlockedSlots = ({
  startDate = null,
  endDate = null,
  court = null,
} = {}) => {
  return async (dispatch) => {
    const filter = { startDate, endDate, court };
    const queryString = `filter=${encodeURIComponent(JSON.stringify(filter))}`;
    await api(`court/blockSlots?${queryString}`, {}, "get")
      .then((res) => {
        if (
          String(res.status).startsWith("5") ||
          String(res?.response?.status).startsWith("5")
        ) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error(res?.data?.message || "Some error occurred");
          return;
        }
        dispatch(setCourtBlockedSlotsForBookingPageView(res.data.data || []));
      })
      .catch(() => {
        toastr.error("An error occurred while fetching blocked court slots");
      });
  };
};

export const blockCourtSlots = (body, currentDates) => {
  return async (dispatch) => {
    const res = await api("court/blockSlots", body, "post").catch(() => {
      toastr.error("Something went wrong!");
    });
    if (!res) return null;
    if (
      String(res.status).startsWith("5") ||
      String(res?.response?.status).startsWith("5")
    ) {
      toastr.error("Something went wrong!");
      return null;
    }
    if (res.status === 400) {
      toastr.error(res?.data?.message || res?.data?.error || "Some error occurred");
      return null;
    }

    const skipped = res?.data?.skipped || [];
    if (!res?.data?.data?.length) {
      toastr.warning(res?.data?.message || "No court slots were blocked");
    } else {
      toastr.success(res?.data?.message || "Court slots blocked successfully");
    }
    skipped.forEach((item) => {
      toastr.warning(
        `${moment(item.dateTime).format("DD/MM/YYYY HH:mm")} ${item.reason || ""}`,
        "",
        { timeOut: 6000 },
      );
    });

    dispatch(getCourtBlockedSlots(courtBlockRange(currentDates)));
    return res;
  };
};

export const copyCourtBlockedSlot = (
  { courtId, reason, allDay, duration, dateTimes },
  currentDates,
) => {
  return async (dispatch) => {
    const created = [];
    const skipped = [];
    for (const dateTime of dateTimes || []) {
      const start = moment(dateTime);
      const end = start.clone().add(duration || 60 * 60 * 1000, "ms");
      const body = {
        startDate: start.clone().startOf("day").valueOf(),
        endDate: start.clone().endOf("day").valueOf(),
        reason: reason || "Blocked by Gym",
        court: courtId,
        ...(allDay
          ? { blockAll: true }
          : {
              timeRanges: [
                `${start.format("HH:mm")}–${end.format("HH:mm")}`,
              ],
            }),
      };
      const res = await api("court/blockSlots", body, "post").catch(
        (err) => err?.response,
      );
      if (!res || res.status >= 400) {
        skipped.push({
          dateTime,
          reason: res?.data?.message || res?.data?.error || "Unable to copy",
        });
        continue;
      }
      created.push(...(res?.data?.data || []));
      (res?.data?.skipped || []).forEach((item) => skipped.push(item));
    }

    if (created.length) {
      toastr.success(`${created.length} blocked time(s) copied successfully`);
    } else {
      toastr.warning("No blocked times were copied");
    }
    skipped.forEach((item) => {
      toastr.warning(
        `${moment(item.dateTime).format("DD/MM/YYYY HH:mm")} ${item.reason || ""}`,
        "",
        { timeOut: 6000 },
      );
    });
    dispatch(getCourtBlockedSlots(courtBlockRange(currentDates)));
  };
};

export const unblockCourtSlot = ({ id }, dates) => {
  return async (dispatch) => {
    const res = await api(`court/blockSlots/${id}`, {}, "delete").catch(
      (err) => err?.response,
    );
    if (!res || res.status >= 500) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status >= 400) {
      toastr.error(res?.data?.message || res?.data?.error || "Unable to unblock");
      return;
    }
    toastr.success("Time unblocked successfully");
    dispatch(getCourtBlockedSlots(courtBlockRange(dates)));
  };
};
export const updateBookingAppointmentStatus = (
  {
  id,newStatus,bookingStatus
  },
  dates
) => {
  return async (dispatch, store) => {
    let url = `booking/updateStatus/${id}`;
    api(
      url,
      {newStatus},
      "patch"
    )
      .then((res) => {
        if (res.status === 200) {
          toastr.success("Status Updated successfully");
          dispatch(
            getCourtsSlotsForBookingPageView({
              startDate:dates?.startDate ,
              endDate:dates?.endDate,
              bookingStatus
            })
          );
          // );
      
        } else toastr.error(res.message);
      })
      .catch((err) => console.log(err));
  };
};
export const getTrainerAppointments = (trainerId) => {
  return async () => {
    const res = await api(`appointment?trainerId=${trainerId}`, {}, "get");
    if (res?.status === 200) return res.data?.data || [];
    toastr.error(
      res?.data?.error || res?.data?.message || "Could not load appointments"
    );
    return [];
  };
};
export const getAppointmentSubServices = (appointmentId) => {
  return async () => {
    if (!appointmentId) return [];
    const res = await api(`appointment/${appointmentId}`, {}, "get");
    if (res?.status !== 200) return [];
    return (res.data?.data?.subServices || []).filter(
      (service) => service.isActive && !service.isDeleted
    );
  };
};
export const updateUnpaidBookingAppointment = ({
  bookingId,
  appointment,
  subService,
  dates,
}) => {
  return async (dispatch) => {
    const res = await api(
      `booking/appointment/${bookingId}/unpaid-service`,
      { appointment, subService: subService || null },
      "patch"
    );
    if (!res || res.status !== 200) {
      toastr.error(
        res?.data?.error ||
          res?.data?.message ||
          "Could not update the appointment"
      );
      return false;
    }
    toastr.success("Appointment updated");
    if (dates?.startDate && dates?.endDate) {
      dispatch(
        getCourtsSlotsForBookingPageView({
          startDate: dates.startDate,
          endDate: dates.endDate,
        })
      );
    }
    return true;
  };
};
export const updateBookingSubService = (id,
  data,
  dates
) => {
  return async (dispatch, store) => {
    let url = `booking/subService/${id}`;
    api(
      url,
      data,
      "patch"
    )
      .then((res) => {
        if (res.status === 200) {
          toastr.success("sub service Updated successfully");
          dispatch(
            getCourtsSlotsForBookingPageView({
              startDate:dates?.startDate ,
              endDate:dates?.endDate,
            })
          );
          // );
      
        } else toastr.error(res.message);
      })
      .catch((err) => console.log(err));
  };
};
export const updateAppointmentBooking = (args) =>
  updateClassBooking({
    ...args,
    endpoint: `booking/updateAppointmentBooking/${args.id}`,
  });
export const updateCourtSlotBooking = (args) =>
  updateClassBooking({
    ...args,
    endpoint: `booking/updateCourtSlotBooking/${args.id}`,
  });
export const updateClassBooking=({id,body,classId,callBackFunction,dates,endpoint}) => {
  return async (dispatch, store) => {
    let url = endpoint || `booking/updateClassBooking/${id}`;
    api(
      url,
      body,
      "patch"
    )
      .then((res) => {
        if (res.status === 200) {
          const savedNote =
            typeof body?.note === "string" ? body.note.trim() : null;
          toastr.success(
            savedNote === ""
              ? "Booking note deleted"
              : savedNote !== null
              ? "Booking note saved"
              : "Booking updated successfully"
          );
          if(classId)dispatch(getClass(classId));
          if(callBackFunction)callBackFunction()
          if(dates){
          const startDate=dates.startDate||moment(new Date())
          .startOf("day")
          .valueOf()
          const endDate=dates.endDate|| moment(new Date())
                .endOf("day")
                .valueOf()
          dispatch(
            getCourtsSlotsForBookingPageView({
              startDate,
              endDate,
            })
          );
        }
          // );
      
        } else toastr.error(res.message);
      })
      .catch((err) => console.log(err));
  };
};
export const startStaffSession = ({ cashId, startCashOnSiteAmount }) => {
  return async (dispatch, store) => {
    const url = `switchStaff/startSession`;
    await api(
      url,
      {
        startCashOnSiteAmount,
        cashId,
      },
      "post"
    )
      .then((res) => {
        res = res?.response?.data
          ? res.response.data
          : res?.data
          ? res.data
          : res;
        let data = res?.data ? res.data : res;

        if (res?.status == 200) {
          toastr.success(res?.message || "Suceess:Staff Session Started.");
          dispatch(getUserOpenedStaffSessions());
        } else {
          toastr.error(
            typeof res?.error == "string"
              ? res?.error
              : "Error While Starting Staff Session!"
          );
        }
        dispatch(setStartStaffSessionModalOpen(false));
        history.push("/gym-panel/reports/staffSessions");
      })
      .catch((err) => {
        toastr.error(
          err.message
            ? err.message
            : typeof err == "string"
            ? err
            : "Error While Starting Staff Session!"
        );
        dispatch(setStartStaffSessionModalOpen(false));
      });
  };
};

export const endStaffSession = ({
  staffSessionId,
  assignedStaffToConfirm,
  endCashOnSiteAmount,
}) => {
  return async (dispatch, store) => {
    const url = `switchStaff/${staffSessionId}/closeSession`;
    await api(
      url,
      {
        id: staffSessionId,
        assignedStaffToConfirm,
        endCashOnSiteAmount,
      },
      "patch"
    )
      .then((res) => {
        if (res?.status == 200) {
          toastr.success(res.data.message || "Suceess:Staff Session Ended.");
          dispatch(getUserOpenedStaffSessions());
          history.push("/gym-panel/reports/staffSessions");
        } else {
          toastr.error(
            typeof res?.error == "string"
              ? res?.error
              : "Error While Closing Staff Session!"
          );
        }
        dispatch(setEndStaffSessionModalOpen(false));
      })
      .catch((err) => {
        toastr.error(
          err.message
            ? err.message
            : typeof err == "string"
            ? err
            : "Error While Ending Staff Session!"
        );
        dispatch(setEndStaffSessionModalOpen(false));
      });
  };
};

//confirm staff session
export const confirmCloseStaffSession = ({
  staffSessionId,
  cashOnSiteConfirmedAmount,
}) => {
  return async (dispatch, store) => {
    const body = {
      cashOnSiteConfirmedAmount,
    };
    const url = `switchStaff/${staffSessionId}/confirmSession`;
    await api(url, body, "patch")
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success(
            res.data.message || "Suceess:Staff Session Confirmed."
          );
          dispatch(getStaffSessionsToVerify());
          history.push("/gym-panel/reports/staffSessions");
        } else {
          toastr.error(
            typeof res?.data?.error == "string"
            ? res.data.error
            : "Error While Confirming Staff Session!"
          );
        }
        dispatch(setConfirmCloseStaffSessionModalOpen(false));
        dispatch(setVerifyAndInfoStaffSessionsModalOpen(false));
      })
      .catch((err) => {
        dispatch(setConfirmCloseStaffSessionModalOpen(false));
        dispatch(setVerifyAndInfoStaffSessionsModalOpen(false));
        toastr.error(
          err.message || "Error While Confirming Staff Session!"
        );
      });
  };
};

export const getUserOpenedStaffSessions = () => {
  return async (dispatch, store) => {
    const userId = JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).id;
    const url = `switchStaff/getSessions?createdBy=${userId}&status=ACTIVE`;
    await api(url, {}, "get")
      .then((res) => {
        dispatch(setSessionsForToday(res?.data?.data));
        let currentStaffActiveSession = null;
        let currentStaffSessionsForToday = [];
        if (res && res.data && res.data.data) {
          res.data.data.forEach((session) => {
            if (session && session.createdBy?.id == userId) {
              currentStaffSessionsForToday.push(session);
              if (session.status == "ACTIVE") {
                if (currentStaffActiveSession) {
                  toastr.error(
                    "Staff Has More than one active session at the same time!"
                  );
                  return;
                }
                currentStaffActiveSession = session;
              }
            }
          });
        }
        dispatch(setCurrentStaffSessionsForToday(currentStaffSessionsForToday));
        dispatch(setCurrentStaffActiveSession(currentStaffActiveSession));
      })
      .catch((err) => {
        toastr.error(err.message || "Error While Getting Staff Sessions!");
      });
  };
};

//get needs to be verified sessions
export const getStaffSessionsToVerify = () => {
  return async (dispatch, store) => {
    const userId = JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).id;
    const url = `switchStaff/getSessions?assignedStaffToConfirm=${userId ? userId : ""}&status=CLOSED`;
    await api(url, {}, "get")
      .then((res) => {
        dispatch(setCurrentStaffSessionsToVerify(res?.data?.data));
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Getting Staff Sessions To Verify!"
        );
      });
  };
};

export const saveGymSettings = ({
  settings,
}) => {
  return async (dispatch, store) => {
    const body = {
      settings
    };
    const url = `gym/settings`;
    await api(url, body, "patch")
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Settings Saved Successfully!");
          console.log({data:store().gym.gym})
          dispatch(setGymData({...store().gym.gym,settings:res?.data?.data?.settings}));
        } else {
          toastr.error(
            typeof res?.data?.error == "string"
              ? res.data.error
              : "Error While Saving Settings!"
          );
        }
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Saving Settings!"
        );
      });
  };
};

export const createFollowupProgram = ({ data }) => {
  if (skipVoiceCreate(data)) return () => {};
  return async (dispatch, store) => {
    const body = {
      ...data
    };
    const url = `followupProgram`;
    await api(url, body, "post")
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Followup program Created Successfully!");
          dispatch(addFollowupProgramModal(false));
          history.push("/gym-panel/followup-programs");
        } else {
          toastr.error(
            typeof res?.data?.error == "string"
              ? res.data.error
              : "Error While Creating Followup Program!"
          );
        }

      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Creating Followup Program!"
        );
      });
  };
};

export const getFollowupPrograms = ({ page = 1, limit = 10, search }) => {
  return async (dispatch, store) => {
    
    const url = `followupProgram?page=${page}&limit=${limit}&search=${search ? search.trim() : ""}`;
    await api(url, {}, "get")
      .then((res) => {
        dispatch(setFollowupProgramsData(res?.data?.data));
        dispatch(setFollowupProgramCount(res?.data?.totalCount));
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Getting Followup Programs!"
        );
      });
  };
};

export const getFollowupProgramById = ({ id }) => {
  return async (dispatch, store) => {
    
    const url = `followupProgram/${id}`;
    await api(url, {}, "get")
      .then((res) => {
        dispatch(setFollowupProgramData(res?.data?.data));
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Getting Followup Program!"
        );
      });
  };
};

export const updateFollowupProgram = ({ data, id }) => {
  return async (dispatch, store) => {
    const body = {
      ...data
    };
    const url = `followupProgram/${id}`;
    await api(url, body, "patch")
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Followup program Updated Successfully!");
          history.push("/gym-panel/followup-programs");
        } else {
          toastr.error(
            typeof res?.data?.error == "string"
              ? res.data.error
              : "Error While Updating Followup Program!"
          );
        }

      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Updating Followup Program!"
        );
      });
  };
};

export const deleteFollowupProgram = ({ id }) => {
  return async (dispatch, store) => {
    
    const url = `followupProgram/${id}`;
    await api(url, {}, "delete")
      .then((res) => {
        history.push("/gym-panel/followup-programs");
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Deleting Followup Program!"
        );
      });
  };
};

export const getFirstInstructorFromRotationList = () => {
  return async (dispatch, store) => {
    const url = `followupProgram/getFirstInstructorFromRotationList`;
    try {
      let res = await api(url, {}, "get");
      if (res && res.status !== 200) {
        toastr.error("Error while getting first instructor from rotation list!");
      } else {
        const instructor = res?.data?.data;
        return instructor;
      }
    } catch (err) {
      toastr.error(err.message || "Error while getting first instructor from rotation list!");
    }
  };
};

// invoice providers
export const getInvoiceProviderFileds = (provider) => async (dispatch) => {
  try {
    const url = `setting/invoiceProviderFields/${provider}`;
    const res = await api(url, {}, "get");

    if (res.status === 200) {
      dispatch(setPaymentGatewaysFields(res.data.data));
    } else {
      toastr.error(res.message)
    }
  } catch (err) { }
};

export const getInvoiceProvidersUsed = () => async (dispatch) => {
  try {
    const url = `setting/invoice-provider-used`;
    await api(url, {}, "get")
      .then((res) => {
        dispatch(setPaymentGatewaysUsed(res?.data?.data));
      })
      .catch((err) => {
        console.log({ err })
        toastr.error(
          err.message || "Error While Getting used providers!"
        );
      });

  } catch (err) { }
};

export const setInvoiceProviderValues = (key, value, enabled) => async (
  dispatch
) => {
  try {
    const url = "setting/invoice-credentials";
    const data = {
      key: key,
      value: value,
      enabled: enabled,
    };
    await api(url, data, "post").then((res) => {
      if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
        toastr.error(res?.response?.data?.message || "Something went wrong!");
        return;
      }
      if (res.status === 400) {
        toastr.error(res?.message || "some error occured");
      } else {
        dispatch(setSaveGatewayValueFields(res?.data?.data));
        toastr.success(res?.data?.message);
      }
    });

  } catch (err) {
    toastr.error("something went wrong")
  }
};
export const getInvoiceProviderCredentials = (provider) => async (
  dispatch
) => {
  try {
    const url = `setting/invoice-credentials/${provider}`;
    const res = await api(url, {}, "get");

    if (res.status === 200) {
      dispatch(setPaymentGatewayFieldSValue(res.data.data));
    }
  } catch (err) { }
};

// Invoice template endpoints intentionally return their values to the caller.
// The layout is provider-independent JSON so the same designer can support
// additional invoice providers later without a frontend schema change.
export const getInvoiceTemplate = (provider) => async () => {
  const url = `setting/invoice-template/${provider}`;
  const res = await api(url, {}, "get");
  return res?.data?.data || null;
};

export const saveInvoiceTemplate = (provider, template) => async () => {
  const url = "setting/invoice-template";
  const res = await api(url, { provider, ...template }, "post");
  const responseStatus = res?.status || res?.response?.status;

  if (!res || responseStatus >= 400) {
    throw new Error(res?.response?.data?.message || res?.data?.message || res?.message || "Could not save invoice template");
  }

  toastr.success(res?.data?.message || "Invoice template saved successfully");
  return res?.data?.data || template;
};
export const getInvoicesByProvider = (
  page,
  limit,
  filters
) => {
  return async (dispatch, store) => {
      let cleanedFilters = {};
      if(filters){
              Object.entries(filters).forEach(([key, value]) => {
        if (
          value !== undefined &&
          value !== null &&
          !(typeof value === "string" && value.trim() === "") &&
          !(Array.isArray(value) && value.length === 0)
        ) {
          cleanedFilters[key] = value;
        }
      });
      }


      // Step 2: Build query string
      let params = {
        filters: cleanedFilters,
      };

      const queryString = Object.keys(params)
        .map((key) => {
          const value = params[key];
          if (
            value !== undefined &&
            value !== null &&
            !(typeof value === "string" && value.trim() === "") &&
            !(typeof value === "object" && Object.keys(value).length === 0)
          ) {
            return `${encodeURIComponent(key)}=${encodeURIComponent(
              JSON.stringify(value)
            )}`;
          }
          return null;
        })
        .filter(Boolean)
        .join("&");
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Operation canceled due to new request.");
    }

    // Create a new CancelToken source
    cancelTokenSource = generateCancelTokenSource();
    let url = `invoicesByProvider?page=${page}&limit=${limit}&${queryString}`;

    await api(url, {}, "get",null,cancelTokenSource.token)
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setInvoiceData(res.data.data));
          dispatch(setInvoiceCount(res.data.totalCount));
        }
      })
      .catch((err) => { });
  };
};
export const getOtherInvoices = (
  page,
  limit,
  filters={}
) => {
  return async (dispatch, store) => {
      let cleanedFilters = {};
      Object.entries(filters).forEach(([key, value]) => {
        if (
          value !== undefined &&
          value !== null &&
          !(typeof value === "string" && value.trim() === "") &&
          !(Array.isArray(value) && value.length === 0)
        ) {
          cleanedFilters[key] = value;
        }
      });

      // Step 2: Build query string
      let params = {
        filters: cleanedFilters,
      };

      const queryString = Object.keys(params)
        .map((key) => {
          const value = params[key];
          if (
            value !== undefined &&
            value !== null &&
            !(typeof value === "string" && value.trim() === "") &&
            !(typeof value === "object" && Object.keys(value).length === 0)
          ) {
            return `${encodeURIComponent(key)}=${encodeURIComponent(
              JSON.stringify(value)
            )}`;
          }
          return null;
        })
        .filter(Boolean)
        .join("&");
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Operation canceled due to new request.");
    }

    // Create a new CancelToken source
    cancelTokenSource = generateCancelTokenSource();
    let url = `transaction/others?page=${page}&limit=${limit}&${queryString}`;

    await api(url, {}, "get",null,cancelTokenSource.token)
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          dispatch(setInvoiceData(res.data.data));
          dispatch(setInvoiceCount(res.data.totalCount));
        }
      })
      .catch((err) => { });
  };
};
export const downloadInvoiceByProvider = (
 refId,invoiceType="invoices"
) => {
  return async (dispatch, store) => {
    let url = `invoicesByProvider/downlaod/${refId}?invoiceType=${invoiceType}`;
   return await api(url, {}, "get")
      .then((res) => {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error(res?.data?.message||res?.response?.data?.message || "Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error(res?.data?.message||res?.response?.data?.message || "Something went wrong!");
          return
        } else {
          return res.data.data
        }
      })
      .catch((err) => { });
  };
};

export const createBodyMeasurementsRecord = ({ data }) => {
  return async (dispatch, store) => {
    const body = {
      ...data
    };
    const url = `bodyMeasurements`;
    await api(url, body, "post")
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Body Measurements Record Created Successfully!");
          dispatch(addBodyMeasurementsModalAction(false));
          dispatch(getMemberBodyMeasurements({ id: data.member }));
        } else {
          toastr.error(
            typeof res?.data?.error == "string"
              ? res.data.error
              : "Error While Creating Body Measurements Record!"
          );
        }

      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Creating Body Measurements Record!"
        );
      });
  };
};

export const getMemberBodyMeasurements = ({ id }) => {
  return async (dispatch, store) => {
    
    const url = `bodyMeasurements/member/${id}`;
    await api(url, {}, "get")
      .then((res) => {
        dispatch(setMemberBodyMeasurements(res?.data?.data));
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Getting Member Body Measurements!"
        );
      });
  };
};

export const updateBodyMeasurementsRecord = ({ data, id }) => {
  return async (dispatch, store) => {
    const body = {
      ...data
    };
    const url = `bodyMeasurements/${id}`;
    await api(url, body, "patch")
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Body Measurements Record Updated Successfully!");
        } else {
          toastr.error(
            typeof res?.data?.error == "string"
              ? res.data.error
              : "Error While Updating Body Measurements Record!"
          );
        }

      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Updating Body Measurements Record!"
        );
      });
  };
};

export const deleteBodyMeasurementsRecord = ({ id }) => {
  return async (dispatch, store) => {
    
    const url = `bodyMeasurements/${id}`;
    await api(url, {}, "delete")
      .then((res) => {
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Deleting Body Measurements Record!"
        );
      });
  };
};

export const createInBodyTestRecord = ({ data }) => {
  return async (dispatch, store) => {
    const body = {
      ...data
    };
    const url = `inBodyTest`;
    await api(url, body, "post")
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("In-Body Test Record Created Successfully!");
          dispatch(addInBodyTestModalAction(false));
          dispatch(getMemberInBodyTests({ id: data.member }));
        } else {
          toastr.error(
            typeof res?.data?.error == "string"
              ? res.data.error
              : "Error While Creating In-Body Test Record!"
          );
        }

      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Creating In-Body Test Record!"
        );
      });
  };
};

export const getMemberInBodyTests = ({ id }) => {
  return async (dispatch, store) => {
    
    const url = `inBodyTest/member/${id}`;
    await api(url, {}, "get")
      .then((res) => {
        dispatch(setMemberInBodyTests(res?.data?.data));
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Getting Member In-Body Test!"
        );
      });
  };
};

export const updateInBodyTestRecord = ({ data, id }) => {
  return async (dispatch, store) => {
    const body = {
      ...data
    };
    const url = `inBodyTest/${id}`;
    await api(url, body, "patch")
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("In-Body Test Record Updated Successfully!");
        } else {
          toastr.error(
            typeof res?.data?.error == "string"
              ? res.data.error
              : "Error While Updating In-Body Test Record!"
          );
        }

      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Updating In-Body Test Record!"
        );
      });
  };
};

export const deleteInBodyTestRecord = ({ id }) => {
  return async (dispatch, store) => {
    
    const url = `inBodyTest/${id}`;
    await api(url, {}, "delete")
      .then((res) => {
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error While Deleting In-Body Test Record!"
        );
      });
  };
};

//upload video to storage
export const uploadVideo = (videoFile) => {
  return async (dispatch, store) => {
    const formData = new FormData();
    formData.append('video', videoFile);
    
    const url = `video/upload`;
    const body = formData;
    try {
      const res = await api(url, body, "post");
      if (res.data.status === 200) {
        return res.data.data; //return video metadata for further use        
      } else {
        toastr.error(
          typeof res?.data?.error === "string"
            ? res.data.error
            : "Error while uploading video!!"
        );
      }
      
    } catch (err) {
      toastr.error(
        err.message || "Error while uploading video!!"
      );
    }
  };
};

export const deleteVideoFromStorage = ({ url, thumbnailUrl }) => {
  return async (dispatch, store) => {
    const body = {
      url,
      thumbnailUrl
    };
    const apiUrl = `video/delete`;
    
    await api(apiUrl, body, "delete")
      .then((res) => {
        if (res.data.status === 200) {
        } else {
          toastr.error(
            typeof res?.data?.error === "string"
              ? res.data.error
              : "Error while deleting video from storage!"
          );
        }
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error while deleting video from storage!"
        );
      });
  };
};

export const createVideoRecord = ({ data }) => {
  return async (dispatch, store) => {
    const body = {
      ...data
    };
    const url = `video`;
    
    await api(url, body, "post")
      .then((res) => {
        if (res.data.status === 200) {
          toastr.success("Video record created successfully!");
          dispatch(getVideoLibrary());
        } else {
          toastr.error(
            typeof res?.data?.error === "string"
              ? res.data.error
              : "Error while creating video record!"
          );
        }
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error while creating video record!"
        );
      });
  };
};

export const getVideoLibrary = ({ title, category, page = 1, limit = 10 } = {}) => {
  return async (dispatch, store) => {
    const params = new URLSearchParams();
    
    if (title) params.append('title', title);
    if (category) params.append('category', category);
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    
    const url = `video?${params.toString()}`;
    
    await api(url, {}, "get")
      .then((res) => {
        if (res.data.status === 200) {
          dispatch(setVideosLibraryData(res.data.data.videos));
          dispatch(setPagination(res.data.data.pagination));
        } else {
          toastr.error("Error while fetching video library!");
        }
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error while fetching video library!"
        );
      });
  };
};
export const getVideosByIds = (videoIds) => {
  return async (dispatch) => {
    try {
      dispatch(setSelectedInstructionVideos([])); //reset
      const url = 'video/getByIds';
      const response = await api(url, { ids: videoIds }, "post");
      
      if (response.data.status === 200) {
        dispatch(setSelectedInstructionVideos(response.data.data.videos));
      } else {
        toastr.error("Error while fetching videos!");
      }
    } catch (error) {
      console.error('Error fetching videos by IDs:', error);
      toastr.error(error.message || "Error while fetching videos!");
    }
  };
};

export const getVideoById = ({ id }) => {
  return async (dispatch, store) => {
    const url = `video/${id}`;
    
    await api(url, {}, "get")
      .then((res) => {
        if (res.data.status === 200) {
          dispatch(setSelectedVideo(res.data.data));
        } else {
          toastr.error("Video not found!");
        }
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error while fetching video!"
        );
      });
  };
};

export const updateVideoRecord = ({ data, id }) => {
  return async (dispatch, store) => {
    const body = {
      ...data
    };
    const url = `video/${id}`;
    
    await api(url, body, "patch")
      .then((res) => {
        if (res.data.status === 200) {
          toastr.success("Video record updated successfully!");
          dispatch(getVideoLibrary());
        } else {
          toastr.error(
            typeof res?.data?.error === "string"
              ? res.data.error
              : "Error while updating video record!"
          );
        }
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error while updating video record!"
        );
      });
  };
};

export const updateVideoWithFileChange = ({ id, videoFile, videoData, oldUrl, oldThumbnailUrl }) => {
  return async (dispatch, store) => {
    try {
      const uploadResult = await dispatch(uploadVideo(videoFile));
      
      const completeVideoData = {
        ...videoData,
        url: uploadResult.url,
        thumbnailUrl: uploadResult.thumbnailUrl,
        duration: uploadResult.duration,
        fileSize: uploadResult.fileSize,
        resolution: uploadResult.resolution,
        videoFormat: uploadResult.videoFormat
      };
      
      await dispatch(updateVideoRecord({ id, data: completeVideoData }));
      
      if (oldUrl || oldThumbnailUrl) {
        await dispatch(deleteVideoFromStorage({ 
          url: oldUrl, 
          thumbnailUrl: oldThumbnailUrl 
        }));
      }
      
    } catch (error) {
      toastr.error("Failed to update video!");
      throw error;
    }
  };
};

export const deleteVideoRecord = ({ id }) => {
  return async (dispatch, store) => {
    const url = `video/${id}`;
    
    await api(url, {}, "delete")
      .then((res) => {
        if (res.data.status === 200) {
          toastr.success("Video record deleted successfully!");
          dispatch(getVideoLibrary());
        } else {
          toastr.error(
            typeof res?.data?.error === "string"
              ? res.data.error
              : "Error while deleting video record!"
          );
        }
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error while deleting video record!"
        );
      });
  };
};

export const searchVideos = ({ searchFilters }) => {
  return async (dispatch, store) => {
    dispatch(getVideoLibrary(searchFilters));
  };
};

export const uploadVideoAndCreateRecord = ({ videoFile, videoData }) => {
  return async (dispatch, store) => {
    try {
      const uploadResult = await dispatch(uploadVideo(videoFile));
      
      //create the database record with the upload result
      const completeVideoData = {
        ...videoData,
        url: uploadResult.url,
        thumbnailUrl: uploadResult.thumbnailUrl,
        duration: uploadResult.duration,
        fileSize: uploadResult.fileSize,
        resolution: uploadResult.resolution,
        videoFormat: uploadResult.videoFormat
      };
      
      await dispatch(createVideoRecord({ data: completeVideoData }));
      
    } catch (error) {
      toastr.error("Failed to upload video and create record!");
      throw error;
    }
  };
};

export const deleteVideoCompletely = ({ id, url, thumbnailUrl }) => {
  return async (dispatch, store) => {
    try {
      //first delete from storage
      if (url || thumbnailUrl)
        await dispatch(deleteVideoFromStorage({ url, thumbnailUrl }));
      
      //then delete the database record
      await dispatch(deleteVideoRecord({ id }));
            
    } catch (error) {
      toastr.error("Failed to delete video completely!");
      throw error;
    }
  };
};
export const getAttachmentLibrary = ({ title, category, page = 1, limit = 10 ,tag,description} = {}) => {
  return async (dispatch, store) => {
    const params = new URLSearchParams();
    
    if (title) params.append('title', title);
    if (category) params.append('category', category);
    if (tag) params.append('tag', tag);
    if (description) params.append('description', description);

    params.append('page', page.toString());
    params.append('limit', limit.toString());
    
    const url = `attachment/library?${params.toString()}`;
    
    await api(url, {}, "get")
      .then((res) => {
        if (res.data.status === 200) {
          dispatch(setAttachmentLibraryData(res.data.data.attachments));
          dispatch(setAttachmentPagination(res.data.data.pagination));
        } else {
          toastr.error("Error while fetching attachment library!");
        }
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error while fetching attachment library!"
        );
      });
  };
};
export const createAttachmentRecord = ({ data }) => {
  return async (dispatch, store) => {
    const body = {
      ...data
    };
    const url = `attachment/library`;
    
    await api(url, body, "post")
      .then((res) => {
        if (res.data.status === 200) {
          toastr.success("Attachment record created successfully!");
          dispatch(getAttachmentLibrary({}));
        } else {
          toastr.error(
            typeof res?.data?.error === "string"
              ? res.data.error
              : "Error while creating Attachment record!"
          );
        }
      })
      .catch((err) => {
        toastr.error(
          err.message || "Error while creating Attachment record!"
        );
      });
  };
};
export const changeSchedulePublishStatus = (payload) => {
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(`court/slots/publish/status/${payload.court}`, payload, "patch").catch((err) => {});
    if (res.status !== 200) {
      dispatch(setLoading(false));
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("Enter Valid data");
    } else {
      toastr.success("Success:Status Changed");
      dispatch(setLoading(false));
      history.push("/gym-panel/courtslist");
    }
  };
};

export const getMemberFreezeHistory = (payload) => {
  return async (dispatch, store) => {
    // dispatch(setLoading(true));
    let res = await api(
      `memberFreezeHistorty/${payload}`,
       {},
      "get"
    ).catch((err) => {});
    if (res.status !== 200) {
      // dispatch(setLoading(false));
      if (res?.data?.error) toastr.error(res?.data?.error);
      else toastr.error("Something went wrong");
    } else {
      // dispatch(setLoading(false));
      dispatch(setMemberFreezeHistory(res.data.data));
      // dispatch(setMemberFreezeHistorySaleId(payload));
    }
  };
};
export const transferToWareHouse = (payload) => {
  return async (dispatch, store) => {
    // dispatch(setLoading(true));
    let res = await api(
      `super-gym-admin/product/transfer/wareHouse`,
      payload,
      "post"
    ).catch((err) => {});
    if (res.status !== 200) {
      // dispatch(setLoading(false));
      if (res.data.error) toastr.error(res.data.error);
      else toastr.error("Enter Valid data");
    } else {
      toastr.success("Success:Product Transfered Success");


    }
  };
};

export const getPushNotificationLogs = ({limit,page,type,dateFrom,dateTo}) => {
  return async (dispatch, store) => {
    // dispatch(setProductLoading(true))
    let url = `pushNotification/logs?limit=${limit}&page=${page}`;
    if (dateFrom) {
      url += `&startDate=${dateFrom}`;
    }
    if (dateTo) {
      url += `&endDate=${dateTo}`;
    }
    if (type) {
      url += `&type=${type}`;
    }

    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setPushNotificationLogs(res.data.data));
      dispatch(setPushNotificationLogsTotalCount(res.data.totalCount));
    }
    // dispatch(setProductLoading(false))

  };
};
export const getPushNotificationLogsByGroupId = ({limit,page,groupId,status}) => {
  return async (dispatch, store) => {
    // dispatch(setProductLoading(true))
    let url = `pushNotification/logs/${groupId}?limit=${limit}&page=${page}`;
    if (status) {
      url += `&status=${status}`;
    }
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setPushNotificationLogsByGroupId(res.data.data));
      dispatch(setPushNotificationLogsTotalCountByGroupId(res.data.total));
      return res.data
    }
    // dispatch(setProductLoading(false))

  };
};

export const getActiveMedicalRecordTemplate = ({category,subCategory}) => {
  return async (dispatch, store) => {
    // dispatch(setProductLoading(true))
    let url = `active/medicalRecord/template?category=${category}`;
    if(subCategory) url+=`&type=${subCategory}`
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setActiveMedicalRecordTemplate(res.data.data));
    }
  };
};
export const getMedicalTemplates = ({category}) => {
  return async (dispatch, store) => {
    // dispatch(setProductLoading(true))
    let url = `assessment?category=${category}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      if(category=="assessment") dispatch(setAssessmentTemplates(res.data.data));
      else if (category=="treatment")dispatch(setTreatmentTemplates(res.data.data));
    }
  };
};
export const createAssessmentTemplate = (data) => {
  return async (dispatch, store) => {
    // dispatch(setProductLoading(true))
    let url = `assessment`;
    let res = await api(url, data, "post").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(getMedicalTemplates({category:data.category}));
      toastr.success("Assessment Template Added")
    }
  };
};
export const updateAssessmentTemplate = (data,templateId) => {
  return async (dispatch, store) => {
    // dispatch(setProductLoading(true))
    let url = `assessment/${templateId}/update`;
    let res = await api(url, data, "patch").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(getMedicalTemplates({category:data.category}));
      toastr.success("Assessment Template Updated")
    }
  };
};
export const toggleTemplateStatus = ({templateId,category="assessment"}) => {
  return async (dispatch, store) => {
    // dispatch(setProductLoading(true))
    let url = `assessment/${templateId}`;
    let res = await api(url, {}, "patch").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
       dispatch(getMedicalTemplates({category:category}));
    }
  };
};

export const createMemberMedicalRecord = (data,fromBooking) => {
  return async (dispatch, store) => {
    // dispatch(setProductLoading(true))
    let url = `member/medicalRecord`;
    let res = await api(url, data, "post").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      if(fromBooking){
        const startDate=fromBooking?.startDate|| moment(new Date())
              .startOf("day")
              .valueOf()
        const endDate=fromBooking.endDate||   moment(new Date())
              .endOf("day")
              .valueOf()    
        dispatch(
          getCourtsSlotsForBookingPageView({
            startDate,
            endDate,
          })
        );      
      }
      else{
      dispatch(setMemberAssessmentsQuery({
        page: 1,
        limit: store().member?.memberAssessmentsLimit || 10,
      }));
      dispatch(getMemberAssessments({memberId:data.member,category:data?.category,type:data?.type,page:1}));
      dispatch(getMember(data?.member))
      }
      toastr.success("Assessment Added");

    }
  };
};
export const updateMemberMedicalRecord = (data) => {
  return async (dispatch, store) => {
    // dispatch(setProductLoading(true))
    let url = `member/medicalRecord/${data.id}`;
    let res = await api(url, data, "patch").catch((err) => {});
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(getMemberAssessments({memberId:data.member,category:data?.category,type:data?.type}));
      dispatch(getMemberTreatments({ memberId:data.member}));
      dispatch(getMember(data?.member))
      }
      toastr.success("Assessment Updated");
  };
};
let memberAssessmentsRequestSeq = 0;
export const getMemberAssessments = ({ memberId, category, type, page, limit } = {}) => {
  return async (dispatch, store) => {
    const requestSeq = ++memberAssessmentsRequestSeq;
    const memberState = store().member || {};
    const currentPage = Number(page || memberState.memberAssessmentsPage || 1);
    const currentLimit = Number(limit || memberState.memberAssessmentsLimit || 10);
    let url = `member/assessments/${memberId}?category=${category}&type=${type}&page=${currentPage}&limit=${currentLimit}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (requestSeq !== memberAssessmentsRequestSeq) return;
    if (!res) return;
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setMemberAssessments(res.data.data));
      dispatch(setMemberAssessmentsCount(res.data.totalCount || 0));
    }
  };
};
let cancelLeadTokenSource;

export const getLeads = ({
  page,
  limit,
  gymId=JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym,
  search,
  sort = "createdAt desc",
  filterStatus = "",
  filterSource = "",
  isLoading = true,
  assignedToMe

}
  
) => {
  return async (dispatch, store) => {
    if(isLoading) {
      dispatch(setLoading(true));

    }
    // Cancel the previous request before making a new request
    if (cancelLeadTokenSource) {
      cancelLeadTokenSource.cancel("Operation canceled due to new request.");
    }

    // Create a new CancelToken source
    cancelLeadTokenSource = generateCancelTokenSource();

    let url =`leads?page=${page}&limit=${limit}`;
    if (gymId) {
      url += `&gymId=${gymId}`;
    } 
    if (search) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }
    if (sort) {
      url += `&sort=${encodeURIComponent(sort)}`;
    }
    if( filterStatus ) {
      url += `&status=${encodeURIComponent(filterStatus)}`;
    }
    if( filterSource ) {
      url += `&source=${encodeURIComponent(filterSource)}`;
    }
      if(assignedToMe){
      url+=`&assignedToMe=true`
    }    

    try {
      const res = await api(url, {}, "get", null, cancelLeadTokenSource.token);
      if (res) {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("Some error occurred");
        } else {
          dispatch(setLeadsData(res.data.data));
          dispatch(setLeadCount(res.data.totalCount));
        }
      }
    } catch (err) {
      console.error(err);
      if (isCancelAxios(err)) {
        console.log("Request canceled", err.message);
      } else {
        // Handle error
        toastr.error("An error occurred while fetching data");
      }
    } finally {
      dispatch(setLoading(false));
    }
  };
};
export const getLead = ({
id

}
  
) => {
  return async (dispatch, store) => {
    let url =`lead/${id}`;
    try {
      const res = await api(url, {}, "get", null);
      if (res) {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) {
          toastr.error("Some error occurred");
        } else {
          dispatch(setLeadInfo(res.data.data));
        }
      }
    } catch (err) {
      console.error(err);
        // Handle error
        toastr.error("An error occurred while fetching data");
      
    } finally {
    }
  };
};

export const addLead=(payload,assignedToMe)=>{
  if (skipVoiceCreate(payload)) return () => {};
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(`lead`, payload, "post").catch((err) => {});
    if (res.status !== 200) { 
      toastr.error("Error", "Failed to Add lead");
      dispatch(setLoading(false));
    } else {
      toastr.success("Success", "Lead added successfully");
      dispatch(getLeads({page:1,limit:10,assignedToMe}));
      dispatch(setOpenLeadModal(false));
      dispatch(setLoading(false));
      dispatch(setLeadInfo(res.data.data))
      dispatch(setOpenLeadFollowUpModal(true))
    }
  }
}
export const updateLead=(payload,assignedToMe)=>{
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(`lead/${payload.id}`, payload, "patch").catch((err) => {});
    if (res.status !== 200) { 
      toastr.error("Error", "Failed to Add lead");
      dispatch(setLoading(false));
    } else {
      toastr.success("Success", "Lead added successfully");
      dispatch(getLeads({page:1,limit:10,assignedToMe}));
      dispatch(setLoading(false));
      dispatch(setLeadInfo(res.data.data))
      history.push("/gym-panel/leads")
    }
  }
}
export const addLeadFollowUp=(payload)=>{
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(`lead/${payload.leadId}/followup`, payload, "post").catch((err) => {});
    if (res.status !== 200) { 
      toastr.error("Error", "Failed to Add lead followup");
      dispatch(setLoading(false));
    } else {
      toastr.success("Success", "Lead followup added successfully");
      dispatch(getLeadFollowUps({page:1,limit:10,leadId:payload.leadId}));
      dispatch(setOpenLeadFollowUpModal(false));
      dispatch(setLoading(false));
      
    }
  }
}
export const addLeadQuotation=(payload)=>{
  return async (dispatch, store) => {
    dispatch(setLoading(true));
    let res = await api(`lead/${payload.leadId}/quotation`, payload, "post").catch((err) => {});
    if (res.status !== 200) { 
      toastr.error("Error", "Failed to Add lead quotation");
      dispatch(setLoading(false));
    } else {
      toastr.success("Success", "Lead quotation added successfully");
      dispatch(getLeadQuotation({page:1,limit:10,leadId:payload.leadId}));
       dispatch(getLead({id:payload.leadId}))
      dispatch(setOpenQuotationModal(false));
      dispatch(setLoading(false));
      
    }
  }
}
export const getLeadFollowUps = ({ leadId }) => {
  return async (dispatch, store) => {
    let url =`lead/${leadId}/followups`;
    try {
      const res = await api(url, {}, "get", null);
      if (res) {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) { 
          toastr.error("Some error occurred");
        } else {
          dispatch(setLeadFollowUps(res.data.data));
        }
      }   
    } catch (err) {
      console.error(err); 
        // Handle error
        toastr.error("An error occurred while fetching data");  
    } finally {
    }
  };
};
export const getLeadQuotation = ({ leadId }) => {
  return async (dispatch, store) => {
    let url =`lead/${leadId}/quotations`;
    try {
      const res = await api(url, {}, "get", null);
      if (res) {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) { 
          toastr.error("Some error occurred");
        } else {
          let data=res.data?.data
          data=data.map((q) => ({
          ...q,
          packages:
            typeof q.packages === "string" ? JSON.parse(q.packages) : q.packages,
          followups:
          typeof q.followups === "string" ? JSON.parse(q.followups) : q.followups,
        }))
          dispatch(setLeadQuotations(data));
        }
      }   
    } catch (err) {
      console.error(err); 
        // Handle error
        toastr.error("An error occurred while fetching data");  
    } finally {
    }
  };
};
export const updateLeadFollowUp=(payload,params)=>{
  return async (dispatch, store) => {
    dispatch(setLoading(true));   
    let res = await api(`lead/followup/${payload.id}`, payload, "patch").catch((err) => {});
    if (res.status !== 200) {
      toastr.error("Error", "Failed to Update lead followup");
      dispatch(setLoading(false));
    } else {
      toastr.success("Success", "Lead followup updated successfully");  
      dispatch(getLeadFollowUps({ leadId: payload.leadId }));
      dispatch(setLoading(false));
      if(payload?.fromLeadTasks) return dispatch(getUserFollowUps(params))
      dispatch(getLead({id:payload.leadId}))
      
    
    }
  }
};
export const updateLeadQuotation=(payload)=>{
  return async (dispatch, store) => {
    dispatch(setLoading(true));   
    let res = await api(`lead/quotation/${payload.id}`, payload, "patch").catch((err) => {});
    if (res.status !== 200) {
      toastr.error("Error", "Failed to Update lead quotation");
      dispatch(setLoading(false));
    } else {
      toastr.success("Success", "Lead quotation updated successfully");  
      dispatch(getLeadQuotation({ leadId: payload.leadId }));
      dispatch(setLoading(false));
    
    }
  }
};
export const convertOfferToSale=(payload)=>{
  return async (dispatch, store) => {
    dispatch(setLoading(true));   
    let res = await api(`lead/quotation/${payload.id}/converToSale`, payload, "post").catch((err) => {});
    if (res.status !== 200) {
      console.log({res})
      toastr.error("Error", res?.data?.message||"Failed to Update lead quotation");
      dispatch(setLoading(false));
    } else {
      toastr.success("Success", "Lead quotation Converted successfully");  
      dispatch(getLeadQuotation({ leadId: payload.leadId }));
      dispatch(setLoading(false));
      dispatch(setOpenConverToSaleModal(false))
      history.push("/gym-panel/memberslist")
    
    }
  }
};
export const getLeadStatics=()=>{
  return async (dispatch, store) => {
    dispatch(setLoading(true));   
    let res = await api(`dashboard/lead`, {}, "get").catch((err) => {});
    if (res.status !== 200) {
      console.log({res})
      toastr.error("Error", res?.data?.message||"Failed to Update lead quotation");
     
    } else {
      dispatch(setLeadStatics({ 
        kpis: res.data.data.kpis,
        funnel: res.data.data.funnel,
        leadSources: res.data.data.leadSources,
        packageInterest: res.data.data.packageInterest,
        staffPerformance:res.data.data.staffPerformance}));
    
    }
     dispatch(setLoading(false));
  }
};
export const getUserFollowUps = ({startDate,endDate,userId,page=1,limit=10,dueEnd,dueStart,status,view="today",sort}) => {
  return async (dispatch, store) => {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);
    // Optional dynamic fields
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if(dueEnd)params.append("dueEnd",dueEnd)
    if(dueStart)params.append("dueStart",dueStart)
    if(userId)params.append("userId",userId)
    if(status)params.append("status",status)
    if(view)params.append("view",view)
    if(sort)params.append("sort",sort)
      let url =`followups/user?${params.toString()}`;
    try {
      const res = await api(url, {}, "get", null);
      if (res) {
        if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
          toastr.error("Something went wrong!");
          return;
        }
        if (res.status === 400) { 
          toastr.error("Some error occurred");
        } else {
          dispatch(setUserFollowUps(res.data.data));
          dispatch(setLeadCount(res.data.totalCount))
        }
      }   
    } catch (err) {
      console.error(err); 
        // Handle error
        toastr.error("An error occurred while fetching data");  
    } finally {
    }
  };
};
let memberTreatmentsRequestSeq = 0;
export const getMemberTreatments = ({ memberId, page, limit } = {}) => {
  return async (dispatch, store) => {
    const requestSeq = ++memberTreatmentsRequestSeq;
    const memberState = store().member || {};
    const currentPage = Number(page || memberState.memberTreatmentsPage || 1);
    const currentLimit = Number(limit || memberState.memberTreatmentsLimit || 10);
    const params = new URLSearchParams();
    params.append("page", currentPage);
    params.append("limit", currentLimit);
    let url = `member/treatments/${memberId}?${params.toString()}`;
    let res = await api(url, {}, "get").catch((err) => {});
    if (requestSeq !== memberTreatmentsRequestSeq) return;
    if (!res) return;
    if (String(res.status).startsWith('5') || String(res?.response?.status).startsWith('5')) {
      toastr.error("Something went wrong!");
      return;
    }
    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setMemberTreatments(res.data.data));
      dispatch(setMemberTreatmentsCount(res.data.totalCount || 0));
    }
  };
};
